module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/common/address.ts":
/*!*******************************!*\
  !*** ./src/common/address.ts ***!
  \*******************************/
/*! exports provided: Address */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Address", function() { return Address; });
/* harmony import */ var bs58__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! bs58 */ "bs58");
/* harmony import */ var bs58__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bs58__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _vm_utils_reader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../vm/utils/reader */ "./src/vm/utils/reader.ts");
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./error */ "./src/common/error.ts");
/* harmony import */ var _program__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./program */ "./src/common/program.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./utils */ "./src/common/utils.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */





const ADDR_LEN = 20;
class Address {
    static parseFromBytes(b) {
        const r = new _vm_utils_reader__WEBPACK_IMPORTED_MODULE_1__["Reader"](b);
        const a = new Address();
        a.deserialize(r);
        return a;
    }
    static parseFromVmCode(code) {
        return new Address(Object(_utils__WEBPACK_IMPORTED_MODULE_4__["md160"])(Object(_utils__WEBPACK_IMPORTED_MODULE_4__["sha256"])(code)));
    }
    static fromPubKey(key) {
        const prog = Object(_program__WEBPACK_IMPORTED_MODULE_3__["programFromPubKey"])(key);
        return Address.parseFromVmCode(prog);
    }
    static fromBase58(encoded) {
        const decoded = bs58__WEBPACK_IMPORTED_MODULE_0__["decode"](encoded);
        const hexDecoded = new Buffer(decoded).slice(1, 20 + 1);
        const address = new Address(hexDecoded);
        if (encoded !== address.toBase58()) {
            throw new Error('[Address.fromBase58] decode encoded verify failed');
        }
        return address;
    }
    constructor(value = '0000000000000000000000000000000000000000') {
        if (typeof value === 'string') {
            this.value = new Buffer(value, 'hex');
        } else {
            this.value = value;
        }
    }
    equals(other) {
        return this.value.equals(other.value);
    }
    serialize(w) {
        w.writeBytes(this.value);
    }
    deserialize(r) {
        try {
            this.value = r.readBytes(ADDR_LEN);
        } catch (e) {
            throw new _error__WEBPACK_IMPORTED_MODULE_2__["TracedError"]('deserialize Uint256 error', e);
        }
    }
    toArray() {
        const buffer = new Buffer(this.value.length);
        this.value.copy(buffer);
        return buffer;
    }
    toHexString() {
        return Object(_utils__WEBPACK_IMPORTED_MODULE_4__["reverseBuffer"])(this.toArray()).toString('hex');
    }
    toBase58() {
        const data = Buffer.concat([new Buffer('17', 'hex'), this.value]);
        const hash = Object(_utils__WEBPACK_IMPORTED_MODULE_4__["sha256"])(data);
        const hash2 = Object(_utils__WEBPACK_IMPORTED_MODULE_4__["sha256"])(hash);
        const checksum = hash2.slice(0, 4);
        const datas = Buffer.concat([data, checksum]);
        return bs58__WEBPACK_IMPORTED_MODULE_0__["encode"](datas);
    }
}

/***/ }),

/***/ "./src/common/constants.ts":
/*!*********************************!*\
  !*** ./src/common/constants.ts ***!
  \*********************************/
/*! exports provided: ONT_NAME, ONT_SYMBOL, ONT_DECIMALS, ONT_TOTAL_SUPPLY, ONG_NAME, ONG_SYMBOL, ONG_DECIMALS, ONG_TOTAL_SUPPLY, GENESIS_BLOCK_TIMESTAMP, UNBOUND_TIME_INTERVAL, UNBOUND_GENERATION_AMOUNT, UNBOUND_DEADLINE */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ONT_NAME", function() { return ONT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ONT_SYMBOL", function() { return ONT_SYMBOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ONT_DECIMALS", function() { return ONT_DECIMALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ONT_TOTAL_SUPPLY", function() { return ONT_TOTAL_SUPPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ONG_NAME", function() { return ONG_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ONG_SYMBOL", function() { return ONG_SYMBOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ONG_DECIMALS", function() { return ONG_DECIMALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ONG_TOTAL_SUPPLY", function() { return ONG_TOTAL_SUPPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GENESIS_BLOCK_TIMESTAMP", function() { return GENESIS_BLOCK_TIMESTAMP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNBOUND_TIME_INTERVAL", function() { return UNBOUND_TIME_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNBOUND_GENERATION_AMOUNT", function() { return UNBOUND_GENERATION_AMOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNBOUND_DEADLINE", function() { return UNBOUND_DEADLINE; });
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! long */ "long");
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(long__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./error */ "./src/common/error.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */


const ONT_NAME = 'ONT Token';
const ONT_SYMBOL = 'ONT';
const ONT_DECIMALS = 1;
const ONT_TOTAL_SUPPLY = long__WEBPACK_IMPORTED_MODULE_0__["fromString"]('1000000000');
const ONG_NAME = 'ONG Token';
const ONG_SYMBOL = 'ONG';
const ONG_DECIMALS = 9;
const ONG_TOTAL_SUPPLY = long__WEBPACK_IMPORTED_MODULE_0__["fromString"]('1000000000000000000');
const GENESIS_BLOCK_TIMESTAMP = new Date(2018, 6, 30, 0, 0, 0, 0).getTime();
// ont/ong unbound model constants
const UNBOUND_TIME_INTERVAL = 31536000;
const UNBOUND_GENERATION_AMOUNT = [5, 4, 3, 3, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
const UNBOUND_DEADLINE = (() => {
    let count = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](0);
    for (const m of UNBOUND_GENERATION_AMOUNT) {
        count = count.add(m);
    }
    count = count.mul(long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](UNBOUND_TIME_INTERVAL));
    const numInterval = UNBOUND_GENERATION_AMOUNT.length;
    if (UNBOUND_GENERATION_AMOUNT[numInterval - 1] !== 1 || !(count.subtract(long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](UNBOUND_TIME_INTERVAL)).lessThan(ONT_TOTAL_SUPPLY) && ONT_TOTAL_SUPPLY.lessThanOrEqual(count))) {
        throw new _error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('incompatible constants setting');
    }
    return UNBOUND_TIME_INTERVAL * numInterval - count.subtract(ONT_TOTAL_SUPPLY).toNumber();
})();

/***/ }),

/***/ "./src/common/error.ts":
/*!*****************************!*\
  !*** ./src/common/error.ts ***!
  \*****************************/
/*! exports provided: TracedError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TracedError", function() { return TracedError; });
class TracedError extends Error {
    constructor(msg, cause) {
        if (msg instanceof Error) {
            cause = msg;
            msg = undefined;
        }
        super(msg);
        this.cause = cause;
        const oldStackTrace = Error.prepareStackTrace;
        try {
            Error.prepareStackTrace = (err, structuredStackTrace) => {
                const current = oldStackTrace !== undefined ? oldStackTrace(err, structuredStackTrace) : '';
                if (this.cause !== undefined) {
                    return current + this.cause.stack;
                }
                return current;
            };
            if (Error.captureStackTrace !== undefined) {
                Error.captureStackTrace(this, TracedError);
            }
            // tslint:disable-next-line:no-unused-expression
            this.stack; // Invoke the getter for `stack`.
        } finally {
            Error.prepareStackTrace = oldStackTrace;
        }
    }
    toString() {
        let text = this.message + '\n';
        if (this.cause !== undefined) {
            text += this.cause.toString();
        }
        return text;
    }
}

/***/ }),

/***/ "./src/common/merkleTree.ts":
/*!**********************************!*\
  !*** ./src/common/merkleTree.ts ***!
  \**********************************/
/*! exports provided: computeMerkleRoot */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeMerkleRoot", function() { return computeMerkleRoot; });
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! crypto */ "crypto");
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(crypto__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _uint256__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./uint256 */ "./src/common/uint256.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */


function computeMerkleRoot(hashes) {
    if (hashes.length === 0) {
        return new _uint256__WEBPACK_IMPORTED_MODULE_1__["Uint256"]();
    }
    let temp;
    while (hashes.length !== 1) {
        const n = hashes.length / 2;
        let sha;
        for (let i = 0; i < n; i++) {
            sha = Object(crypto__WEBPACK_IMPORTED_MODULE_0__["createHash"])('sha256');
            sha.update(hashes[2 * i].toArray());
            sha.update(hashes[2 * i + 1].toArray());
            temp = _uint256__WEBPACK_IMPORTED_MODULE_1__["Uint256"].parseFromBytes(sha.digest());
            sha = Object(crypto__WEBPACK_IMPORTED_MODULE_0__["createHash"])('sha256');
            sha.update(temp.toArray());
            hashes[i] = _uint256__WEBPACK_IMPORTED_MODULE_1__["Uint256"].parseFromBytes(sha.digest());
        }
        if (hashes.length === 2 * n + 1) {
            sha = Object(crypto__WEBPACK_IMPORTED_MODULE_0__["createHash"])('sha256');
            sha.update(hashes[2 * n].toArray());
            sha.update(hashes[2 * n].toArray());
            temp = _uint256__WEBPACK_IMPORTED_MODULE_1__["Uint256"].parseFromBytes(sha.digest());
            sha = Object(crypto__WEBPACK_IMPORTED_MODULE_0__["createHash"])('sha256');
            sha.update(temp.toArray());
            hashes[n] = _uint256__WEBPACK_IMPORTED_MODULE_1__["Uint256"].parseFromBytes(sha.digest());
            hashes = hashes.slice(0, n + 1);
        } else {
            hashes = hashes.slice(0, n);
        }
    }
    return hashes[0];
}

/***/ }),

/***/ "./src/common/program.ts":
/*!*******************************!*\
  !*** ./src/common/program.ts ***!
  \*******************************/
/*! exports provided: ProgramBuilder, programFromPubKey, programFromParams */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProgramBuilder", function() { return ProgramBuilder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "programFromPubKey", function() { return programFromPubKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "programFromParams", function() { return programFromParams; });
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! big-integer */ "big-integer");
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(big_integer__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _vm_opCode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../vm/opCode */ "./src/vm/opCode.ts");
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../vm/utils/writer */ "./src/vm/utils/writer.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils */ "./src/common/utils.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */




class ProgramBuilder {
    constructor() {
        this.w = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_2__["Writer"]();
    }
    pushPubKey(key) {
        this.pushBytes(key.serialize());
    }
    writeOpCode(opCode) {
        this.w.writeUint8(opCode);
    }
    writeByte(val) {
        this.w.writeUint8(val);
    }
    writeBytes(b) {
        this.w.writeBytes(b);
    }
    writeVarUInt(val) {
        this.w.writeVarUint(val);
    }
    pushBytes(data) {
        // pushing empty buffer should not do any damage
        // if (data.length === 0) {
        //   throw new Error('push data error: data is nil');
        // }
        if (data.length <= _vm_opCode__WEBPACK_IMPORTED_MODULE_1__["PUSHBYTES75"] + 1 - _vm_opCode__WEBPACK_IMPORTED_MODULE_1__["PUSHBYTES1"]) {
            this.w.writeUint8(data.length + _vm_opCode__WEBPACK_IMPORTED_MODULE_1__["PUSHBYTES1"] - 1);
        } else if (data.length < 0x100) {
            this.w.writeUint8(_vm_opCode__WEBPACK_IMPORTED_MODULE_1__["PUSHDATA1"]);
            this.w.writeUint8(data.length);
        } else if (data.length < 0x10000) {
            this.w.writeUint8(_vm_opCode__WEBPACK_IMPORTED_MODULE_1__["PUSHDATA2"]);
            this.w.writeUint16(data.length);
        } else {
            this.w.writeUint8(_vm_opCode__WEBPACK_IMPORTED_MODULE_1__["PUSHDATA4"]);
            this.w.writeUint32(data.length);
        }
        this.w.writeBytes(data);
    }
    pushNum(num) {
        if (num === -1) {
            this.writeOpCode(_vm_opCode__WEBPACK_IMPORTED_MODULE_1__["PUSHM1"]);
        } else if (num === 0) {
            this.writeOpCode(_vm_opCode__WEBPACK_IMPORTED_MODULE_1__["PUSH0"]);
        } else if (num > 0 && num < 16) {
            this.writeOpCode(num - 1 + _vm_opCode__WEBPACK_IMPORTED_MODULE_1__["PUSH1"]);
        } else {
            this.pushBytes(Object(_utils__WEBPACK_IMPORTED_MODULE_3__["bigIntToBytes"])(big_integer__WEBPACK_IMPORTED_MODULE_0__(num)));
        }
    }
    pushBool(param) {
        if (param) {
            this.writeOpCode(_vm_opCode__WEBPACK_IMPORTED_MODULE_1__["PUSHT"]);
        } else {
            this.writeOpCode(_vm_opCode__WEBPACK_IMPORTED_MODULE_1__["PUSHF"]);
        }
    }
    getProgram() {
        return this.w.getBytes();
    }
}
function programFromPubKey(key) {
    const b = new ProgramBuilder();
    b.pushPubKey(key);
    b.writeOpCode(_vm_opCode__WEBPACK_IMPORTED_MODULE_1__["CHECKSIG"]);
    return b.getProgram();
}
function programFromParams(sigs) {
    const b = new ProgramBuilder();
    for (const s of sigs) {
        b.pushBytes(s);
    }
    return b.getProgram();
}

/***/ }),

/***/ "./src/common/safeMath.ts":
/*!********************************!*\
  !*** ./src/common/safeMath.ts ***!
  \********************************/
/*! exports provided: safeAdd */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "safeAdd", function() { return safeAdd; });
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! long */ "long");
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(long__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./error */ "./src/common/error.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */


function safeAdd(x, y) {
    if (y.gt(long__WEBPACK_IMPORTED_MODULE_0__["MAX_UNSIGNED_VALUE"].subtract(x))) {
        throw new _error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('overflow detected');
    }
    return x.add(y);
}

/***/ }),

/***/ "./src/common/uint256.ts":
/*!*******************************!*\
  !*** ./src/common/uint256.ts ***!
  \*******************************/
/*! exports provided: Uint256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Uint256", function() { return Uint256; });
/* harmony import */ var _vm_utils_reader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../vm/utils/reader */ "./src/vm/utils/reader.ts");
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../vm/utils/writer */ "./src/vm/utils/writer.ts");
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./error */ "./src/common/error.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */



const UINT256_SIZE = 32;
class Uint256 {
    static parseFromBytes(b) {
        const r = new _vm_utils_reader__WEBPACK_IMPORTED_MODULE_0__["Reader"](b);
        const u = new Uint256();
        u.deserialize(r);
        return u;
    }
    constructor(value = new Buffer('')) {
        this.value = value;
    }
    toArray() {
        const bf = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_1__["Writer"]();
        this.serialize(bf);
        return new Buffer(bf.getBytes());
    }
    serialize(w) {
        w.writeBytes(this.value);
    }
    deserialize(r) {
        try {
            this.value = r.readBytes(UINT256_SIZE);
        } catch (e) {
            throw new _error__WEBPACK_IMPORTED_MODULE_2__["TracedError"]('deserialize Uint256 error', e);
        }
    }
}

/***/ }),

/***/ "./src/common/utils.ts":
/*!*****************************!*\
  !*** ./src/common/utils.ts ***!
  \*****************************/
/*! exports provided: bigIntToBytes, bigIntFromBytes, reverseBuffer, sha256, md160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bigIntToBytes", function() { return bigIntToBytes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bigIntFromBytes", function() { return bigIntFromBytes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reverseBuffer", function() { return reverseBuffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sha256", function() { return sha256; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "md160", function() { return md160; });
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! big-integer */ "big-integer");
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(big_integer__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! crypto */ "crypto");
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(crypto__WEBPACK_IMPORTED_MODULE_1__);
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */


// tslint:disable:no-bitwise
function bigIntToBytes(data) {
    let bs = data.toArray(256).value;
    if (data.isZero()) {
        return new Buffer('');
    }
    const b = bs[0];
    if (data.isNegative()) {
        for (let i = 0; i < bs.length; i++) {
            bs[i] = 255 ^ bs[i];
        }
        const temp = big_integer__WEBPACK_IMPORTED_MODULE_0__["fromArray"](bs, 256);
        const temp2 = temp.add(big_integer__WEBPACK_IMPORTED_MODULE_0__["one"]);
        bs = temp2.toArray(256).value;
        bs = bs.reverse();
        if (b >> 7 === 1) {
            bs = bs.concat(255);
        }
    } else {
        bs = bs.reverse();
        if (b >> 7 === 1) {
            bs = bs.concat(0);
        }
    }
    return new Buffer(bs);
}
function bigIntFromBytes(ba) {
    const l = ba.length;
    if (l === 0) {
        return big_integer__WEBPACK_IMPORTED_MODULE_0__["zero"];
    }
    let bytes = Array.from(ba.subarray(0));
    bytes = bytes.reverse();
    if (bytes[0] >> 7 === 1) {
        for (let i = 0; i < bytes.length; i++) {
            bytes[i] = 255 ^ bytes[i];
        }
        const temp = big_integer__WEBPACK_IMPORTED_MODULE_0__["fromArray"](bytes, 256);
        const temp2 = temp.add(big_integer__WEBPACK_IMPORTED_MODULE_0__(1));
        bytes = temp2.toArray(256).value;
        return big_integer__WEBPACK_IMPORTED_MODULE_0__["fromArray"](bytes, 256).negate();
    }
    return big_integer__WEBPACK_IMPORTED_MODULE_0__["fromArray"](bytes, 256);
}
function reverseBuffer(src) {
    const buffer = Buffer.allocUnsafe(src.length);
    for (let i = 0, j = src.length - 1; i <= j; ++i, --j) {
        buffer[i] = src[j];
        buffer[j] = src[i];
    }
    return buffer;
}
function sha256(data) {
    const sh = Object(crypto__WEBPACK_IMPORTED_MODULE_1__["createHash"])('sha256');
    sh.update(data);
    return sh.digest();
}
function md160(data) {
    const sh = Object(crypto__WEBPACK_IMPORTED_MODULE_1__["createHash"])('ripemd160');
    sh.update(data);
    return sh.digest();
}

/***/ }),

/***/ "./src/core/block.ts":
/*!***************************!*\
  !*** ./src/core/block.ts ***!
  \***************************/
/*! exports provided: Block, isBlock */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Block", function() { return Block; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBlock", function() { return isBlock; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/error */ "./src/common/error.ts");
/* harmony import */ var _common_merkleTree__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common/merkleTree */ "./src/common/merkleTree.ts");
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../vm/utils/writer */ "./src/vm/utils/writer.ts");
/* harmony import */ var _header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./header */ "./src/core/header.ts");
/* harmony import */ var _transaction__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./transaction */ "./src/core/transaction.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */





class Block {
    constructor({ header = new _header__WEBPACK_IMPORTED_MODULE_3__["Header"](), transactions = [] }) {
        this.header = header;
        this.transactions = transactions;
    }
    getHeader() {
        return this.header;
    }
    getHash() {
        return this.header.getHash();
    }
    getTransactions() {
        return this.transactions;
    }
    serialize(w) {
        this.header.serialize(w);
        try {
            w.writeUint32(this.transactions.length);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Block item Transactions length serialization failed.', e);
        }
        for (const transaction of this.transactions) {
            transaction.serialize(w);
        }
    }
    deserialize(r) {
        this.header = new _header__WEBPACK_IMPORTED_MODULE_3__["Header"]();
        this.header.deserialize(r);
        const length = r.readUInt32();
        const hashes = [];
        for (let i = 0; i < length; i++) {
            const transaction = new _transaction__WEBPACK_IMPORTED_MODULE_4__["Transaction"]();
            transaction.deserialize(r);
            const txhash = transaction.getHash();
            hashes.push(txhash);
            this.transactions.push(transaction);
        }
        this.header.setTransactionsRoot(Object(_common_merkleTree__WEBPACK_IMPORTED_MODULE_1__["computeMerkleRoot"])(hashes));
    }
    toArray() {
        const bf = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_2__["Writer"]();
        this.serialize(bf);
        return new Buffer(bf.getBytes());
    }
}
function isBlock(item) {
    return item instanceof Block;
}

/***/ }),

/***/ "./src/core/header.ts":
/*!****************************!*\
  !*** ./src/core/header.ts ***!
  \****************************/
/*! exports provided: Header, isHeader */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Header", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isHeader", function() { return isHeader; });
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! big-integer */ "big-integer");
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(big_integer__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! long */ "long");
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(long__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _common_address__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../common/address */ "./src/common/address.ts");
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../common/error */ "./src/common/error.ts");
/* harmony import */ var _common_uint256__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../common/uint256 */ "./src/common/uint256.ts");
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../common/utils */ "./src/common/utils.ts");
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../vm/utils/writer */ "./src/vm/utils/writer.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */







class Header {
    constructor({ version = 0, prevBlockHash = new _common_uint256__WEBPACK_IMPORTED_MODULE_4__["Uint256"](), transactionsRoot = new _common_uint256__WEBPACK_IMPORTED_MODULE_4__["Uint256"](), blockRoot = new _common_uint256__WEBPACK_IMPORTED_MODULE_4__["Uint256"](), timestamp = 0, height = 0, consensusData = big_integer__WEBPACK_IMPORTED_MODULE_0__(0), consensusPayload = new Buffer(''), nextBookkeeper = new _common_address__WEBPACK_IMPORTED_MODULE_2__["Address"](), bookkeepers = [], sigData = [] } = {}) {
        this.version = version;
        this.prevBlockHash = prevBlockHash;
        this.transactionsRoot = transactionsRoot;
        this.blockRoot = blockRoot;
        this.timestamp = timestamp;
        this.height = height;
        this.consensusData = consensusData;
        this.consensusPayload = consensusPayload;
        this.nextBookkeeper = nextBookkeeper;
        this.bookkeepers = bookkeepers;
        this.sigData = sigData;
    }
    getVersion() {
        return this.version;
    }
    getPrevBlockHash() {
        return this.prevBlockHash;
    }
    getTransactionsRoot() {
        return this.transactionsRoot;
    }
    setTransactionsRoot(transactionsRoot) {
        this.transactionsRoot = transactionsRoot;
    }
    getHeight() {
        return this.height;
    }
    getTimestamp() {
        return this.timestamp;
    }
    getConsensusData() {
        return this.consensusData;
    }
    getNextBookkeeper() {
        return this.nextBookkeeper;
    }
    getHash() {
        const w = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_6__["Writer"]();
        this.serializeUnsigned(w);
        return _common_uint256__WEBPACK_IMPORTED_MODULE_4__["Uint256"].parseFromBytes(Object(_common_utils__WEBPACK_IMPORTED_MODULE_5__["sha256"])(Object(_common_utils__WEBPACK_IMPORTED_MODULE_5__["sha256"])(w.getBytes())));
    }
    serialize(w) {
        this.serializeUnsigned(w);
        try {
            w.writeVarUint(this.bookkeepers.length);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_3__["TracedError"]('serialize sig pubkey length failed', e);
        }
        for (const pubKey of this.bookkeepers) {
            w.writeVarBytes(pubKey.serialize());
        }
        try {
            w.writeVarUint(this.sigData.length);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_3__["TracedError"]('serialize sig pubkey length failed', e);
        }
        for (const sig of this.sigData) {
            w.writeVarBytes(sig);
        }
    }
    deserialize(w) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_3__["TracedError"]('Unsupported');
    }
    toArray() {
        const bf = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_6__["Writer"]();
        this.serialize(bf);
        return new Buffer(bf.getBytes());
    }
    serializeUnsigned(w) {
        w.writeUint32(this.version);
        w.writeBytes(this.prevBlockHash.toArray());
        w.writeBytes(this.transactionsRoot.toArray());
        w.writeBytes(this.blockRoot.toArray());
        w.writeUint32(this.timestamp);
        w.writeUint32(this.height);
        w.writeUint64(long__WEBPACK_IMPORTED_MODULE_1__["fromString"](this.consensusData.toString()));
        w.writeVarBytes(this.consensusPayload);
        w.writeBytes(this.nextBookkeeper.toArray());
    }
}
function isHeader(item) {
    return item instanceof Header;
}

/***/ }),

/***/ "./src/core/payload/deployCode.ts":
/*!****************************************!*\
  !*** ./src/core/payload/deployCode.ts ***!
  \****************************************/
/*! exports provided: DeployCode, isDeployCode */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeployCode", function() { return DeployCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDeployCode", function() { return isDeployCode; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../vm/utils/writer */ "./src/vm/utils/writer.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */


class DeployCode {
    // private needStorage: boolean; - unused
    // private name: string; - unused
    // private version: string; - unused
    // private author: string; - unused
    // private email: string; - unused
    // private description: string; - unused
    constructor(options = { code: new Buffer('') }) {
        this.code = options.code;
        // this.needStorage = options.needStorage; - unused
        // this.name = options.name; - unused
        // this.author = options.author; - unused
        // this.email = options.email; - unused
        // this.description = options.description; - unused
    }
    serialize(w) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Unsuported');
    }
    deserialize(r) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Unsuported');
    }
    toArray() {
        const bf = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_1__["Writer"]();
        this.serialize(bf);
        return new Buffer(bf.getBytes());
    }
    getCode() {
        return this.code;
    }
}
function isDeployCode(item) {
    return item instanceof DeployCode;
}

/***/ }),

/***/ "./src/core/payload/invokeCode.ts":
/*!****************************************!*\
  !*** ./src/core/payload/invokeCode.ts ***!
  \****************************************/
/*! exports provided: InvokeCode */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InvokeCode", function() { return InvokeCode; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */

class InvokeCode {
    constructor(code = new Buffer('')) {
        this.code = code;
    }
    serialize(w) {
        try {
            w.writeVarBytes(this.code);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('InvokeCode Code Serialize failed.', e);
        }
    }
    deserialize(r) {
        try {
            const code = r.readVarBytes();
            this.code = code;
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('InvokeCode Code Deserialize failed.', e);
        }
    }
}

/***/ }),

/***/ "./src/core/state/dataEntryPrefix.ts":
/*!*******************************************!*\
  !*** ./src/core/state/dataEntryPrefix.ts ***!
  \*******************************************/
/*! exports provided: DATA_BLOCK, DATA_HEADER, DATA_TRANSACTION, ST_BOOKKEEPER, ST_CONTRACT, ST_STORAGE, ST_VALIDATOR, ST_VOTE, IX_HEADER_HASH_LIST, SYS_CURRENT_BLOCK, SYS_VERSION, SYS_CURRENT_STATE_ROOT, SYS_BLOCK_MERKLE_TREE, EVENT_NOTIFY */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATA_BLOCK", function() { return DATA_BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATA_HEADER", function() { return DATA_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATA_TRANSACTION", function() { return DATA_TRANSACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ST_BOOKKEEPER", function() { return ST_BOOKKEEPER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ST_CONTRACT", function() { return ST_CONTRACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ST_STORAGE", function() { return ST_STORAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ST_VALIDATOR", function() { return ST_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ST_VOTE", function() { return ST_VOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IX_HEADER_HASH_LIST", function() { return IX_HEADER_HASH_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYS_CURRENT_BLOCK", function() { return SYS_CURRENT_BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYS_VERSION", function() { return SYS_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYS_CURRENT_STATE_ROOT", function() { return SYS_CURRENT_STATE_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYS_BLOCK_MERKLE_TREE", function() { return SYS_BLOCK_MERKLE_TREE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_NOTIFY", function() { return EVENT_NOTIFY; });
const DATA_BLOCK = 0x00; // Block height => block hash key prefix
const DATA_HEADER = 0x01; // Block hash => block hash key prefix
const DATA_TRANSACTION = 0x02; // Transction hash = > transaction key prefix
// Transaction
const ST_BOOKKEEPER = 0x03; // BookKeeper state key prefix
const ST_CONTRACT = 0x04; // Smart contract state key prefix
const ST_STORAGE = 0x05; // Smart contract storage key prefix
const ST_VALIDATOR = 0x07; // no use
const ST_VOTE = 0x08; // Vote state key prefix
const IX_HEADER_HASH_LIST = 0x09; // Block height => block hash key prefix
// SYSTEM
const SYS_CURRENT_BLOCK = 0x10; // Current block key prefix
const SYS_VERSION = 0x11; // Store version key prefix
const SYS_CURRENT_STATE_ROOT = 0x12; // no use
const SYS_BLOCK_MERKLE_TREE = 0x13; // Block merkle tree root key prefix
const EVENT_NOTIFY = 0x14; // Event notify key prefix

/***/ }),

/***/ "./src/core/state/stateBase.ts":
/*!*************************************!*\
  !*** ./src/core/state/stateBase.ts ***!
  \*************************************/
/*! exports provided: StateBase */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateBase", function() { return StateBase; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */

class StateBase {
    serialize(w) {
        w.writeUint8(this.stateVersion);
    }
    deserialize(r) {
        try {
            this.stateVersion = r.readByte();
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[StateBase], StateBase Deserialize failed.', e);
        }
    }
}

/***/ }),

/***/ "./src/core/state/stateStore.ts":
/*!**************************************!*\
  !*** ./src/core/state/stateStore.ts ***!
  \**************************************/
/*! exports provided: getStorageKey */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStorageKey", function() { return getStorageKey; });
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../vm/utils/writer */ "./src/vm/utils/writer.ts");
/* harmony import */ var _dataEntryPrefix__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./dataEntryPrefix */ "./src/core/state/dataEntryPrefix.ts");


/**
 * TODO: should be in storage
 */
function getStorageKey(address, key) {
    const w = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_0__["Writer"]();
    w.writeUint8(_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_1__["ST_STORAGE"]);
    w.writeBytes(address.toArray());
    w.writeBytes(key);
    return w.getBytes();
}

/***/ }),

/***/ "./src/core/state/storageItem.ts":
/*!***************************************!*\
  !*** ./src/core/state/storageItem.ts ***!
  \***************************************/
/*! exports provided: StorageItem, isStorageItem */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StorageItem", function() { return StorageItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStorageItem", function() { return isStorageItem; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../vm/utils/writer */ "./src/vm/utils/writer.ts");
/* harmony import */ var _stateBase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./stateBase */ "./src/core/state/stateBase.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */



class StorageItem extends _stateBase__WEBPACK_IMPORTED_MODULE_2__["StateBase"] {
    constructor(value) {
        super();
        this.value = value;
    }
    getValue() {
        return this.value;
    }
    serialize(w) {
        super.serialize(w);
        w.writeVarBytes(this.value);
    }
    deserialize(r) {
        try {
            super.deserialize(r);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[StorageItem], StateBase Deserialize failed.', e);
        }
        try {
            this.value = r.readVarBytes();
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[StorageItem], Value Deserialize failed.', e);
        }
    }
    toArray() {
        const bf = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_1__["Writer"]();
        this.serialize(bf);
        return new Buffer(bf.getBytes());
    }
}
function isStorageItem(item) {
    return item instanceof StorageItem;
}

/***/ }),

/***/ "./src/core/transaction.ts":
/*!*********************************!*\
  !*** ./src/core/transaction.ts ***!
  \*********************************/
/*! exports provided: TX_MAX_SIG_SIZE, Bookkeeper, Deploy, Invoke, RawSig, Transaction, isTransaction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TX_MAX_SIG_SIZE", function() { return TX_MAX_SIG_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bookkeeper", function() { return Bookkeeper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Deploy", function() { return Deploy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Invoke", function() { return Invoke; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RawSig", function() { return RawSig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Transaction", function() { return Transaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTransaction", function() { return isTransaction; });
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! long */ "long");
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(long__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common_address__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common/address */ "./src/common/address.ts");
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../common/error */ "./src/common/error.ts");
/* harmony import */ var _common_uint256__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../common/uint256 */ "./src/common/uint256.ts");
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../common/utils */ "./src/common/utils.ts");
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../vm/utils/writer */ "./src/vm/utils/writer.ts");
/* harmony import */ var _payload_deployCode__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./payload/deployCode */ "./src/core/payload/deployCode.ts");
/* harmony import */ var _payload_invokeCode__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./payload/invokeCode */ "./src/core/payload/invokeCode.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */








const TX_MAX_SIG_SIZE = 16;
const Bookkeeper = 0x02;
const Deploy = 0xd0;
const Invoke = 0xd1;
class RawSig {
    static deserialize(r) {
        const invoke = r.readVarBytes();
        const verify = r.readVarBytes();
        return new RawSig(invoke, verify);
    }
    constructor(invoke, verify) {
        this.invoke = invoke;
        this.verify = verify;
    }
    getVerify() {
        return this.verify;
    }
    serialize(w) {
        w.writeVarBytes(this.invoke);
        w.writeVarBytes(this.verify);
    }
}
class Transaction {
    constructor() {
        this.version = 0;
        this.txType = Invoke;
        this.nonce = 0;
        this.gasPrice = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](500);
        this.gasLimit = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](30000);
        this.sigs = [];
        this.version = 0;
        this.txType = Invoke;
        this.nonce = 0;
        this.gasPrice = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](500);
        this.gasLimit = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](30000);
        this.payer = new _common_address__WEBPACK_IMPORTED_MODULE_1__["Address"]('0000000000000000000000000000000000000000');
        this.payload = new _payload_invokeCode__WEBPACK_IMPORTED_MODULE_7__["InvokeCode"]();
        this.hash = _common_uint256__WEBPACK_IMPORTED_MODULE_3__["Uint256"].parseFromBytes(Object(_common_utils__WEBPACK_IMPORTED_MODULE_4__["sha256"])(this.serializeUnsigned()));
    }
    getVersion() {
        return this.version;
    }
    getNonce() {
        return this.nonce;
    }
    getGasPrice() {
        return this.gasPrice;
    }
    getGasLimit() {
        return this.gasLimit;
    }
    getHash() {
        return this.hash;
    }
    getTxType() {
        return this.txType;
    }
    getPayer() {
        return this.payer;
    }
    getPayload() {
        return this.payload;
    }
    addSig(sig) {
        this.sigs.push(sig);
    }
    getSignatureAddresses() {
        const addrs = [];
        for (const sig of this.sigs) {
            addrs.push(_common_address__WEBPACK_IMPORTED_MODULE_1__["Address"].parseFromVmCode(sig.getVerify()));
        }
        return addrs;
    }
    serialize(w) {
        if (this.raw !== undefined) {
            if (this.raw.length === 0) {
                throw new _common_error__WEBPACK_IMPORTED_MODULE_2__["TracedError"]('wrong constructed transaction');
            }
            w.writeBytes(this.raw);
        } else {
            const bytes = this.serializeUnsigned();
            w.writeBytes(bytes);
        }
    }
    deserialize(r) {
        const pstart = r.position();
        this.deserializeUnsigned(r);
        const pos = r.position();
        const lenUnsigned = pos - pstart;
        r.seek(-lenUnsigned, 'relative');
        const rawUnsigned = r.readBytes(lenUnsigned);
        this.hash = _common_uint256__WEBPACK_IMPORTED_MODULE_3__["Uint256"].parseFromBytes(Object(_common_utils__WEBPACK_IMPORTED_MODULE_4__["sha256"])(rawUnsigned));
        // tx sigs
        const length = r.readVarUInt().toNumber();
        if (length > TX_MAX_SIG_SIZE) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_2__["TracedError"](`transaction signature number ${length} execced ${TX_MAX_SIG_SIZE}`);
        }
        for (let i = 0; i < length; i++) {
            const sig = RawSig.deserialize(r);
            this.sigs.push(sig);
        }
        const pend = r.position();
        const lenAll = pend - pstart;
        r.seek(-lenAll, 'relative');
        this.raw = r.readBytes(lenAll);
    }
    toArray() {
        const bf = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_5__["Writer"]();
        this.serialize(bf);
        return new Buffer(bf.getBytes());
    }
    deserializeUnsigned(r) {
        this.version = r.readByte();
        this.txType = r.readByte();
        this.nonce = r.readUInt32();
        this.gasPrice = r.readUInt64();
        this.gasLimit = r.readUInt64();
        this.payer = new _common_address__WEBPACK_IMPORTED_MODULE_1__["Address"]();
        this.payer.deserialize(r);
        if (this.txType === Invoke) {
            const pl = new _payload_invokeCode__WEBPACK_IMPORTED_MODULE_7__["InvokeCode"]();
            pl.deserialize(r);
            this.payload = pl;
        } else if (this.txType === Deploy) {
            const pl = new _payload_deployCode__WEBPACK_IMPORTED_MODULE_6__["DeployCode"]();
            pl.deserialize(r);
            this.payload = pl;
        } else {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_2__["TracedError"](`unsupported tx type ${this.getTxType()}`);
        }
        const length = r.readVarUInt();
        if (!length.isZero()) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_2__["TracedError"](`transaction attribute must be 0, got ${length.toString()}`);
        }
    }
    /**
     * Serialize transaction data exclueds signatures
     */
    serializeUnsigned() {
        const w = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_5__["Writer"]();
        w.writeUint8(this.version);
        w.writeUint8(this.txType);
        w.writeUint32(this.nonce);
        w.writeUint64(this.gasPrice);
        w.writeUint64(this.gasLimit);
        this.payer.serialize(w);
        this.payload.serialize(w);
        w.writeVarUint(0);
        return w.getBytes();
    }
}
function isTransaction(item) {
    return item instanceof Transaction;
}

/***/ }),

/***/ "./src/core/transactionAttribute.ts":
/*!******************************************!*\
  !*** ./src/core/transactionAttribute.ts ***!
  \******************************************/
/*! exports provided: Nonce, Script, DescriptionUrl, Description, TransactionAttribute, isTransactionAttribute, isTransactionAttributeUsage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Nonce", function() { return Nonce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Script", function() { return Script; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DescriptionUrl", function() { return DescriptionUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Description", function() { return Description; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransactionAttribute", function() { return TransactionAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTransactionAttribute", function() { return isTransactionAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTransactionAttributeUsage", function() { return isTransactionAttributeUsage; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/error */ "./src/common/error.ts");
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../vm/utils/writer */ "./src/vm/utils/writer.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */


const Nonce = 0x00;
const Script = 0x20;
const DescriptionUrl = 0x81;
const Description = 0x90;
class TransactionAttribute {
    constructor(u, d) {
        this.usage = u;
        this.data = this.data;
    }
    getSize() {
        if (this.usage === DescriptionUrl) {
            return 2 + this.data.length;
        }
        return 0;
    }
    getUsage() {
        return this.usage;
    }
    getData() {
        return this.data;
    }
    serialize(w) {
        try {
            w.writeUint8(this.usage);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"](`Transaction attribute Usage serialization error.`, e);
        }
        if (!isTransactionAttributeUsage(this.usage)) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"](`Unsupported attribute Description.`);
        }
        try {
            w.writeVarBytes(this.data);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"](`Transaction attribute Data serialization error.`, e);
        }
    }
    deserialize(r) {
        try {
            const val = r.readByte();
            if (!isTransactionAttributeUsage(this.usage)) {
                throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[TxAttribute] Unsupported attribute Description.');
            }
            this.usage = val;
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"](`Transaction attribute Usage deserialization error`, e);
        }
        try {
            this.data = r.readVarBytes();
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"](`Transaction attribute Data deserialization error.`, e);
        }
    }
    toArray() {
        const bf = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_1__["Writer"]();
        this.serialize(bf);
        return new Buffer(bf.getBytes());
    }
}
function isTransactionAttribute(item) {
    return item instanceof TransactionAttribute;
}
function isTransactionAttributeUsage(item) {
    return item === Nonce || item === Script || item === DescriptionUrl || item === Description;
}

/***/ }),

/***/ "./src/crypto/consts.ts":
/*!******************************!*\
  !*** ./src/crypto/consts.ts ***!
  \******************************/
/*! exports provided: DEFAULT_ALGORITHM */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_ALGORITHM", function() { return DEFAULT_ALGORITHM; });
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */
const DEFAULT_ALGORITHM = {
    algorithm: 'ECDSA',
    parameters: {
        curve: 'P-256' // also called secp256r1
    }
};

/***/ }),

/***/ "./src/crypto/curveLabel.ts":
/*!**********************************!*\
  !*** ./src/crypto/curveLabel.ts ***!
  \**********************************/
/*! exports provided: CurveLabel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CurveLabel", function() { return CurveLabel; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/error */ "./src/common/error.ts");

/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */
/**
 * Elliptic curve used.
 */
class CurveLabel {
    constructor(label, hex, preset) {
        this.label = label;
        this.hex = hex;
        this.preset = preset;
        CurveLabel.values.push(this);
    }
    /**
     * Finds Curvecorresponding to specified hex representation.
     *
     * @param hex Byte hex value
     */
    static fromHex(hex) {
        const item = CurveLabel.values.find(v => v.hex === hex);
        if (item === undefined) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Enum value not found');
        }
        return item;
    }
    /**
     * Finds Curve corresponding to specified label representation.
     *
     * @param label Label
     */
    static fromLabel(label) {
        const item = CurveLabel.values.find(v => v.label === label);
        if (item === undefined) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Enum value not found');
        }
        return item;
    }
}
CurveLabel.values = [];
CurveLabel.SECP224R1 = new CurveLabel('P-224', 1, 'p224');
CurveLabel.SECP256R1 = new CurveLabel('P-256', 2, 'p256');
CurveLabel.SECP384R1 = new CurveLabel('P-384', 3, 'p384');
CurveLabel.SECP521R1 = new CurveLabel('P-521', 4, 'p521');
CurveLabel.ED25519 = new CurveLabel('ed25519', 25, 'ed25519');

/***/ }),

/***/ "./src/crypto/key.ts":
/*!***************************!*\
  !*** ./src/crypto/key.ts ***!
  \***************************/
/*! exports provided: Key, KeyParameters */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Key", function() { return Key; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KeyParameters", function() { return KeyParameters; });
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! crypto */ "crypto");
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(crypto__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var js_sha3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! js-sha3 */ "js-sha3");
/* harmony import */ var js_sha3__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(js_sha3__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../common/error */ "./src/common/error.ts");
/* harmony import */ var _consts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./consts */ "./src/crypto/consts.ts");
/* harmony import */ var _curveLabel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./curveLabel */ "./src/crypto/curveLabel.ts");
/* harmony import */ var _keyType__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./keyType */ "./src/crypto/keyType.ts");
/* harmony import */ var _signatureScheme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./signatureScheme */ "./src/crypto/signatureScheme.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */







/**
 * Common representation of private or public key
 */
class Key {
    /**
     * Creates Key.
     *
     * If no algorithm or parameters are specified, default values will be used.
     * This is strongly discurraged, because it will forbid using other Key types.
     * Therefore use it only for testing.
     *
     * @param key Hex encoded key value
     * @param algorithm Key type
     * @param parameters Parameters of the key type
     */
    constructor(key, algorithm, parameters) {
        if (typeof key === 'string') {
            key = new Buffer(key, 'hex');
        }
        this.key = key;
        if (algorithm === undefined) {
            algorithm = _keyType__WEBPACK_IMPORTED_MODULE_5__["KeyType"].fromLabel(_consts__WEBPACK_IMPORTED_MODULE_3__["DEFAULT_ALGORITHM"].algorithm);
        }
        if (parameters === undefined) {
            parameters = new KeyParameters(_curveLabel__WEBPACK_IMPORTED_MODULE_4__["CurveLabel"].fromLabel(_consts__WEBPACK_IMPORTED_MODULE_3__["DEFAULT_ALGORITHM"].parameters.curve));
        }
        this.algorithm = algorithm;
        this.parameters = parameters;
    }
    /**
     * Computes hash of message using hashing function of signature schema.
     *
     * @param msg input data
     * @param scheme Signing schema to use
     */
    computeHash(msg, scheme) {
        if (scheme === _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithSHA224) {
            const hash = Object(crypto__WEBPACK_IMPORTED_MODULE_0__["createHash"])('sha224');
            hash.update(msg);
            return hash.digest();
        } else if (scheme === _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithSHA256) {
            const hash = Object(crypto__WEBPACK_IMPORTED_MODULE_0__["createHash"])('sha256');
            hash.update(msg);
            return hash.digest();
        } else if (scheme === _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithSHA384) {
            const hash = Object(crypto__WEBPACK_IMPORTED_MODULE_0__["createHash"])('sha384');
            hash.update(msg);
            return hash.digest();
        } else if (scheme === _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithSHA3_512 || scheme === _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].EDDSAwithSHA512) {
            const hash = Object(crypto__WEBPACK_IMPORTED_MODULE_0__["createHash"])('sha512');
            hash.update(msg);
            return hash.digest();
        } else if (scheme === _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithRIPEMD160) {
            const hash = Object(crypto__WEBPACK_IMPORTED_MODULE_0__["createHash"])('ripemd160');
            hash.update(msg);
            return hash.digest();
        } else if (scheme === _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithSHA3_224) {
            return new Buffer(js_sha3__WEBPACK_IMPORTED_MODULE_1__["sha3_224"].arrayBuffer(msg));
        } else if (scheme === _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithSHA3_256) {
            return new Buffer(js_sha3__WEBPACK_IMPORTED_MODULE_1__["sha3_256"].arrayBuffer(msg));
        } else if (scheme === _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithSHA3_384) {
            return new Buffer(js_sha3__WEBPACK_IMPORTED_MODULE_1__["sha3_384"].arrayBuffer(msg));
        } else if (scheme === _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithSHA3_512) {
            return new Buffer(js_sha3__WEBPACK_IMPORTED_MODULE_1__["sha3_512"].arrayBuffer(msg));
        } else {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_2__["TracedError"]('Unsupported hash algorithm.');
        }
    }
    /**
     * Tests if signing schema is compatible with key type.
     *
     * @param schema Signing schema to use
     */
    isSchemaSupported(schema) {
        switch (schema) {
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithSHA224:
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithSHA256:
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithSHA384:
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithSHA512:
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithSHA3_224:
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithSHA3_256:
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithSHA3_384:
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithSHA3_512:
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].ECDSAwithRIPEMD160:
                return this.algorithm === _keyType__WEBPACK_IMPORTED_MODULE_5__["KeyType"].ECDSA;
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_6__["SignatureScheme"].EDDSAwithSHA512:
                return this.algorithm === _keyType__WEBPACK_IMPORTED_MODULE_5__["KeyType"].EDDSA;
            default:
                throw new _common_error__WEBPACK_IMPORTED_MODULE_2__["TracedError"]('Unsupported signature schema.');
        }
    }
}
class KeyParameters {
    constructor(curve) {
        this.curve = curve;
    }
}

/***/ }),

/***/ "./src/crypto/keyType.ts":
/*!*******************************!*\
  !*** ./src/crypto/keyType.ts ***!
  \*******************************/
/*! exports provided: KeyType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KeyType", function() { return KeyType; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/error */ "./src/common/error.ts");
/* harmony import */ var _signatureScheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./signatureScheme */ "./src/crypto/signatureScheme.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */


/**
 * Type of key. ECDSA is the default one to use.
 */
class KeyType {
    constructor(label, hex, defaultSchema) {
        this.label = label;
        this.hex = hex;
        this.defaultSchema = defaultSchema;
        KeyType.values.push(this);
    }
    /**
     * Finds Key type corresponding to specified hex representation.
     *
     * @param hex Byte hex value
     */
    static fromHex(hex) {
        const item = KeyType.values.find(v => v.hex === hex);
        if (item === undefined) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Enum value not found');
        }
        return item;
    }
    /**
     * Finds Key type corresponding to specified label representation.
     *
     * @param label Label
     */
    static fromLabel(label) {
        const item = KeyType.values.find(v => v.label === label);
        if (item === undefined) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Enum value not found');
        }
        return item;
    }
}
KeyType.values = [];
KeyType.ECDSA = new KeyType('ECDSA', 0x12, _signatureScheme__WEBPACK_IMPORTED_MODULE_1__["SignatureScheme"].ECDSAwithSHA256);
KeyType.EDDSA = new KeyType('EDDSA', 0x14, _signatureScheme__WEBPACK_IMPORTED_MODULE_1__["SignatureScheme"].EDDSAwithSHA512);

/***/ }),

/***/ "./src/crypto/publicKey.ts":
/*!*********************************!*\
  !*** ./src/crypto/publicKey.ts ***!
  \*********************************/
/*! exports provided: PublicKey */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PublicKey", function() { return PublicKey; });
/* harmony import */ var elliptic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! elliptic */ "elliptic");
/* harmony import */ var elliptic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(elliptic__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common/error */ "./src/common/error.ts");
/* harmony import */ var _vm_utils_reader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../vm/utils/reader */ "./src/vm/utils/reader.ts");
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../vm/utils/writer */ "./src/vm/utils/writer.ts");
/* harmony import */ var _curveLabel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./curveLabel */ "./src/crypto/curveLabel.ts");
/* harmony import */ var _key__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./key */ "./src/crypto/key.ts");
/* harmony import */ var _keyType__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./keyType */ "./src/crypto/keyType.ts");
/* harmony import */ var _signatureScheme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./signatureScheme */ "./src/crypto/signatureScheme.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */








class PublicKey extends _key__WEBPACK_IMPORTED_MODULE_5__["Key"] {
    /**
     * Deserializes PublicKey
     *
     * @param b Buffer
     *
     */
    static deserialize(b) {
        const r = new _vm_utils_reader__WEBPACK_IMPORTED_MODULE_2__["Reader"](b);
        if (b.length === 33) {
            // ECDSA
            const algorithm = _keyType__WEBPACK_IMPORTED_MODULE_6__["KeyType"].ECDSA;
            const curve = _curveLabel__WEBPACK_IMPORTED_MODULE_4__["CurveLabel"].SECP256R1;
            const pk = r.readBytes(33);
            return new PublicKey(pk, algorithm, new _key__WEBPACK_IMPORTED_MODULE_5__["KeyParameters"](curve));
        } else {
            const algorithmHex = r.readByte();
            const curveHex = r.readByte();
            const pk = r.readBytes(r.length() - 2);
            return new PublicKey(pk, _keyType__WEBPACK_IMPORTED_MODULE_6__["KeyType"].fromHex(algorithmHex), new _key__WEBPACK_IMPORTED_MODULE_5__["KeyParameters"](_curveLabel__WEBPACK_IMPORTED_MODULE_4__["CurveLabel"].fromHex(curveHex)));
        }
    }
    serialize() {
        const w = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_3__["Writer"]();
        switch (this.algorithm) {
            case _keyType__WEBPACK_IMPORTED_MODULE_6__["KeyType"].ECDSA:
                w.writeBytes(this.key);
                break;
            case _keyType__WEBPACK_IMPORTED_MODULE_6__["KeyType"].EDDSA:
                w.writeUint8(this.algorithm.hex);
                w.writeUint8(this.parameters.curve.hex);
                w.writeBytes(this.key);
                break;
        }
        return w.getBytes();
    }
    /**
     * Verifies if the signature was created with private key corresponding to supplied public key
     * and was not tampered with using signature schema.
     *
     * @param msg Buffer input data or Signable object
     * @param signature Signature object
     */
    verify(msg, signature) {
        if (!this.isSchemaSupported(signature.algorithm)) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('Signature schema does not match key type.');
        }
        // retrieves content to sign if not provided directly
        if (!(msg instanceof Buffer)) {
            msg = msg.getSignContent();
        }
        const hash = this.computeHash(msg, signature.algorithm);
        return this.verifySignature(hash, signature.value, signature.algorithm);
    }
    /**
     * For internal use.
     * @param hash Message hash
     * @param signature Hex encoded signature
     * @param schema Signature scheme to use
     */
    verifySignature(hash, signature, schema) {
        switch (schema) {
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_7__["SignatureScheme"].ECDSAwithSHA224:
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_7__["SignatureScheme"].ECDSAwithSHA256:
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_7__["SignatureScheme"].ECDSAwithSHA384:
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_7__["SignatureScheme"].ECDSAwithSHA512:
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_7__["SignatureScheme"].ECDSAwithSHA3_224:
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_7__["SignatureScheme"].ECDSAwithSHA3_256:
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_7__["SignatureScheme"].ECDSAwithSHA3_384:
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_7__["SignatureScheme"].ECDSAwithSHA3_512:
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_7__["SignatureScheme"].ECDSAwithRIPEMD160:
                return this.verifyEcDSASignature(hash, signature);
            case _signatureScheme__WEBPACK_IMPORTED_MODULE_7__["SignatureScheme"].EDDSAwithSHA512:
                return this.verifyEdDSASignature(hash, signature);
            default:
                throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('Unsupported signature schema.');
        }
    }
    /**
     * Verifies EcDSA signature of message hash. Curve name is derrived from private key.
     *
     * @param hash Message hash
     * @param signature Hex encoded signature
     */
    verifyEcDSASignature(hash, signature) {
        const r = signature.slice(0, 32);
        const s = signature.slice(32, 64);
        const ec = new elliptic__WEBPACK_IMPORTED_MODULE_0__["ec"](this.parameters.curve.preset);
        return ec.verify(hash, { r, s }, this.key, 'hex');
    }
    /**
     * Verifies EdDSA signature of message hash. Curve name is derrived from private key.
     *
     * @param hash Message hash
     * @param signature Hex encoded signature
     */
    verifyEdDSASignature(hash, signature) {
        const r = signature.slice(0, 64);
        const s = signature.slice(64, 64);
        const eddsa = new elliptic__WEBPACK_IMPORTED_MODULE_0__["eddsa"](this.parameters.curve.preset);
        return eddsa.verify(hash, { r, s }, this.key, 'hex');
    }
}

/***/ }),

/***/ "./src/crypto/signature.ts":
/*!*********************************!*\
  !*** ./src/crypto/signature.ts ***!
  \*********************************/
/*! exports provided: Signature */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Signature", function() { return Signature; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/error */ "./src/common/error.ts");
/* harmony import */ var _vm_utils_reader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../vm/utils/reader */ "./src/vm/utils/reader.ts");
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../vm/utils/writer */ "./src/vm/utils/writer.ts");
/* harmony import */ var _signatureScheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./signatureScheme */ "./src/crypto/signatureScheme.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */




/**
 * Signature generated by signing data with Private Key.
 */
class Signature {
    /**
     * Deserializes Signature
     * @param data
     */
    static deserialize(data) {
        if (data.length < 2) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Invalid params.');
        }
        if (data.length === 64) {
            const sigScheme = _signatureScheme__WEBPACK_IMPORTED_MODULE_3__["SignatureScheme"].ECDSAwithSHA256;
            return new Signature(sigScheme, data);
        } else {
            const r = new _vm_utils_reader__WEBPACK_IMPORTED_MODULE_1__["Reader"](data);
            const scheme = r.readByte();
            const sigScheme = _signatureScheme__WEBPACK_IMPORTED_MODULE_3__["SignatureScheme"].fromHex(scheme);
            const value = r.readBytes(r.length() - r.position());
            return new Signature(sigScheme, value);
        }
    }
    constructor(algorithm, value) {
        this.algorithm = algorithm;
        this.value = value;
    }
    /**
     * Serializes signature to Hex representation.
     * For transfer to java backend and verify it.
     */
    serialize() {
        const w = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_2__["Writer"]();
        w.writeUint8(this.algorithm.hex);
        w.writeBytes(this.value);
        return w.getBytes();
    }
}

/***/ }),

/***/ "./src/crypto/signatureScheme.ts":
/*!***************************************!*\
  !*** ./src/crypto/signatureScheme.ts ***!
  \***************************************/
/*! exports provided: SignatureScheme */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SignatureScheme", function() { return SignatureScheme; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/error */ "./src/common/error.ts");

/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */
// tslint:disable:variable-name
/**
 * Schema used during signing and verification of signature.
 */
class SignatureScheme {
    constructor(label, hex, labelJWS) {
        this.label = label;
        this.hex = hex;
        this.labelJWS = labelJWS;
        SignatureScheme.values.push(this);
    }
    /**
     * Finds Signature schema corresponding to specified hex representation.
     *
     * @param hex Byte hex value
     */
    static fromHex(hex) {
        const item = SignatureScheme.values.find(v => v.hex === hex);
        if (item === undefined) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Enum value not found');
        }
        return item;
    }
    /**
     * Finds Signature schema corresponding to specified label representation.
     *
     * @param label Label
     */
    static fromLabel(label) {
        const item = SignatureScheme.values.find(v => v.label === label);
        if (item === undefined) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Enum value not found');
        }
        return item;
    }
    /**
     * Finds Signature schema corresponding to specified label representation in JWS.
     *
     * @param label Label
     */
    static fromLabelJWS(label) {
        const item = SignatureScheme.values.find(v => v.labelJWS === label);
        if (item === undefined) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Enum value not found');
        }
        return item;
    }
}
SignatureScheme.values = [];
SignatureScheme.ECDSAwithSHA224 = new SignatureScheme('SHA224withECDSA', 0, 'ES224');
SignatureScheme.ECDSAwithSHA256 = new SignatureScheme('SHA256withECDSA', 1, 'ES256');
SignatureScheme.ECDSAwithSHA384 = new SignatureScheme('SHA384withECDSA', 2, 'ES384');
SignatureScheme.ECDSAwithSHA512 = new SignatureScheme('SHA512withECDSA', 3, 'ES512');
SignatureScheme.ECDSAwithSHA3_224 = new SignatureScheme('SHA3-224withECDSA', 4, 'ES3-224');
SignatureScheme.ECDSAwithSHA3_256 = new SignatureScheme('SHA3-256withECDSA', 5, 'ES3-256');
SignatureScheme.ECDSAwithSHA3_384 = new SignatureScheme('SHA3-384withECDSA', 6, 'ES3-384');
SignatureScheme.ECDSAwithSHA3_512 = new SignatureScheme('SHA3-512withECDSA', 7, 'ES3-512');
SignatureScheme.ECDSAwithRIPEMD160 = new SignatureScheme('RIPEMD160withECDSA', 8, 'ER160');
SignatureScheme.EDDSAwithSHA512 = new SignatureScheme('SHA512withEdDSA', 10, 'EDS512');

/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/*! exports provided: NeoVmService, ScEnvironment, Address, StorageItem, RuntimeLedgerStore, RuntimeStateStore */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _common_address__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common/address */ "./src/common/address.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Address", function() { return _common_address__WEBPACK_IMPORTED_MODULE_0__["Address"]; });

/* harmony import */ var _scEnvironment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scEnvironment */ "./src/scEnvironment.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScEnvironment", function() { return _scEnvironment__WEBPACK_IMPORTED_MODULE_1__["ScEnvironment"]; });

/* harmony import */ var _smartcontract_neoVmService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./smartcontract/neoVmService */ "./src/smartcontract/neoVmService.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NeoVmService", function() { return _smartcontract_neoVmService__WEBPACK_IMPORTED_MODULE_2__["NeoVmService"]; });

/* harmony import */ var _smartcontract_service_native_init__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./smartcontract/service/native/init */ "./src/smartcontract/service/native/init.ts");
/* harmony import */ var _core_state_storageItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./core/state/storageItem */ "./src/core/state/storageItem.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StorageItem", function() { return _core_state_storageItem__WEBPACK_IMPORTED_MODULE_4__["StorageItem"]; });

/* harmony import */ var _smartcontract_runtime_runtimeLedgerStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./smartcontract/runtime/runtimeLedgerStore */ "./src/smartcontract/runtime/runtimeLedgerStore.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RuntimeLedgerStore", function() { return _smartcontract_runtime_runtimeLedgerStore__WEBPACK_IMPORTED_MODULE_5__["RuntimeLedgerStore"]; });

/* harmony import */ var _smartcontract_runtime_runtimeStateStore__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./smartcontract/runtime/runtimeStateStore */ "./src/smartcontract/runtime/runtimeStateStore.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RuntimeStateStore", function() { return _smartcontract_runtime_runtimeStateStore__WEBPACK_IMPORTED_MODULE_6__["RuntimeStateStore"]; });

/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */








// init native contracts
Object(_smartcontract_service_native_init__WEBPACK_IMPORTED_MODULE_3__["init"])();

/***/ }),

/***/ "./src/scEnvironment.ts":
/*!******************************!*\
  !*** ./src/scEnvironment.ts ***!
  \******************************/
/*! exports provided: ScEnvironment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScEnvironment", function() { return ScEnvironment; });
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! long */ "long");
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(long__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common_address__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./common/address */ "./src/common/address.ts");
/* harmony import */ var _common_uint256__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./common/uint256 */ "./src/common/uint256.ts");
/* harmony import */ var _core_payload_deployCode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./core/payload/deployCode */ "./src/core/payload/deployCode.ts");
/* harmony import */ var _core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./core/state/dataEntryPrefix */ "./src/core/state/dataEntryPrefix.ts");
/* harmony import */ var _core_transaction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./core/transaction */ "./src/core/transaction.ts");
/* harmony import */ var _smartcontract_runtime_runtimeLedgerStore__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./smartcontract/runtime/runtimeLedgerStore */ "./src/smartcontract/runtime/runtimeLedgerStore.ts");
/* harmony import */ var _smartcontract_runtime_runtimeStateStore__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./smartcontract/runtime/runtimeStateStore */ "./src/smartcontract/runtime/runtimeStateStore.ts");
/* harmony import */ var _smartcontract_smartContract__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./smartcontract/smartContract */ "./src/smartcontract/smartContract.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */









class ScEnvironment {
    constructor({ ledgerStore = new _smartcontract_runtime_runtimeLedgerStore__WEBPACK_IMPORTED_MODULE_6__["RuntimeLedgerStore"](), store = new _smartcontract_runtime_runtimeStateStore__WEBPACK_IMPORTED_MODULE_7__["RuntimeStateStore"]() } = {}) {
        this.ledgerStore = ledgerStore;
        this.store = store;
    }
    deployContract(contract) {
        const address = _common_address__WEBPACK_IMPORTED_MODULE_1__["Address"].parseFromVmCode(contract);
        const deployCode = new _core_payload_deployCode__WEBPACK_IMPORTED_MODULE_3__["DeployCode"]({ code: contract });
        this.store.add(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_4__["ST_CONTRACT"], address.toArray(), deployCode);
        this.ledgerStore.deployContract(address, deployCode);
        return address.toArray();
    }
    async execute(code, { time = 10, tx = new _core_transaction__WEBPACK_IMPORTED_MODULE_5__["Transaction"](), gas = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](100000), randomHash, inspect, wallet, enableSecurity, enableGas, notificationCallback, logCallback } = {}) {
        if (wallet !== undefined) {
            wallet.signTransaction(tx);
        }
        const sc = new _smartcontract_smartContract__WEBPACK_IMPORTED_MODULE_8__["SmartContract"]({
            time,
            tx,
            gas,
            randomHash: randomHash !== undefined ? new _common_uint256__WEBPACK_IMPORTED_MODULE_2__["Uint256"](randomHash) : undefined,
            stateStore: this.store,
            store: this.ledgerStore,
            enableSecurity,
            enableGas,
            notificationCallback,
            logCallback
        });
        const vmService = sc.newExecuteEngine(code);
        const result = await vmService.invoke({ inspect });
        const notifications = sc.getNotifications();
        const logs = sc.getLogs();
        return { result, notifications, logs };
    }
}

/***/ }),

/***/ "./src/smartcontract/common.ts":
/*!*************************************!*\
  !*** ./src/smartcontract/common.ts ***!
  \*************************************/
/*! exports provided: convertNeoVmTypeHexString */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertNeoVmTypeHexString", function() { return convertNeoVmTypeHexString; });
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/common/utils.ts");
/* harmony import */ var _vm_types_array__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../vm/types/array */ "./src/vm/types/array.ts");
/* harmony import */ var _vm_types_boolean__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../vm/types/boolean */ "./src/vm/types/boolean.ts");
/* harmony import */ var _vm_types_byteArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../vm/types/byteArray */ "./src/vm/types/byteArray.ts");
/* harmony import */ var _vm_types_integer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../vm/types/integer */ "./src/vm/types/integer.ts");
/* harmony import */ var _vm_types_interop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../vm/types/interop */ "./src/vm/types/interop.ts");
/* harmony import */ var _vm_types_struct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../vm/types/struct */ "./src/vm/types/struct.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */







function convertNeoVmTypeHexString(item) {
    if (item === undefined) {
        return undefined;
    }
    if (Object(_vm_types_byteArray__WEBPACK_IMPORTED_MODULE_3__["isByteArrayType"])(item)) {
        const arr = item.getByteArray();
        return arr.toString('hex');
    } else if (Object(_vm_types_integer__WEBPACK_IMPORTED_MODULE_4__["isIntegerType"])(item)) {
        const i = item.getBigInteger();
        if (i.isZero()) {
            return '00';
        } else {
            return Object(_common_utils__WEBPACK_IMPORTED_MODULE_0__["bigIntToBytes"])(i).toString('hex');
        }
    } else if (Object(_vm_types_boolean__WEBPACK_IMPORTED_MODULE_2__["isBooleanType"])(item)) {
        const b = item.getBoolean();
        if (b) {
            return '01';
        } else {
            return '00';
        }
    } else if (Object(_vm_types_array__WEBPACK_IMPORTED_MODULE_1__["isArrayType"])(item)) {
        const arr = [];
        const ar = item.getArray();
        for (const val of ar) {
            arr.push(convertNeoVmTypeHexString(val));
        }
        return arr;
    } else if (Object(_vm_types_struct__WEBPACK_IMPORTED_MODULE_6__["isStructType"])(item)) {
        const arr = [];
        const ar = item.getArray();
        for (const val of ar) {
            arr.push(convertNeoVmTypeHexString(val));
        }
        return arr;
    } else if (Object(_vm_types_interop__WEBPACK_IMPORTED_MODULE_5__["isInteropType"])(item)) {
        const it = item.getInterface();
        return it.toArray().toString('hex');
    } else {
        // tslint:disable-next-line:no-console
        console.log('[ConvertTypes] Invalid Types!');
    }
}

/***/ }),

/***/ "./src/smartcontract/consts.ts":
/*!*************************************!*\
  !*** ./src/smartcontract/consts.ts ***!
  \*************************************/
/*! exports provided: MIN_TRANSACTION_GAS, BLOCKCHAIN_GETHEADER_GAS, BLOCKCHAIN_GETBLOCK_GAS, BLOCKCHAIN_GETTRANSACTION_GAS, BLOCKCHAIN_GETCONTRACT_GAS, CONTRACT_CREATE_GAS, CONTRACT_MIGRATE_GAS, UINT_DEPLOY_CODE_LEN_GAS, UINT_INVOKE_CODE_LEN_GAS, NATIVE_INVOKE_GAS, STORAGE_GET_GAS, STORAGE_PUT_GAS, STORAGE_DELETE_GAS, RUNTIME_CHECKWITNESS_GAS, APPCALL_GAS, TAILCALL_GAS, SHA1_GAS, SHA256_GAS, HASH160_GAS, HASH256_GAS, OPCODE_GAS, PER_UNIT_CODE_LEN, METHOD_LENGTH_LIMIT, MAX_STACK_SIZE, VM_STEP_LIMIT, ATTRIBUTE_GETUSAGE_NAME, ATTRIBUTE_GETDATA_NAME, BLOCK_GETTRANSACTIONCOUNT_NAME, BLOCK_GETTRANSACTIONS_NAME, BLOCK_GETTRANSACTION_NAME, BLOCKCHAIN_GETHEIGHT_NAME, BLOCKCHAIN_GETHEADER_NAME, BLOCKCHAIN_GETBLOCK_NAME, BLOCKCHAIN_GETTRANSACTION_NAME, BLOCKCHAIN_GETCONTRACT_NAME, BLOCKCHAIN_GETTRANSACTIONHEIGHT_NAME, HEADER_GETINDEX_NAME, HEADER_GETHASH_NAME, HEADER_GETVERSION_NAME, HEADER_GETPREVHASH_NAME, HEADER_GETTIMESTAMP_NAME, HEADER_GETCONSENSUSDATA_NAME, HEADER_GETNEXTCONSENSUS_NAME, HEADER_GETMERKLEROOT_NAME, TRANSACTION_GETHASH_NAME, TRANSACTION_GETTYPE_NAME, TRANSACTION_GETATTRIBUTES_NAME, CONTRACT_CREATE_NAME, CONTRACT_MIGRATE_NAME, CONTRACT_GETSTORAGECONTEXT_NAME, CONTRACT_DESTROY_NAME, CONTRACT_GETSCRIPT_NAME, STORAGE_GET_NAME, STORAGE_PUT_NAME, STORAGE_DELETE_NAME, STORAGE_GETCONTEXT_NAME, STORAGE_GETREADONLYCONTEXT_NAME, STORAGECONTEXT_ASREADONLY_NAME, RUNTIME_GETTIME_NAME, RUNTIME_CHECKWITNESS_NAME, RUNTIME_NOTIFY_NAME, RUNTIME_LOG_NAME, RUNTIME_GETTRIGGER_NAME, RUNTIME_SERIALIZE_NAME, RUNTIME_DESERIALIZE_NAME, RUNTIME_BASE58TOADDRESS_NAME, RUNTIME_ADDRESSTOBASE58_NAME, RUNTIME_GETRANDOMHASH_NAME, NATIVE_INVOKE_NAME, GETSCRIPTCONTAINER_NAME, GETEXECUTINGSCRIPTHASH_NAME, GETCALLINGSCRIPTHASH_NAME, GETENTRYSCRIPTHASH_NAME, APPCALL_NAME, TAILCALL_NAME, SHA1_NAME, SHA256_NAME, HASH160_NAME, HASH256_NAME, UINT_DEPLOY_CODE_LEN_NAME, UINT_INVOKE_CODE_LEN_NAME, MAX_EXECUTE_ENGINE, GasTable, GasTableKeys */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIN_TRANSACTION_GAS", function() { return MIN_TRANSACTION_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLOCKCHAIN_GETHEADER_GAS", function() { return BLOCKCHAIN_GETHEADER_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLOCKCHAIN_GETBLOCK_GAS", function() { return BLOCKCHAIN_GETBLOCK_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLOCKCHAIN_GETTRANSACTION_GAS", function() { return BLOCKCHAIN_GETTRANSACTION_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLOCKCHAIN_GETCONTRACT_GAS", function() { return BLOCKCHAIN_GETCONTRACT_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTRACT_CREATE_GAS", function() { return CONTRACT_CREATE_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTRACT_MIGRATE_GAS", function() { return CONTRACT_MIGRATE_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UINT_DEPLOY_CODE_LEN_GAS", function() { return UINT_DEPLOY_CODE_LEN_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UINT_INVOKE_CODE_LEN_GAS", function() { return UINT_INVOKE_CODE_LEN_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NATIVE_INVOKE_GAS", function() { return NATIVE_INVOKE_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STORAGE_GET_GAS", function() { return STORAGE_GET_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STORAGE_PUT_GAS", function() { return STORAGE_PUT_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STORAGE_DELETE_GAS", function() { return STORAGE_DELETE_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RUNTIME_CHECKWITNESS_GAS", function() { return RUNTIME_CHECKWITNESS_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APPCALL_GAS", function() { return APPCALL_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAILCALL_GAS", function() { return TAILCALL_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHA1_GAS", function() { return SHA1_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHA256_GAS", function() { return SHA256_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HASH160_GAS", function() { return HASH160_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HASH256_GAS", function() { return HASH256_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OPCODE_GAS", function() { return OPCODE_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PER_UNIT_CODE_LEN", function() { return PER_UNIT_CODE_LEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "METHOD_LENGTH_LIMIT", function() { return METHOD_LENGTH_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_STACK_SIZE", function() { return MAX_STACK_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VM_STEP_LIMIT", function() { return VM_STEP_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ATTRIBUTE_GETUSAGE_NAME", function() { return ATTRIBUTE_GETUSAGE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ATTRIBUTE_GETDATA_NAME", function() { return ATTRIBUTE_GETDATA_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLOCK_GETTRANSACTIONCOUNT_NAME", function() { return BLOCK_GETTRANSACTIONCOUNT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLOCK_GETTRANSACTIONS_NAME", function() { return BLOCK_GETTRANSACTIONS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLOCK_GETTRANSACTION_NAME", function() { return BLOCK_GETTRANSACTION_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLOCKCHAIN_GETHEIGHT_NAME", function() { return BLOCKCHAIN_GETHEIGHT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLOCKCHAIN_GETHEADER_NAME", function() { return BLOCKCHAIN_GETHEADER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLOCKCHAIN_GETBLOCK_NAME", function() { return BLOCKCHAIN_GETBLOCK_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLOCKCHAIN_GETTRANSACTION_NAME", function() { return BLOCKCHAIN_GETTRANSACTION_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLOCKCHAIN_GETCONTRACT_NAME", function() { return BLOCKCHAIN_GETCONTRACT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLOCKCHAIN_GETTRANSACTIONHEIGHT_NAME", function() { return BLOCKCHAIN_GETTRANSACTIONHEIGHT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEADER_GETINDEX_NAME", function() { return HEADER_GETINDEX_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEADER_GETHASH_NAME", function() { return HEADER_GETHASH_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEADER_GETVERSION_NAME", function() { return HEADER_GETVERSION_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEADER_GETPREVHASH_NAME", function() { return HEADER_GETPREVHASH_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEADER_GETTIMESTAMP_NAME", function() { return HEADER_GETTIMESTAMP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEADER_GETCONSENSUSDATA_NAME", function() { return HEADER_GETCONSENSUSDATA_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEADER_GETNEXTCONSENSUS_NAME", function() { return HEADER_GETNEXTCONSENSUS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEADER_GETMERKLEROOT_NAME", function() { return HEADER_GETMERKLEROOT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSACTION_GETHASH_NAME", function() { return TRANSACTION_GETHASH_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSACTION_GETTYPE_NAME", function() { return TRANSACTION_GETTYPE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSACTION_GETATTRIBUTES_NAME", function() { return TRANSACTION_GETATTRIBUTES_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTRACT_CREATE_NAME", function() { return CONTRACT_CREATE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTRACT_MIGRATE_NAME", function() { return CONTRACT_MIGRATE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTRACT_GETSTORAGECONTEXT_NAME", function() { return CONTRACT_GETSTORAGECONTEXT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTRACT_DESTROY_NAME", function() { return CONTRACT_DESTROY_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTRACT_GETSCRIPT_NAME", function() { return CONTRACT_GETSCRIPT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STORAGE_GET_NAME", function() { return STORAGE_GET_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STORAGE_PUT_NAME", function() { return STORAGE_PUT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STORAGE_DELETE_NAME", function() { return STORAGE_DELETE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STORAGE_GETCONTEXT_NAME", function() { return STORAGE_GETCONTEXT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STORAGE_GETREADONLYCONTEXT_NAME", function() { return STORAGE_GETREADONLYCONTEXT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STORAGECONTEXT_ASREADONLY_NAME", function() { return STORAGECONTEXT_ASREADONLY_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RUNTIME_GETTIME_NAME", function() { return RUNTIME_GETTIME_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RUNTIME_CHECKWITNESS_NAME", function() { return RUNTIME_CHECKWITNESS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RUNTIME_NOTIFY_NAME", function() { return RUNTIME_NOTIFY_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RUNTIME_LOG_NAME", function() { return RUNTIME_LOG_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RUNTIME_GETTRIGGER_NAME", function() { return RUNTIME_GETTRIGGER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RUNTIME_SERIALIZE_NAME", function() { return RUNTIME_SERIALIZE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RUNTIME_DESERIALIZE_NAME", function() { return RUNTIME_DESERIALIZE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RUNTIME_BASE58TOADDRESS_NAME", function() { return RUNTIME_BASE58TOADDRESS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RUNTIME_ADDRESSTOBASE58_NAME", function() { return RUNTIME_ADDRESSTOBASE58_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RUNTIME_GETRANDOMHASH_NAME", function() { return RUNTIME_GETRANDOMHASH_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NATIVE_INVOKE_NAME", function() { return NATIVE_INVOKE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GETSCRIPTCONTAINER_NAME", function() { return GETSCRIPTCONTAINER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GETEXECUTINGSCRIPTHASH_NAME", function() { return GETEXECUTINGSCRIPTHASH_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GETCALLINGSCRIPTHASH_NAME", function() { return GETCALLINGSCRIPTHASH_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GETENTRYSCRIPTHASH_NAME", function() { return GETENTRYSCRIPTHASH_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APPCALL_NAME", function() { return APPCALL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAILCALL_NAME", function() { return TAILCALL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHA1_NAME", function() { return SHA1_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHA256_NAME", function() { return SHA256_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HASH160_NAME", function() { return HASH160_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HASH256_NAME", function() { return HASH256_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UINT_DEPLOY_CODE_LEN_NAME", function() { return UINT_DEPLOY_CODE_LEN_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UINT_INVOKE_CODE_LEN_NAME", function() { return UINT_INVOKE_CODE_LEN_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_EXECUTE_ENGINE", function() { return MAX_EXECUTE_ENGINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GasTable", function() { return GasTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GasTableKeys", function() { return GasTableKeys; });
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! long */ "long");
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(long__WEBPACK_IMPORTED_MODULE_0__);
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */

// Gas Limit
const MIN_TRANSACTION_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](20000); // Per transaction base cost.
const BLOCKCHAIN_GETHEADER_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](100);
const BLOCKCHAIN_GETBLOCK_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](200);
const BLOCKCHAIN_GETTRANSACTION_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](100);
const BLOCKCHAIN_GETCONTRACT_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](100);
const CONTRACT_CREATE_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](20000000);
const CONTRACT_MIGRATE_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](20000000);
const UINT_DEPLOY_CODE_LEN_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](200000);
const UINT_INVOKE_CODE_LEN_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](20000);
const NATIVE_INVOKE_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](1000);
const STORAGE_GET_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](200);
const STORAGE_PUT_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](4000);
const STORAGE_DELETE_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](100);
const RUNTIME_CHECKWITNESS_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](200);
const APPCALL_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](10);
const TAILCALL_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](10);
const SHA1_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](10);
const SHA256_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](10);
const HASH160_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](20);
const HASH256_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](20);
const OPCODE_GAS = long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](1);
const PER_UNIT_CODE_LEN = 1024;
const METHOD_LENGTH_LIMIT = 1024;
const MAX_STACK_SIZE = 1024;
const VM_STEP_LIMIT = 400000;
// API Name
const ATTRIBUTE_GETUSAGE_NAME = 'Ontology.Attribute.GetUsage';
const ATTRIBUTE_GETDATA_NAME = 'Ontology.Attribute.GetData';
const BLOCK_GETTRANSACTIONCOUNT_NAME = 'System.Block.GetTransactionCount';
const BLOCK_GETTRANSACTIONS_NAME = 'System.Block.GetTransactions';
const BLOCK_GETTRANSACTION_NAME = 'System.Block.GetTransaction';
const BLOCKCHAIN_GETHEIGHT_NAME = 'System.Blockchain.GetHeight';
const BLOCKCHAIN_GETHEADER_NAME = 'System.Blockchain.GetHeader';
const BLOCKCHAIN_GETBLOCK_NAME = 'System.Blockchain.GetBlock';
const BLOCKCHAIN_GETTRANSACTION_NAME = 'System.Blockchain.GetTransaction';
const BLOCKCHAIN_GETCONTRACT_NAME = 'System.Blockchain.GetContract';
const BLOCKCHAIN_GETTRANSACTIONHEIGHT_NAME = 'System.Blockchain.GetTransactionHeight';
const HEADER_GETINDEX_NAME = 'System.Header.GetIndex';
const HEADER_GETHASH_NAME = 'System.Header.GetHash';
const HEADER_GETVERSION_NAME = 'Ontology.Header.GetVersion';
const HEADER_GETPREVHASH_NAME = 'System.Header.GetPrevHash';
const HEADER_GETTIMESTAMP_NAME = 'System.Header.GetTimestamp';
const HEADER_GETCONSENSUSDATA_NAME = 'Ontology.Header.GetConsensusData';
const HEADER_GETNEXTCONSENSUS_NAME = 'Ontology.Header.GetNextConsensus';
const HEADER_GETMERKLEROOT_NAME = 'Ontology.Header.GetMerkleRoot';
const TRANSACTION_GETHASH_NAME = 'System.Transaction.GetHash';
const TRANSACTION_GETTYPE_NAME = 'Ontology.Transaction.GetType';
const TRANSACTION_GETATTRIBUTES_NAME = 'Ontology.Transaction.GetAttributes';
const CONTRACT_CREATE_NAME = 'System.Contract.Create';
const CONTRACT_MIGRATE_NAME = 'System.Contract.Migrate';
const CONTRACT_GETSTORAGECONTEXT_NAME = 'System.Contract.GetStorageContext';
const CONTRACT_DESTROY_NAME = 'System.Contract.Destroy';
const CONTRACT_GETSCRIPT_NAME = 'System.Contract.GetScript';
const STORAGE_GET_NAME = 'System.Storage.Get';
const STORAGE_PUT_NAME = 'System.Storage.Put';
const STORAGE_DELETE_NAME = 'System.Storage.Delete';
const STORAGE_GETCONTEXT_NAME = 'System.Storage.GetContext';
const STORAGE_GETREADONLYCONTEXT_NAME = 'System.Storage.GetReadOnlyContext';
const STORAGECONTEXT_ASREADONLY_NAME = 'System.StorageContext.AsReadOnly';
const RUNTIME_GETTIME_NAME = 'System.Runtime.GetTime';
const RUNTIME_CHECKWITNESS_NAME = 'System.Runtime.CheckWitness';
const RUNTIME_NOTIFY_NAME = 'System.Runtime.Notify';
const RUNTIME_LOG_NAME = 'System.Runtime.Log';
const RUNTIME_GETTRIGGER_NAME = 'System.Runtime.GetTrigger';
const RUNTIME_SERIALIZE_NAME = 'System.Runtime.Serialize';
const RUNTIME_DESERIALIZE_NAME = 'System.Runtime.Deserialize';
const RUNTIME_BASE58TOADDRESS_NAME = 'Ontology.Runtime.Base58ToAddress';
const RUNTIME_ADDRESSTOBASE58_NAME = 'Ontology.Runtime.AddressToBase58';
const RUNTIME_GETRANDOMHASH_NAME = 'Ontology.Runtime.GetRandomHash';
const NATIVE_INVOKE_NAME = 'Ontology.Native.Invoke';
const GETSCRIPTCONTAINER_NAME = 'System.ExecutionEngine.GetScriptContainer';
const GETEXECUTINGSCRIPTHASH_NAME = 'System.ExecutionEngine.GetExecutingScriptHash';
const GETCALLINGSCRIPTHASH_NAME = 'System.ExecutionEngine.GetCallingScriptHash';
const GETENTRYSCRIPTHASH_NAME = 'System.ExecutionEngine.GetEntryScriptHash';
const APPCALL_NAME = 'APPCALL';
const TAILCALL_NAME = 'TAILCALL';
const SHA1_NAME = 'SHA1';
const SHA256_NAME = 'SHA256';
const HASH160_NAME = 'HASH160';
const HASH256_NAME = 'HASH256';
const UINT_DEPLOY_CODE_LEN_NAME = 'Deploy.Code.Gas';
const UINT_INVOKE_CODE_LEN_NAME = 'Invoke.Code.Gas';
const MAX_EXECUTE_ENGINE = 1024;
const GasTable = new Map([[BLOCKCHAIN_GETHEADER_NAME, BLOCKCHAIN_GETHEADER_GAS], [BLOCKCHAIN_GETBLOCK_NAME, BLOCKCHAIN_GETBLOCK_GAS], [BLOCKCHAIN_GETTRANSACTION_NAME, BLOCKCHAIN_GETTRANSACTION_GAS], [BLOCKCHAIN_GETCONTRACT_NAME, BLOCKCHAIN_GETCONTRACT_GAS], [CONTRACT_CREATE_NAME, CONTRACT_CREATE_GAS], [CONTRACT_MIGRATE_NAME, CONTRACT_MIGRATE_GAS], [STORAGE_GET_NAME, STORAGE_GET_GAS], [STORAGE_PUT_NAME, STORAGE_PUT_GAS], [STORAGE_DELETE_NAME, STORAGE_DELETE_GAS], [RUNTIME_CHECKWITNESS_NAME, RUNTIME_CHECKWITNESS_GAS], [NATIVE_INVOKE_NAME, NATIVE_INVOKE_GAS], [APPCALL_NAME, APPCALL_GAS], [TAILCALL_NAME, TAILCALL_GAS], [SHA1_NAME, SHA1_GAS], [SHA256_NAME, SHA256_GAS], [HASH160_NAME, HASH160_GAS], [HASH256_NAME, HASH256_GAS], [UINT_DEPLOY_CODE_LEN_NAME, UINT_DEPLOY_CODE_LEN_GAS], [UINT_INVOKE_CODE_LEN_NAME, UINT_INVOKE_CODE_LEN_GAS]]);
const GasTableKeys = GasTable.keys();

/***/ }),

/***/ "./src/smartcontract/errors.ts":
/*!*************************************!*\
  !*** ./src/smartcontract/errors.ts ***!
  \*************************************/
/*! exports provided: ERR_CHECK_STACK_SIZE, ERR_EXECUTE_CODE, ERR_GAS_INSUFFICIENT, VM_EXEC_STEP_EXCEED, CONTRACT_NOT_EXIST, DEPLOYCODE_TYPE_ERROR, VM_EXEC_FAULT */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_CHECK_STACK_SIZE", function() { return ERR_CHECK_STACK_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_EXECUTE_CODE", function() { return ERR_EXECUTE_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_GAS_INSUFFICIENT", function() { return ERR_GAS_INSUFFICIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VM_EXEC_STEP_EXCEED", function() { return VM_EXEC_STEP_EXCEED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTRACT_NOT_EXIST", function() { return CONTRACT_NOT_EXIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEPLOYCODE_TYPE_ERROR", function() { return DEPLOYCODE_TYPE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VM_EXEC_FAULT", function() { return VM_EXEC_FAULT; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/error */ "./src/common/error.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */

const ERR_CHECK_STACK_SIZE = new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[NeoVmService] vm over max stack size!');
const ERR_EXECUTE_CODE = new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[NeoVmService] vm execute code invalid!');
const ERR_GAS_INSUFFICIENT = new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[NeoVmService] gas insufficient');
const VM_EXEC_STEP_EXCEED = new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[NeoVmService] vm execute step exceed!');
const CONTRACT_NOT_EXIST = new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[NeoVmService] Get contract code from db fail');
const DEPLOYCODE_TYPE_ERROR = new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[NeoVmService] DeployCode type error!');
const VM_EXEC_FAULT = new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[NeoVmService] vm execute state fault!');

/***/ }),

/***/ "./src/smartcontract/gasCost.ts":
/*!**************************************!*\
  !*** ./src/smartcontract/gasCost.ts ***!
  \**************************************/
/*! exports provided: storeGasCost, gasPrice */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeGasCost", function() { return storeGasCost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gasPrice", function() { return gasPrice; });
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! long */ "long");
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(long__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common/error */ "./src/common/error.ts");
/* harmony import */ var _vm_func_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../vm/func/common */ "./src/vm/func/common.ts");
/* harmony import */ var _consts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./consts */ "./src/smartcontract/consts.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */




function storeGasCost(engine) {
    const key = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_2__["peekNByteArray"])(1, engine);
    const value = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_2__["peekNByteArray"])(2, engine);
    const putCost = _consts__WEBPACK_IMPORTED_MODULE_3__["GasTable"].get(_consts__WEBPACK_IMPORTED_MODULE_3__["STORAGE_PUT_NAME"]);
    if (putCost !== undefined) {
        return long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"]((key.length + value.length - 1) / 1024 + 1).mul(putCost);
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[StoreGasCost] get STORAGE_PUT_NAME gas failed');
    }
}
function gasPrice(engine, name) {
    switch (name) {
        case _consts__WEBPACK_IMPORTED_MODULE_3__["STORAGE_PUT_NAME"]:
            return storeGasCost(engine);
        default:
            const value = _consts__WEBPACK_IMPORTED_MODULE_3__["GasTable"].get(name);
            if (value !== undefined) {
                return value;
            }
            return _consts__WEBPACK_IMPORTED_MODULE_3__["OPCODE_GAS"];
    }
}

/***/ }),

/***/ "./src/smartcontract/nativeVmService.ts":
/*!**********************************************!*\
  !*** ./src/smartcontract/nativeVmService.ts ***!
  \**********************************************/
/*! exports provided: contracts, NativeVmService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "contracts", function() { return contracts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NativeVmService", function() { return NativeVmService; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/error */ "./src/common/error.ts");
/* harmony import */ var _vm_func_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../vm/func/common */ "./src/vm/func/common.ts");
/* harmony import */ var _vm_utils_reader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../vm/utils/reader */ "./src/vm/utils/reader.ts");
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../vm/utils/writer */ "./src/vm/utils/writer.ts");
/* harmony import */ var _states_contract__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./states/contract */ "./src/smartcontract/states/contract.ts");





const contracts = new Map();
class NativeVmService {
    constructor(options) {
        this.stateStore = options.stateStore;
        this.contextRef = options.contextRef;
        this.code = options.code;
        this.tx = options.tx;
        this.time = options.time;
        this.serviceMap = options.serviceMap;
        // this.height = options.height;
        this.notifications = [];
        this.logs = [];
        this.notificationCallback = options.notificationCallback;
    }
    invoke() {
        const contract = _states_contract__WEBPACK_IMPORTED_MODULE_4__["Contract"].deserialize(new _vm_utils_reader__WEBPACK_IMPORTED_MODULE_2__["Reader"](this.code));
        const addr = contract.address.toHexString();
        const services = contracts.get(addr);
        if (services === undefined) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"](`Native contract address ${addr} haven't been registered.`);
        }
        services(this);
        const service = this.serviceMap.get(contract.method);
        if (service === undefined) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"](`Native contract ${addr} doesn't support this function ${contract.method}.`);
        }
        const args = this.input;
        this.input = contract.args;
        this.contextRef.pushContext({ contractAddress: contract.address, code: new Buffer('') });
        const notifications = this.notifications;
        this.notifications = [];
        try {
            const result = service(this);
            this.contextRef.popContext();
            this.contextRef.pushNotifications(this.notifications);
            this.contextRef.pushLogs(this.logs);
            this.notifications = notifications;
            this.input = args;
            return Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["newStackItem"])(result);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[Invoke] Native serivce function execute error!', e);
        }
    }
    register(methodName, handler) {
        this.serviceMap.set(methodName, handler);
    }
    addNotification(event) {
        this.notifications.push(event);
        if (this.notificationCallback !== undefined) {
            this.notificationCallback(event);
        }
    }
    nativeCall(address, method, args) {
        const c = new _states_contract__WEBPACK_IMPORTED_MODULE_4__["Contract"]({
            version: 0,
            address,
            method,
            args
        });
        const w = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_3__["Writer"]();
        c.serialize(w);
        this.code = w.getBytes();
        return this.invoke();
    }
}

/***/ }),

/***/ "./src/smartcontract/neoVmService.ts":
/*!*******************************************!*\
  !*** ./src/smartcontract/neoVmService.ts ***!
  \*******************************************/
/*! exports provided: NeoVmService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NeoVmService", function() { return NeoVmService; });
/* harmony import */ var _common_address__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/address */ "./src/common/address.ts");
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common/error */ "./src/common/error.ts");
/* harmony import */ var _core_payload_deployCode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../core/payload/deployCode */ "./src/core/payload/deployCode.ts");
/* harmony import */ var _core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../core/state/dataEntryPrefix */ "./src/core/state/dataEntryPrefix.ts");
/* harmony import */ var _crypto_publicKey__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../crypto/publicKey */ "./src/crypto/publicKey.ts");
/* harmony import */ var _crypto_signature__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../crypto/signature */ "./src/crypto/signature.ts");
/* harmony import */ var _vm_consts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../vm/consts */ "./src/vm/consts.ts");
/* harmony import */ var _vm_executionContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../vm/executionContext */ "./src/vm/executionContext.ts");
/* harmony import */ var _vm_func_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../vm/func/common */ "./src/vm/func/common.ts");
/* harmony import */ var _vm_interfaces_engine__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../vm/interfaces/engine */ "./src/vm/interfaces/engine.ts");
/* harmony import */ var _vm_opCode__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../vm/opCode */ "./src/vm/opCode.ts");
/* harmony import */ var _vm_types_array__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../vm/types/array */ "./src/vm/types/array.ts");
/* harmony import */ var _vm_types_struct__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../vm/types/struct */ "./src/vm/types/struct.ts");
/* harmony import */ var _consts__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./consts */ "./src/smartcontract/consts.ts");
/* harmony import */ var _errors__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./errors */ "./src/smartcontract/errors.ts");
/* harmony import */ var _gasCost__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./gasCost */ "./src/smartcontract/gasCost.ts");
/* harmony import */ var _serviceMap__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./serviceMap */ "./src/smartcontract/serviceMap.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */

















const BYTE_ZERO_20 = new Buffer([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
class NeoVmService {
    constructor(options) {
        this.store = options.store;
        this.stateStore = options.stateStore;
        this.contextRef = options.contextRef;
        this.code = options.code;
        this.tx = options.tx;
        this.time = options.time;
        // this.height = options.height;
        this.randomHash = options.randomHash;
        this.engine = options.engine;
        this.notifications = [];
        this.logs = [];
        this.notificationCallback = options.notificationCallback;
        this.logCallback = options.logCallback;
    }
    getTx() {
        return this.tx;
    }
    getTime() {
        return this.time;
    }
    getEngine() {
        return this.engine;
    }
    getContextRef() {
        return this.contextRef;
    }
    getStateStore() {
        return this.stateStore;
    }
    getStore() {
        return this.store;
    }
    getNotifications() {
        return this.notifications;
    }
    getLogs() {
        return this.logs;
    }
    getRandomHash() {
        return this.randomHash;
    }
    // Invoke a smart contract
    async invoke({ inspect = () => Promise.resolve(true) }) {
        if (this.code.length === 0) {
            throw _errors__WEBPACK_IMPORTED_MODULE_14__["ERR_EXECUTE_CODE"];
        }
        const contractAddress = _common_address__WEBPACK_IMPORTED_MODULE_0__["Address"].parseFromVmCode(this.code);
        this.contextRef.pushContext({ contractAddress, code: this.code });
        this.engine.pushContext(new _vm_executionContext__WEBPACK_IMPORTED_MODULE_7__["ExecutionContext"](this.code));
        while (true) {
            // check the execution step count
            if (!this.contextRef.checkExecStep()) {
                throw _errors__WEBPACK_IMPORTED_MODULE_14__["VM_EXEC_STEP_EXCEED"];
            }
            if (this.engine.getContexts().length === 0) {
                break;
            }
            if (this.engine.getContext().getInstructionPointer() >= this.engine.getContext().getCode().length) {
                break;
            }
            const instructionPointer = this.engine.getContext().getInstructionPointer();
            this.engine.executeCode();
            if (this.engine.getContext().getInstructionPointer() < this.engine.getContext().getCode().length) {
                if (!this.checkStackSize()) {
                    throw _errors__WEBPACK_IMPORTED_MODULE_14__["ERR_CHECK_STACK_SIZE"];
                }
            }
            const opCode = this.engine.getOpCode();
            let opName = '';
            if (opCode >= _vm_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSHBYTES1"] && opCode <= _vm_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSHBYTES75"]) {
                opName = `PUSHBYTES${opCode}`;
                if (!this.contextRef.checkUseGas(_consts__WEBPACK_IMPORTED_MODULE_13__["OPCODE_GAS"])) {
                    throw _errors__WEBPACK_IMPORTED_MODULE_14__["ERR_GAS_INSUFFICIENT"];
                }
            } else {
                this.engine.validateOp();
                opName = this.engine.getOpExec().name;
                const price = Object(_gasCost__WEBPACK_IMPORTED_MODULE_15__["gasPrice"])(this.engine, opName);
                if (!this.contextRef.checkUseGas(price)) {
                    throw _errors__WEBPACK_IMPORTED_MODULE_14__["ERR_GAS_INSUFFICIENT"];
                }
            }
            const evaluationStack = this.getEngine().getEvaluationStack();
            const altStack = this.getEngine().getAltStack();
            const inspectionResult = await inspect({
                opCode,
                opName,
                contractAddress,
                instructionPointer,
                evaluationStack,
                altStack,
                contexts: this.getEngine().getContexts()
            });
            if (!inspectionResult) {
                return;
            }
            switch (this.engine.getOpCode()) {
                case _vm_opCode__WEBPACK_IMPORTED_MODULE_10__["VERIFY"]:
                    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_8__["evaluationStackCount"])(this.engine) < 3) {
                        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[VERIFY] Too few input parameters ');
                    }
                    const pubKey = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_8__["popByteArray"])(this.engine);
                    const key = _crypto_publicKey__WEBPACK_IMPORTED_MODULE_4__["PublicKey"].deserialize(pubKey);
                    const sig = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_8__["popByteArray"])(this.engine);
                    const data = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_8__["popByteArray"])(this.engine);
                    const signature = _crypto_signature__WEBPACK_IMPORTED_MODULE_5__["Signature"].deserialize(sig);
                    if (!key.verify(data, signature)) {
                        Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_8__["pushData"])(this.engine, false);
                    } else {
                        Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_8__["pushData"])(this.engine, true);
                    }
                    break;
                case _vm_opCode__WEBPACK_IMPORTED_MODULE_10__["SYSCALL"]:
                    this.systemCall();
                    break;
                case _vm_opCode__WEBPACK_IMPORTED_MODULE_10__["APPCALL"]:
                    let address = this.engine.getContext().getReader().readBytes(20);
                    if (address.compare(BYTE_ZERO_20) === 0) {
                        if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_8__["evaluationStackCount"])(this.engine) < 1) {
                            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[Appcall] Too few input parameters:${Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_8__["evaluationStackCount"])(this.engine)}`);
                        }
                        try {
                            address = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_8__["popByteArray"])(this.engine);
                        } catch (e) {
                            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[Appcall] pop contract address error.`, e);
                        }
                        if (address.length !== 20) {
                            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[Appcall] pop contract address len != 20:${address}`);
                        }
                    }
                    const code = this.getContract(address);
                    const service = this.contextRef.newExecuteEngine(code);
                    this.engine.getEvaluationStack().copyTo(service.getEngine().getEvaluationStack());
                    const result = await service.invoke({ inspect });
                    if (result !== undefined) {
                        Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_8__["pushData"])(this.engine, result);
                    }
                    break;
                default:
                    const err = this.engine.stepInto();
                    if (err !== undefined) {
                        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[NeoVmService] vm execute error!`, err);
                    }
                    if (this.engine.getState() === _vm_interfaces_engine__WEBPACK_IMPORTED_MODULE_9__["FAULT"]) {
                        throw _errors__WEBPACK_IMPORTED_MODULE_14__["VM_EXEC_FAULT"];
                    }
            }
        }
        this.contextRef.popContext();
        this.contextRef.pushNotifications(this.notifications);
        this.contextRef.pushLogs(this.logs);
        if (this.engine.getEvaluationStack().count() !== 0) {
            return this.engine.getEvaluationStack().peek(0);
        }
    }
    /**
     * SystemCall provide register service for smart contract to interaction with blockchain
     */
    systemCall() {
        const serviceName = this.engine.getContext().getReader().readVarString(_vm_consts__WEBPACK_IMPORTED_MODULE_6__["MAX_BYTEARRAY_SIZE"]);
        const service = _serviceMap__WEBPACK_IMPORTED_MODULE_16__["ServiceMap"].get(serviceName);
        if (service === undefined) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[SystemCall] service not support: ${serviceName}`);
        }
        const price = Object(_gasCost__WEBPACK_IMPORTED_MODULE_15__["gasPrice"])(this.engine, serviceName);
        if (!this.contextRef.checkUseGas(price)) {
            throw _errors__WEBPACK_IMPORTED_MODULE_14__["ERR_GAS_INSUFFICIENT"];
        }
        if (service.validator !== undefined) {
            try {
                service.validator(this.engine);
            } catch (e) {
                throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[SystemCall] service validator error.`, e);
            }
        }
        try {
            service.execute(this, this.engine);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[SystemCall] service execute error.`, e);
        }
    }
    /**
     * DUMMY: this method will call other SC.
     * Need to devise a way how to use it in test VM
     * @param address
     */
    getContract(address) {
        let item;
        try {
            item = this.stateStore.get(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_3__["ST_CONTRACT"], address);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[getContract] Get contract context error!', e);
        }
        // log.Debugf("invoke contract address:%x", scommon.ToArrayReverse(address))
        if (item === undefined) {
            throw _errors__WEBPACK_IMPORTED_MODULE_14__["CONTRACT_NOT_EXIST"];
        }
        const contract = item.value;
        if (!Object(_core_payload_deployCode__WEBPACK_IMPORTED_MODULE_2__["isDeployCode"])(contract)) {
            throw _errors__WEBPACK_IMPORTED_MODULE_14__["DEPLOYCODE_TYPE_ERROR"];
        }
        return contract.getCode();
    }
    checkStackSize() {
        let size = 0;
        const opCode = this.engine.getOpCode();
        if (opCode < _vm_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH16"]) {
            size = 1;
        } else {
            switch (opCode) {
                case _vm_opCode__WEBPACK_IMPORTED_MODULE_10__["DEPTH"]:
                case _vm_opCode__WEBPACK_IMPORTED_MODULE_10__["DUP"]:
                case _vm_opCode__WEBPACK_IMPORTED_MODULE_10__["OVER"]:
                case _vm_opCode__WEBPACK_IMPORTED_MODULE_10__["TUCK"]:
                    size = 1;
                    break;
                case _vm_opCode__WEBPACK_IMPORTED_MODULE_10__["UNPACK"]:
                    if (this.engine.getEvaluationStack().count() === 0) {
                        return false;
                    }
                    const item = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_8__["peekStackItem"])(this.engine);
                    if (Object(_vm_types_array__WEBPACK_IMPORTED_MODULE_11__["isArrayType"])(item)) {
                        size = item.count();
                    } else if (Object(_vm_types_struct__WEBPACK_IMPORTED_MODULE_12__["isStructType"])(item)) {
                        size = item.count();
                    }
            }
        }
        size += this.engine.getEvaluationStack().count() + this.engine.getAltStack().count();
        if (size > _consts__WEBPACK_IMPORTED_MODULE_13__["MAX_STACK_SIZE"]) {
            return false;
        }
        return true;
    }
    addNotification(event) {
        this.notifications.push(event);
        if (this.notificationCallback !== undefined) {
            this.notificationCallback(event);
        }
    }
    addLog(event) {
        this.logs.push(event);
        if (this.logCallback !== undefined) {
            this.logCallback(event);
        }
    }
    getNotificationCallback() {
        return this.notificationCallback;
    }
}

/***/ }),

/***/ "./src/smartcontract/runtime/runtimeLedgerStore.ts":
/*!*********************************************************!*\
  !*** ./src/smartcontract/runtime/runtimeLedgerStore.ts ***!
  \*********************************************************/
/*! exports provided: RuntimeLedgerStore */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RuntimeLedgerStore", function() { return RuntimeLedgerStore; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */

class RuntimeLedgerStore {
    constructor() {
        this.contracts = new Map();
        this.headerIndex = new Map();
        this.blocks = new Map();
        this.currBlockHeight = 0;
    }
    getCurrentBlockHeight() {
        return this.currBlockHeight;
    }
    /**
     * GetBlockHash return the block hash by block height
     */
    getBlockHash(height) {
        return this.getHeaderIndex(height);
    }
    getHeaderIndex(height) {
        const blockHash = this.headerIndex.get(height);
        if (blockHash === undefined) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"](`[getHeaderIndex] Invalid block height: ${height}`);
        }
        return blockHash;
    }
    /**
     * GetBlockByHeight return block by height.
     */
    getBlockByHeight(height) {
        const blockHash = this.getBlockHash(height);
        if (blockHash === undefined) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"](`[getBlockByHeight] Invalid block height: ${height}`);
        }
        return this.getBlockByHash(blockHash);
    }
    getHeaderByHash(blockHash) {
        const block = this.getBlockByHash(blockHash);
        return block.getHeader();
    }
    getBlockByHash(blockHash) {
        const hash = blockHash.toArray().toString('hex');
        const block = this.blocks.get(hash);
        if (block === undefined) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"](`[RuntimeLedgerStore] Block ${hash} not found.`);
        }
        return block;
    }
    getTransaction(txHash) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Method not implemented.');
    }
    getContractState(contractHash) {
        const contract = this.contracts.get(contractHash.toHexString());
        if (contract === undefined) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Contract not found');
        }
        return contract;
    }
    deployContract(contractHash, contract) {
        this.contracts.set(contractHash.toHexString(), contract);
    }
    addBlock(block) {
        const index = block.getHeader().getHeight();
        const hash = block.getHash();
        this.headerIndex.set(index, hash);
        this.blocks.set(hash.toArray().toString('hex'), block);
    }
}

/***/ }),

/***/ "./src/smartcontract/runtime/runtimeStateStore.ts":
/*!********************************************************!*\
  !*** ./src/smartcontract/runtime/runtimeStateStore.ts ***!
  \********************************************************/
/*! exports provided: RuntimeStateStore */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RuntimeStateStore", function() { return RuntimeStateStore; });
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */
class RuntimeStateStore {
    constructor() {
        this.data = new Map();
    }
    add(prefix, key, value) {
        const k = buildWholeKey(prefix, key);
        this.data.set(k, value);
    }
    getOrAdd(prefix, key, value) {
        const k = buildWholeKey(prefix, key);
        if (this.data.has(k)) {
            return this.data.get(k);
        } else {
            this.add(prefix, key, value);
            return value;
        }
    }
    get(prefix, key) {
        const k = buildWholeKey(prefix, key);
        const item = this.data.get(k);
        if (item === undefined) {
            return undefined;
        }
        return {
            prefix,
            key,
            value: item,
            state: 0
        };
    }
    delete(prefix, key) {
        const k = buildWholeKey(prefix, key);
        this.data.delete(k);
    }
    find(prefix, key) {
        try {
            const item = this.get(prefix, key);
            if (item !== undefined) {
                return [item];
            } else {
                return [];
            }
        } catch (e) {
            return [];
        }
    }
}
function buildWholeKey(prefix, key) {
    const prefixBuffer = new Buffer(1);
    prefixBuffer.writeUInt8(prefix, 0);
    return Buffer.concat([prefixBuffer, key]).toString('hex');
}

/***/ }),

/***/ "./src/smartcontract/service/attribute.ts":
/*!************************************************!*\
  !*** ./src/smartcontract/service/attribute.ts ***!
  \************************************************/
/*! exports provided: attributeGetUsage, attributeGetData */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "attributeGetUsage", function() { return attributeGetUsage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "attributeGetData", function() { return attributeGetData; });
/* harmony import */ var _core_transactionAttribute__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../core/transactionAttribute */ "./src/core/transactionAttribute.ts");
/* harmony import */ var _vm_func_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../vm/func/common */ "./src/vm/func/common.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */


// AttributeGetUsage put attribute's usage to vm stack
function attributeGetUsage(service, engine) {
    const i = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["popInteropInterface"])(engine);
    if (Object(_core_transactionAttribute__WEBPACK_IMPORTED_MODULE_0__["isTransactionAttribute"])(i)) {
        Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["pushData"])(engine, i.getUsage());
    }
}
// AttributeGetData put attribute's data to vm stack
function attributeGetData(service, engine) {
    const i = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["popInteropInterface"])(engine);
    if (Object(_core_transactionAttribute__WEBPACK_IMPORTED_MODULE_0__["isTransactionAttribute"])(i)) {
        Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["pushData"])(engine, i.getData());
    }
}

/***/ }),

/***/ "./src/smartcontract/service/block.ts":
/*!********************************************!*\
  !*** ./src/smartcontract/service/block.ts ***!
  \********************************************/
/*! exports provided: blockGetTransactionCount, blockGetTransactions, blockGetTransaction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blockGetTransactionCount", function() { return blockGetTransactionCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blockGetTransactions", function() { return blockGetTransactions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blockGetTransaction", function() { return blockGetTransaction; });
/* harmony import */ var _core_block__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../core/block */ "./src/core/block.ts");
/* harmony import */ var _vm_func_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../vm/func/common */ "./src/vm/func/common.ts");
/* harmony import */ var _vm_types_interop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../vm/types/interop */ "./src/vm/types/interop.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */



/**
 * BlockGetTransactionCount put block's transactions count to vm stack
 */
function blockGetTransactionCount(service, engine) {
    const i = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["popInteropInterface"])(engine);
    if (Object(_core_block__WEBPACK_IMPORTED_MODULE_0__["isBlock"])(i)) {
        Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["pushData"])(engine, i.getTransactions().length);
    }
}
/**
 * BlockGetTransactions put block's transactions to vm stack
 */
function blockGetTransactions(service, engine) {
    const i = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["popInteropInterface"])(engine);
    if (Object(_core_block__WEBPACK_IMPORTED_MODULE_0__["isBlock"])(i)) {
        const transactions = i.getTransactions();
        const transactionList = transactions.map(transaction => new _vm_types_interop__WEBPACK_IMPORTED_MODULE_2__["InteropType"](transaction));
        Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["pushData"])(engine, transactionList);
    }
}
/**
 * BlockGetTransaction put block's transaction to vm stack
 */
function blockGetTransaction(service, engine) {
    const i = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["popInteropInterface"])(engine);
    const index = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["popInt"])(engine);
    if (Object(_core_block__WEBPACK_IMPORTED_MODULE_0__["isBlock"])(i)) {
        Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["pushData"])(engine, i.getTransactions()[index]);
    }
}

/***/ }),

/***/ "./src/smartcontract/service/blockchain.ts":
/*!*************************************************!*\
  !*** ./src/smartcontract/service/blockchain.ts ***!
  \*************************************************/
/*! exports provided: blockChainGetHeight, blockChainGetHeader, blockChainGetBlock, blockChainGetTransaction, blockChainGetContract, blockChainGetTransactionHeight */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blockChainGetHeight", function() { return blockChainGetHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blockChainGetHeader", function() { return blockChainGetHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blockChainGetBlock", function() { return blockChainGetBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blockChainGetTransaction", function() { return blockChainGetTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blockChainGetContract", function() { return blockChainGetContract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blockChainGetTransactionHeight", function() { return blockChainGetTransactionHeight; });
/* harmony import */ var _common_address__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/address */ "./src/common/address.ts");
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/* harmony import */ var _common_uint256__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../common/uint256 */ "./src/common/uint256.ts");
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../common/utils */ "./src/common/utils.ts");
/* harmony import */ var _vm_func_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../vm/func/common */ "./src/vm/func/common.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */





/**
 * BlockChainGetHeight put blockchain's height to vm stack
 */
function blockChainGetHeight(service, engine) {
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["pushData"])(engine, service.getStore().getCurrentBlockHeight());
}
/**
 * BlockChainGetHeader put blockchain's header to vm stack
 */
function blockChainGetHeader(service, engine) {
    let header;
    const data = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["popByteArray"])(engine);
    const l = data.length;
    if (l <= 5) {
        const b = Object(_common_utils__WEBPACK_IMPORTED_MODULE_3__["bigIntFromBytes"])(data);
        const height = b.toJSNumber();
        const hash = service.getStore().getBlockHash(height);
        try {
            header = service.getStore().getHeaderByHash(hash);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[BlockChainGetHeader] GetHeader error.`, e);
        }
    } else if (l === 32) {
        const hash = _common_uint256__WEBPACK_IMPORTED_MODULE_2__["Uint256"].parseFromBytes(data);
        header = service.getStore().getHeaderByHash(hash);
        try {
            header = service.getStore().getHeaderByHash(hash);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[BlockChainGetHeader] GetHeader error.`, e);
        }
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[BlockChainGetHeader] data invalid.');
    }
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["pushData"])(engine, header);
}
/**
 * BlockChainGetBlock put blockchain's block to vm stack
 */
function blockChainGetBlock(service, engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[BlockChainGetBlock] Too few input parameters ');
    }
    const data = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["popByteArray"])(engine);
    let block;
    const l = data.length;
    if (l <= 5) {
        const b = Object(_common_utils__WEBPACK_IMPORTED_MODULE_3__["bigIntFromBytes"])(data);
        const height = b.toJSNumber();
        try {
            block = service.getStore().getBlockByHeight(height);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[BlockChainGetBlock] GetBlock error.`, e);
        }
    } else if (l === 32) {
        const hash = _common_uint256__WEBPACK_IMPORTED_MODULE_2__["Uint256"].parseFromBytes(data);
        try {
            block = service.getStore().getBlockByHash(hash);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[BlockChainGetBlock] GetBlock error.`, e);
        }
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[BlockChainGetBlock] data invalid.');
    }
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["pushData"])(engine, block);
}
/**
 * BlockChainGetTransaction put blockchain's transaction to vm stack
 */
function blockChainGetTransaction(service, engine) {
    const d = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["popByteArray"])(engine);
    const hash = _common_uint256__WEBPACK_IMPORTED_MODULE_2__["Uint256"].parseFromBytes(d);
    try {
        const [t] = service.getStore().getTransaction(hash);
        Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["pushData"])(engine, t);
    } catch (e) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[BlockChainGetTransaction] GetTransaction error.`, e);
    }
}
/**
 * BlockChainGetContract put blockchain's contract to vm stack
 */
function blockChainGetContract(service, engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[GetContract] Too few input parameters ');
    }
    const b = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["popByteArray"])(engine);
    const address = _common_address__WEBPACK_IMPORTED_MODULE_0__["Address"].parseFromBytes(b);
    try {
        const item = service.getStore().getContractState(address);
        Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["pushData"])(engine, item);
    } catch (e) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[GetContract] GetAsset error.`, e);
    }
}
/**
 * BlockChainGetTransactionHeight put transaction in block height to vm stack
 */
function blockChainGetTransactionHeight(service, engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[BlockChainGetTransactionHeight] Too few input parameters ');
    }
    const d = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["popByteArray"])(engine);
    const hash = _common_uint256__WEBPACK_IMPORTED_MODULE_2__["Uint256"].parseFromBytes(d);
    try {
        const [, h] = service.getStore().getTransaction(hash);
        Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["pushData"])(engine, h);
    } catch (e) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[BlockChainGetTransaction] GetTransaction error.`, e);
    }
}

/***/ }),

/***/ "./src/smartcontract/service/contract.ts":
/*!***********************************************!*\
  !*** ./src/smartcontract/service/contract.ts ***!
  \***********************************************/
/*! exports provided: contractCreate, contractMigrate, contractDestroy, contractGetStorageContext, contractGetCode */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "contractCreate", function() { return contractCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "contractMigrate", function() { return contractMigrate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "contractDestroy", function() { return contractDestroy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "contractGetStorageContext", function() { return contractGetStorageContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "contractGetCode", function() { return contractGetCode; });
/* harmony import */ var _common_address__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/address */ "./src/common/address.ts");
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/* harmony import */ var _core_payload_deployCode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../core/payload/deployCode */ "./src/core/payload/deployCode.ts");
/* harmony import */ var _core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../core/state/dataEntryPrefix */ "./src/core/state/dataEntryPrefix.ts");
/* harmony import */ var _core_state_stateStore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../core/state/stateStore */ "./src/core/state/stateStore.ts");
/* harmony import */ var _vm_func_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../vm/func/common */ "./src/vm/func/common.ts");
/* harmony import */ var _storageContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../storageContext */ "./src/smartcontract/storageContext.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */







/**
 * ContractCreate create a new smart contract on blockchain, and put it to vm stack
 */
function contractCreate(service, engine) {
    try {
        const contract = isContractParamValid(engine);
        const contractAddress = _common_address__WEBPACK_IMPORTED_MODULE_0__["Address"].parseFromVmCode(contract.getCode());
        try {
            const state = service.getStateStore().getOrAdd(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_3__["ST_CONTRACT"], contractAddress.toArray(), contract);
            Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["pushData"])(engine, state);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[ContractCreate] GetOrAdd error.`, e);
        }
    } catch (e) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[ContractCreate] contract parameters invalid.`, e);
    }
}
/**
 * ContractMigrate migrate old smart contract to a new contract, and destroy old contract
 */
function contractMigrate(service, engine) {
    try {
        const contract = isContractParamValid(engine);
        const contractAddress = _common_address__WEBPACK_IMPORTED_MODULE_0__["Address"].parseFromVmCode(contract.getCode());
        try {
            isContractExist(service, contractAddress);
            const context = service.getContextRef().currentContext();
            if (context === undefined) {
                throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[ContractMigrate] current contract context invalid!');
            }
            service.getStateStore().add(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_3__["ST_CONTRACT"], contractAddress.toArray(), contract);
            try {
                const items = storeMigration(service, context.contractAddress, contractAddress);
                service.getStateStore().delete(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_3__["ST_CONTRACT"], context.contractAddress.toArray());
                for (const v of items) {
                    service.getStateStore().delete(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_3__["ST_STORAGE"], v.key);
                }
                Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["pushData"])(engine, contract);
            } catch (e) {
                throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[ContractMigrate] contract store migration error.`, e);
            }
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[ContractMigrate] contract invalid.`, e);
        }
    } catch (e) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[ContractMigrate] contract parameters invalid.`, e);
    }
}
/**
 * ContractDestroy destroy a contract
 */
function contractDestroy(service, engine) {
    const context = service.getContextRef().currentContext();
    if (context === undefined) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[ContractDestory] current contract context invalid!');
    }
    try {
        const item = service.getStateStore().get(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_3__["ST_CONTRACT"], context.contractAddress.toArray());
        if (item === undefined) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[ContractDestroy] get current contract null!');
        }
        service.getStateStore().delete(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_3__["ST_CONTRACT"], context.contractAddress.toArray());
        try {
            const stateValues = service.getStateStore().find(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_3__["ST_STORAGE"], context.contractAddress.toArray());
            for (const v of stateValues) {
                service.getStateStore().delete(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_3__["ST_STORAGE"], v.key);
            }
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[ContractDestory] find error.`, e);
        }
    } catch (e) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[ContractDestroy] get current contract fail!');
    }
}
/**
 * ContractGetStorageContext put contract storage context to vm stack
 */
function contractGetStorageContext(service, engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[GetStorageContext] Too few input parameter!');
    }
    const opInterface = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["popInteropInterface"])(engine);
    if (Object(_core_payload_deployCode__WEBPACK_IMPORTED_MODULE_2__["isDeployCode"])(opInterface)) {
        const address = _common_address__WEBPACK_IMPORTED_MODULE_0__["Address"].parseFromVmCode(opInterface.getCode());
        try {
            const item = service.getStateStore().get(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_3__["ST_CONTRACT"], address.toArray());
            if (item === undefined) {
                throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[GetStorageContext] Get StorageContext null');
            }
            if (!address.equals(service.getContextRef().currentContext().contractAddress)) {
                throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[GetStorageContext] CodeHash not equal!');
            }
            Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["pushData"])(engine, new _storageContext__WEBPACK_IMPORTED_MODULE_6__["StorageContext"](address));
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[GetStorageContext] Get StorageContext error.`, e);
        }
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[GetStorageContext] Pop data not contract!');
    }
}
/**
 * ContractGetCode put contract to vm stack
 */
function contractGetCode(service, engine) {
    const i = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["popInteropInterface"])(engine);
    if (Object(_core_payload_deployCode__WEBPACK_IMPORTED_MODULE_2__["isDeployCode"])(i)) {
        Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["pushData"])(engine, i.getCode());
    }
}
function isContractParamValid(engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 7) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[Contract] Too few input parameters');
    }
    const code = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["popByteArray"])(engine);
    if (code.length > 1024 * 1024) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[Contract] Code too long!');
    }
    const needStorage = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["popBoolean"])(engine);
    const name = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["popByteArray"])(engine);
    if (name.length > 252) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[Contract] Name too long!');
    }
    const version = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["popByteArray"])(engine);
    if (version.length > 252) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[Contract] Version too long!');
    }
    const author = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["popByteArray"])(engine);
    if (author.length > 252) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[Contract] Author too long!');
    }
    const email = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["popByteArray"])(engine);
    if (email.length > 252) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[Contract] Email too long!');
    }
    const desc = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["popByteArray"])(engine);
    if (desc.length > 65536) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[Contract] Desc too long!');
    }
    const contract = new _core_payload_deployCode__WEBPACK_IMPORTED_MODULE_2__["DeployCode"]({
        code,
        needStorage,
        name: name.toString('utf-8'),
        version: version.toString('utf-8'),
        author: author.toString('utf-8'),
        email: email.toString('utf-8'),
        description: desc.toString('utf-8')
    });
    return contract;
}
function isContractExist(service, contractAddress) {
    try {
        const item = service.getStateStore().get(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_3__["ST_CONTRACT"], contractAddress.toArray());
        if (item !== undefined) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[Contract] Get ${contractAddress} contract exist!`);
        }
    } catch (e) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[Contract] Get contract ${contractAddress} error!`, e);
    }
}
function storeMigration(service, oldAddr, newAddr) {
    try {
        const stateValues = service.getStateStore().find(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_3__["ST_STORAGE"], oldAddr.toArray());
        for (const v of stateValues) {
            const subKey = v.key.slice(20);
            service.getStateStore().add(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_3__["ST_STORAGE"], Object(_core_state_stateStore__WEBPACK_IMPORTED_MODULE_4__["getStorageKey"])(newAddr, subKey), v.value);
        }
        return stateValues;
    } catch (e) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[Contract] Find error.`, e);
    }
}

/***/ }),

/***/ "./src/smartcontract/service/header.ts":
/*!*********************************************!*\
  !*** ./src/smartcontract/service/header.ts ***!
  \*********************************************/
/*! exports provided: headerGetHash, headerGetVersion, headerGetPrevHash, headerGetMerkleRoot, headerGetIndex, headerGetTimestamp, headerGetConsensusData, headerGetNextConsensus */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "headerGetHash", function() { return headerGetHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "headerGetVersion", function() { return headerGetVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "headerGetPrevHash", function() { return headerGetPrevHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "headerGetMerkleRoot", function() { return headerGetMerkleRoot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "headerGetIndex", function() { return headerGetIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "headerGetTimestamp", function() { return headerGetTimestamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "headerGetConsensusData", function() { return headerGetConsensusData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "headerGetNextConsensus", function() { return headerGetNextConsensus; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/* harmony import */ var _core_block__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/block */ "./src/core/block.ts");
/* harmony import */ var _core_header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../core/header */ "./src/core/header.ts");
/* harmony import */ var _vm_func_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../vm/func/common */ "./src/vm/func/common.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */




/**
 * HeaderGetHash put header's hash to vm stack
 */
function headerGetHash(service, engine) {
    const d = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["popInteropInterface"])(engine);
    let data;
    if (Object(_core_block__WEBPACK_IMPORTED_MODULE_1__["isBlock"])(d)) {
        data = d.getHeader();
    } else if (Object(_core_header__WEBPACK_IMPORTED_MODULE_2__["isHeader"])(d)) {
        data = d;
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[HeaderGetHash] Wrong type!');
    }
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["pushData"])(engine, data.getHash().toArray());
}
/**
 * HeaderGetVersion put header's version to vm stack
 */
function headerGetVersion(service, engine) {
    const d = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["popInteropInterface"])(engine);
    let data;
    if (Object(_core_block__WEBPACK_IMPORTED_MODULE_1__["isBlock"])(d)) {
        data = d.getHeader();
    } else if (Object(_core_header__WEBPACK_IMPORTED_MODULE_2__["isHeader"])(d)) {
        data = d;
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[headerGetVersion] Wrong type!');
    }
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["pushData"])(engine, data.getVersion());
}
/**
 * HeaderGetPrevHash put header's prevblockhash to vm stack
 */
function headerGetPrevHash(service, engine) {
    const d = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["popInteropInterface"])(engine);
    let data;
    if (Object(_core_block__WEBPACK_IMPORTED_MODULE_1__["isBlock"])(d)) {
        data = d.getHeader();
    } else if (Object(_core_header__WEBPACK_IMPORTED_MODULE_2__["isHeader"])(d)) {
        data = d;
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[headerGetVersion] Wrong type!');
    }
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["pushData"])(engine, data.getPrevBlockHash().toArray());
}
/**
 * HeaderGetMerkleRoot put header's merkleroot to vm stack
 */
function headerGetMerkleRoot(service, engine) {
    const d = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["popInteropInterface"])(engine);
    let data;
    if (Object(_core_block__WEBPACK_IMPORTED_MODULE_1__["isBlock"])(d)) {
        data = d.getHeader();
    } else if (Object(_core_header__WEBPACK_IMPORTED_MODULE_2__["isHeader"])(d)) {
        data = d;
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[headerGetVersion] Wrong type!');
    }
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["pushData"])(engine, data.getTransactionsRoot().toArray());
}
/**
 * HeaderGetIndex put header's height to vm stack
 */
function headerGetIndex(service, engine) {
    const d = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["popInteropInterface"])(engine);
    let data;
    if (Object(_core_block__WEBPACK_IMPORTED_MODULE_1__["isBlock"])(d)) {
        data = d.getHeader();
    } else if (Object(_core_header__WEBPACK_IMPORTED_MODULE_2__["isHeader"])(d)) {
        data = d;
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[headerGetVersion] Wrong type!');
    }
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["pushData"])(engine, data.getHeight());
}
/**
 * HeaderGetTimestamp put header's timestamp to vm stack
 */
function headerGetTimestamp(service, engine) {
    const d = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["popInteropInterface"])(engine);
    let data;
    if (Object(_core_block__WEBPACK_IMPORTED_MODULE_1__["isBlock"])(d)) {
        data = d.getHeader();
    } else if (Object(_core_header__WEBPACK_IMPORTED_MODULE_2__["isHeader"])(d)) {
        data = d;
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[headerGetVersion] Wrong type!');
    }
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["pushData"])(engine, data.getTimestamp());
}
/**
 * HeaderGetConsensusData put header's consensus data to vm stack
 */
function headerGetConsensusData(service, engine) {
    const d = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["popInteropInterface"])(engine);
    let data;
    if (Object(_core_block__WEBPACK_IMPORTED_MODULE_1__["isBlock"])(d)) {
        data = d.getHeader();
    } else if (Object(_core_header__WEBPACK_IMPORTED_MODULE_2__["isHeader"])(d)) {
        data = d;
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[headerGetVersion] Wrong type!');
    }
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["pushData"])(engine, data.getConsensusData());
}
/**
 * HeaderGetNextConsensus put header's consensus to vm stack
 */
function headerGetNextConsensus(service, engine) {
    const d = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["popInteropInterface"])(engine);
    let data;
    if (Object(_core_block__WEBPACK_IMPORTED_MODULE_1__["isBlock"])(d)) {
        data = d.getHeader();
    } else if (Object(_core_header__WEBPACK_IMPORTED_MODULE_2__["isHeader"])(d)) {
        data = d;
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[headerGetVersion] Wrong type!');
    }
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["pushData"])(engine, data.getNextBookkeeper().toArray());
}

/***/ }),

/***/ "./src/smartcontract/service/native.ts":
/*!*********************************************!*\
  !*** ./src/smartcontract/service/native.ts ***!
  \*********************************************/
/*! exports provided: nativeInvoke */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nativeInvoke", function() { return nativeInvoke; });
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! big-integer */ "big-integer");
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(big_integer__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common_address__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../common/address */ "./src/common/address.ts");
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../common/utils */ "./src/common/utils.ts");
/* harmony import */ var _vm_func_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../vm/func/common */ "./src/vm/func/common.ts");
/* harmony import */ var _vm_types_array__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../vm/types/array */ "./src/vm/types/array.ts");
/* harmony import */ var _vm_types_boolean__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../vm/types/boolean */ "./src/vm/types/boolean.ts");
/* harmony import */ var _vm_types_byteArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../vm/types/byteArray */ "./src/vm/types/byteArray.ts");
/* harmony import */ var _vm_types_integer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../vm/types/integer */ "./src/vm/types/integer.ts");
/* harmony import */ var _vm_types_struct__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../vm/types/struct */ "./src/vm/types/struct.ts");
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../vm/utils/writer */ "./src/vm/utils/writer.ts");
/* harmony import */ var _consts__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../consts */ "./src/smartcontract/consts.ts");
/* harmony import */ var _nativeVmService__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../nativeVmService */ "./src/smartcontract/nativeVmService.ts");
/* harmony import */ var _states_contract__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../states/contract */ "./src/smartcontract/states/contract.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */














function nativeInvoke(service, engine) {
    const count = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["evaluationStackCount"])(engine);
    if (count < 4) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_2__["TracedError"](`invoke native contract invalid parameters ${count} < 4`);
    }
    const version = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["popInt"])(engine);
    const address = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["popByteArray"])(engine);
    let addr;
    try {
        addr = _common_address__WEBPACK_IMPORTED_MODULE_1__["Address"].parseFromBytes(address);
    } catch (e) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_2__["TracedError"](`invoke native contract:${address}, address invalid`, e);
    }
    const method = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["popByteArray"])(engine);
    if (method.length > _consts__WEBPACK_IMPORTED_MODULE_11__["METHOD_LENGTH_LIMIT"]) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_2__["TracedError"](`invoke native contract:${address} method:${method} too long, over max length 1024 limit`);
    }
    const args = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["popStackItem"])(engine);
    const buf = buildParamToNative(args);
    const contract = new _states_contract__WEBPACK_IMPORTED_MODULE_13__["Contract"]({
        version,
        address: addr,
        method: method.toString(),
        args: buf
    });
    const sink = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_10__["Writer"]();
    contract.serialize(sink);
    const native = new _nativeVmService__WEBPACK_IMPORTED_MODULE_12__["NativeVmService"]({
        stateStore: service.getStateStore(),
        code: sink.getBytes(),
        tx: service.getTx(),
        // height: service.getHeight(),
        time: service.getTime(),
        contextRef: service.getContextRef(),
        serviceMap: new Map(),
        notificationCallback: service.getNotificationCallback()
    });
    const result = native.invoke();
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_4__["pushData"])(engine, result);
}
function buildParamToNative(item) {
    const w = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_10__["Writer"]();
    buildParamToNativeInternal(w, item);
    return w.getBytes();
}
function buildParamToNativeInternal(w, item) {
    if (Object(_vm_types_byteArray__WEBPACK_IMPORTED_MODULE_7__["isByteArrayType"])(item)) {
        w.writeVarBytes(item.getByteArray());
    } else if (Object(_vm_types_integer__WEBPACK_IMPORTED_MODULE_8__["isIntegerType"])(item)) {
        w.writeVarBytes(item.getByteArray());
    } else if (Object(_vm_types_boolean__WEBPACK_IMPORTED_MODULE_6__["isBooleanType"])(item)) {
        w.writeBool(item.getBoolean());
    } else if (Object(_vm_types_array__WEBPACK_IMPORTED_MODULE_5__["isArrayType"])(item)) {
        const arr = item.getArray();
        const length = Object(_common_utils__WEBPACK_IMPORTED_MODULE_3__["bigIntToBytes"])(big_integer__WEBPACK_IMPORTED_MODULE_0__(arr.length));
        w.writeVarBytes(length);
        for (const v of arr) {
            buildParamToNativeInternal(w, v);
        }
    } else if (Object(_vm_types_struct__WEBPACK_IMPORTED_MODULE_9__["isStructType"])(item)) {
        const st = item.getStruct();
        for (const v of st) {
            buildParamToNativeInternal(w, v);
        }
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_2__["TracedError"](`convert neovm params to native invalid type support: ${item.getType()}`);
    }
}

/***/ }),

/***/ "./src/smartcontract/service/native/init.ts":
/*!**************************************************!*\
  !*** ./src/smartcontract/service/native/init.ts ***!
  \**************************************************/
/*! exports provided: init */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony import */ var _ong_ong__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ong/ong */ "./src/smartcontract/service/native/ong/ong.ts");
/* harmony import */ var _ont_ont__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ont/ont */ "./src/smartcontract/service/native/ont/ont.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */


function init() {
  Object(_ont_ont__WEBPACK_IMPORTED_MODULE_1__["initOnt"])();
  Object(_ong_ong__WEBPACK_IMPORTED_MODULE_0__["initOng"])();
}

/***/ }),

/***/ "./src/smartcontract/service/native/ong/ong.ts":
/*!*****************************************************!*\
  !*** ./src/smartcontract/service/native/ong/ong.ts ***!
  \*****************************************************/
/*! exports provided: initOng, registerOngContract, ongInit, ongTransfer, ongApprove, ongTransferFrom, ongName, ongDecimals, ongSymbol, ongTotalSupply, ongBalanceOf, ongAllowance */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initOng", function() { return initOng; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerOngContract", function() { return registerOngContract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ongInit", function() { return ongInit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ongTransfer", function() { return ongTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ongApprove", function() { return ongApprove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ongTransferFrom", function() { return ongTransferFrom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ongName", function() { return ongName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ongDecimals", function() { return ongDecimals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ongSymbol", function() { return ongSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ongTotalSupply", function() { return ongTotalSupply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ongBalanceOf", function() { return ongBalanceOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ongAllowance", function() { return ongAllowance; });
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! big-integer */ "big-integer");
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(big_integer__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common_address__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../common/address */ "./src/common/address.ts");
/* harmony import */ var _common_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../common/constants */ "./src/common/constants.ts");
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../common/error */ "./src/common/error.ts");
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../common/utils */ "./src/common/utils.ts");
/* harmony import */ var _core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../core/state/dataEntryPrefix */ "./src/core/state/dataEntryPrefix.ts");
/* harmony import */ var _vm_utils_reader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../vm/utils/reader */ "./src/vm/utils/reader.ts");
/* harmony import */ var _nativeVmService__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../nativeVmService */ "./src/smartcontract/nativeVmService.ts");
/* harmony import */ var _ont_ont__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../ont/ont */ "./src/smartcontract/service/native/ont/ont.ts");
/* harmony import */ var _ont_states__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../ont/states */ "./src/smartcontract/service/native/ont/states.ts");
/* harmony import */ var _ont_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../ont/utils */ "./src/smartcontract/service/native/ont/utils.ts");
/* harmony import */ var _utils_params__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../utils/params */ "./src/smartcontract/service/native/utils/params.ts");
/* harmony import */ var _utils_store__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../utils/store */ "./src/smartcontract/service/native/utils/store.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */













function initOng() {
    _nativeVmService__WEBPACK_IMPORTED_MODULE_7__["contracts"].set(_utils_params__WEBPACK_IMPORTED_MODULE_11__["OngContractAddress"].toHexString(), registerOngContract);
}
function registerOngContract(native) {
    native.register(_ont_utils__WEBPACK_IMPORTED_MODULE_10__["INIT_NAME"], ongInit);
    native.register(_ont_utils__WEBPACK_IMPORTED_MODULE_10__["TRANSFER_NAME"], ongTransfer);
    native.register(_ont_utils__WEBPACK_IMPORTED_MODULE_10__["APPROVE_NAME"], ongApprove);
    native.register(_ont_utils__WEBPACK_IMPORTED_MODULE_10__["TRANSFERFROM_NAME"], ongTransferFrom);
    native.register(_ont_utils__WEBPACK_IMPORTED_MODULE_10__["NAME_NAME"], ongName);
    native.register(_ont_utils__WEBPACK_IMPORTED_MODULE_10__["SYMBOL_NAME"], ongSymbol);
    native.register(_ont_utils__WEBPACK_IMPORTED_MODULE_10__["DECIMALS_NAME"], ongDecimals);
    native.register(_ont_utils__WEBPACK_IMPORTED_MODULE_10__["TOTALSUPPLY_NAME"], ongTotalSupply);
    native.register(_ont_utils__WEBPACK_IMPORTED_MODULE_10__["BALANCEOF_NAME"], ongBalanceOf);
    native.register(_ont_utils__WEBPACK_IMPORTED_MODULE_10__["ALLOWANCE_NAME"], ongAllowance);
}
function ongInit(native) {
    const contract = native.contextRef.currentContext().contractAddress;
    const amount = Object(_utils_store__WEBPACK_IMPORTED_MODULE_12__["getStorageUInt64"])(native, _ont_utils__WEBPACK_IMPORTED_MODULE_10__["genTotalSupplyKey"](contract));
    if (amount.gt(0)) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_3__["TracedError"]('Init ong has been completed!');
    }
    const item = Object(_utils_store__WEBPACK_IMPORTED_MODULE_12__["genUInt64StorageItem"])(_common_constants__WEBPACK_IMPORTED_MODULE_2__["ONG_TOTAL_SUPPLY"]);
    native.stateStore.add(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_5__["ST_STORAGE"], _ont_utils__WEBPACK_IMPORTED_MODULE_10__["genTotalSupplyKey"](contract), item);
    native.stateStore.add(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_5__["ST_STORAGE"], Buffer.concat([contract.toArray(), _utils_params__WEBPACK_IMPORTED_MODULE_11__["OntContractAddress"].toArray()]), item);
    _ont_utils__WEBPACK_IMPORTED_MODULE_10__["addNotifications"](native, contract, { from: new _common_address__WEBPACK_IMPORTED_MODULE_1__["Address"](), to: _utils_params__WEBPACK_IMPORTED_MODULE_11__["OntContractAddress"], value: _common_constants__WEBPACK_IMPORTED_MODULE_2__["ONG_TOTAL_SUPPLY"] });
    return _utils_params__WEBPACK_IMPORTED_MODULE_11__["BYTE_TRUE"];
}
function ongTransfer(native) {
    const source = new _vm_utils_reader__WEBPACK_IMPORTED_MODULE_6__["Reader"](native.input);
    const transfers = Object(_ont_states__WEBPACK_IMPORTED_MODULE_9__["deserializeTransfers"])(source);
    const contract = native.contextRef.currentContext().contractAddress;
    for (const v of transfers.states) {
        if (v.value.isZero()) {
            continue;
        }
        if (v.value.gt(_common_constants__WEBPACK_IMPORTED_MODULE_2__["ONG_TOTAL_SUPPLY"])) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_3__["TracedError"](`transfer ong amount:${v.value} over totalSupply:${_common_constants__WEBPACK_IMPORTED_MODULE_2__["ONG_TOTAL_SUPPLY"]}`);
        }
        _ont_utils__WEBPACK_IMPORTED_MODULE_10__["transfer"](native, contract, v);
        _ont_utils__WEBPACK_IMPORTED_MODULE_10__["addNotifications"](native, contract, v);
    }
    return _utils_params__WEBPACK_IMPORTED_MODULE_11__["BYTE_TRUE"];
}
function ongApprove(native) {
    const source = new _vm_utils_reader__WEBPACK_IMPORTED_MODULE_6__["Reader"](native.input);
    const state = Object(_ont_states__WEBPACK_IMPORTED_MODULE_9__["deserializeState"])(source);
    if (state.value.isZero()) {
        return _utils_params__WEBPACK_IMPORTED_MODULE_11__["BYTE_FALSE"];
    }
    if (state.value.gt(_common_constants__WEBPACK_IMPORTED_MODULE_2__["ONG_TOTAL_SUPPLY"])) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_3__["TracedError"](`approve ong amount:${state.value} over totalSupply:${_common_constants__WEBPACK_IMPORTED_MODULE_2__["ONG_TOTAL_SUPPLY"]}`);
    }
    if (native.contextRef.checkWitness(state.from) === false) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_3__["TracedError"]('authentication failed!');
    }
    const contract = native.contextRef.currentContext().contractAddress;
    native.stateStore.add(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_5__["ST_STORAGE"], _ont_utils__WEBPACK_IMPORTED_MODULE_10__["genApproveKey"](contract, state.from, state.to), Object(_utils_store__WEBPACK_IMPORTED_MODULE_12__["genUInt64StorageItem"])(state.value));
    return _utils_params__WEBPACK_IMPORTED_MODULE_11__["BYTE_TRUE"];
}
function ongTransferFrom(native) {
    const source = new _vm_utils_reader__WEBPACK_IMPORTED_MODULE_6__["Reader"](native.input);
    const state = Object(_ont_states__WEBPACK_IMPORTED_MODULE_9__["deserializeTransferFrom"])(source);
    if (state.value.isZero()) {
        return _utils_params__WEBPACK_IMPORTED_MODULE_11__["BYTE_FALSE"];
    }
    if (state.value.gt(_common_constants__WEBPACK_IMPORTED_MODULE_2__["ONG_TOTAL_SUPPLY"])) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_3__["TracedError"](`approve ong amount:${state.value} over totalSupply:${_common_constants__WEBPACK_IMPORTED_MODULE_2__["ONG_TOTAL_SUPPLY"]}`);
    }
    const contract = native.contextRef.currentContext().contractAddress;
    _ont_utils__WEBPACK_IMPORTED_MODULE_10__["transferedFrom"](native, contract, state);
    _ont_utils__WEBPACK_IMPORTED_MODULE_10__["addNotifications"](native, contract, { from: state.from, to: state.to, value: state.value });
    return _utils_params__WEBPACK_IMPORTED_MODULE_11__["BYTE_TRUE"];
}
function ongName(native) {
    return new Buffer(_common_constants__WEBPACK_IMPORTED_MODULE_2__["ONG_NAME"]);
}
function ongDecimals(native) {
    return Object(_common_utils__WEBPACK_IMPORTED_MODULE_4__["bigIntToBytes"])(big_integer__WEBPACK_IMPORTED_MODULE_0__(_common_constants__WEBPACK_IMPORTED_MODULE_2__["ONG_DECIMALS"]));
}
function ongSymbol(native) {
    return new Buffer(_common_constants__WEBPACK_IMPORTED_MODULE_2__["ONG_SYMBOL"]);
}
function ongTotalSupply(native) {
    const contract = native.contextRef.currentContext().contractAddress;
    const amount = Object(_utils_store__WEBPACK_IMPORTED_MODULE_12__["getStorageUInt64"])(native, _ont_utils__WEBPACK_IMPORTED_MODULE_10__["genTotalSupplyKey"](contract));
    return Object(_common_utils__WEBPACK_IMPORTED_MODULE_4__["bigIntToBytes"])(big_integer__WEBPACK_IMPORTED_MODULE_0__(amount.toString()));
}
function ongBalanceOf(native) {
    return Object(_ont_ont__WEBPACK_IMPORTED_MODULE_8__["getBalanceValue"])(native, _ont_ont__WEBPACK_IMPORTED_MODULE_8__["TRANSFER_FLAG"]);
}
function ongAllowance(native) {
    return Object(_ont_ont__WEBPACK_IMPORTED_MODULE_8__["getBalanceValue"])(native, _ont_ont__WEBPACK_IMPORTED_MODULE_8__["APPROVE_FLAG"]);
}

/***/ }),

/***/ "./src/smartcontract/service/native/ont/ont.ts":
/*!*****************************************************!*\
  !*** ./src/smartcontract/service/native/ont/ont.ts ***!
  \*****************************************************/
/*! exports provided: TRANSFER_FLAG, APPROVE_FLAG, initOnt, ontTransferFrom, ontApprove, ontName, ontDecimals, ontSymbol, ontTotalSupply, ontBalanceOf, ontAllowance, getBalanceValue, grantOng, getApproveArgs */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSFER_FLAG", function() { return TRANSFER_FLAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APPROVE_FLAG", function() { return APPROVE_FLAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initOnt", function() { return initOnt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ontTransferFrom", function() { return ontTransferFrom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ontApprove", function() { return ontApprove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ontName", function() { return ontName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ontDecimals", function() { return ontDecimals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ontSymbol", function() { return ontSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ontTotalSupply", function() { return ontTotalSupply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ontBalanceOf", function() { return ontBalanceOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ontAllowance", function() { return ontAllowance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBalanceValue", function() { return getBalanceValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "grantOng", function() { return grantOng; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getApproveArgs", function() { return getApproveArgs; });
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! big-integer */ "big-integer");
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(big_integer__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! long */ "long");
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(long__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _common_address__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../common/address */ "./src/common/address.ts");
/* harmony import */ var _common_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../common/constants */ "./src/common/constants.ts");
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../common/error */ "./src/common/error.ts");
/* harmony import */ var _common_safeMath__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../common/safeMath */ "./src/common/safeMath.ts");
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../common/utils */ "./src/common/utils.ts");
/* harmony import */ var _core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../core/state/dataEntryPrefix */ "./src/core/state/dataEntryPrefix.ts");
/* harmony import */ var _vm_utils_reader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../vm/utils/reader */ "./src/vm/utils/reader.ts");
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../vm/utils/writer */ "./src/vm/utils/writer.ts");
/* harmony import */ var _nativeVmService__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../nativeVmService */ "./src/smartcontract/nativeVmService.ts");
/* harmony import */ var _utils_params__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../utils/params */ "./src/smartcontract/service/native/utils/params.ts");
/* harmony import */ var _utils_serialization__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../utils/serialization */ "./src/smartcontract/service/native/utils/serialization.ts");
/* harmony import */ var _utils_store__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../utils/store */ "./src/smartcontract/service/native/utils/store.ts");
/* harmony import */ var _utils_unbindOng__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../utils/unbindOng */ "./src/smartcontract/service/native/utils/unbindOng.ts");
/* harmony import */ var _states__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./states */ "./src/smartcontract/service/native/ont/states.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./utils */ "./src/smartcontract/service/native/ont/utils.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */

















const TRANSFER_FLAG = 1;
const APPROVE_FLAG = 2;
function initOnt() {
    _nativeVmService__WEBPACK_IMPORTED_MODULE_10__["contracts"].set(_utils_params__WEBPACK_IMPORTED_MODULE_11__["OntContractAddress"].toHexString(), registerOntContract);
}
function registerOntContract(native) {
    native.register(_utils__WEBPACK_IMPORTED_MODULE_16__["INIT_NAME"], ontInit);
    native.register(_utils__WEBPACK_IMPORTED_MODULE_16__["TRANSFER_NAME"], ontTransfer);
    native.register(_utils__WEBPACK_IMPORTED_MODULE_16__["APPROVE_NAME"], ontApprove);
    native.register(_utils__WEBPACK_IMPORTED_MODULE_16__["TRANSFERFROM_NAME"], ontTransferFrom);
    native.register(_utils__WEBPACK_IMPORTED_MODULE_16__["NAME_NAME"], ontName);
    native.register(_utils__WEBPACK_IMPORTED_MODULE_16__["SYMBOL_NAME"], ontSymbol);
    native.register(_utils__WEBPACK_IMPORTED_MODULE_16__["DECIMALS_NAME"], ontDecimals);
    native.register(_utils__WEBPACK_IMPORTED_MODULE_16__["TOTALSUPPLY_NAME"], ontTotalSupply);
    native.register(_utils__WEBPACK_IMPORTED_MODULE_16__["BALANCEOF_NAME"], ontBalanceOf);
    native.register(_utils__WEBPACK_IMPORTED_MODULE_16__["ALLOWANCE_NAME"], ontAllowance);
}
function ontInit(native) {
    const context = native.contextRef.currentContext();
    const contract = context.contractAddress;
    const amount = Object(_utils_store__WEBPACK_IMPORTED_MODULE_13__["getStorageUInt64"])(native, _utils__WEBPACK_IMPORTED_MODULE_16__["genTotalSupplyKey"](contract));
    if (amount.gt(0)) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_4__["TracedError"]('Init ont has been completed!');
    }
    const distribute = new Map();
    const source = native.input;
    let buf;
    try {
        buf = new _vm_utils_reader__WEBPACK_IMPORTED_MODULE_8__["Reader"](source).readVarBytes();
    } catch (e) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_4__["TracedError"]('serialization.ReadVarBytes, contract params deserialize error!', e);
    }
    const input = new _vm_utils_reader__WEBPACK_IMPORTED_MODULE_8__["Reader"](buf);
    const num = Object(_utils_serialization__WEBPACK_IMPORTED_MODULE_12__["decodeVarUint"])(input);
    let sum = long__WEBPACK_IMPORTED_MODULE_1__["ZERO"];
    for (let i = 0; i < num.toNumber(); i++) {
        const addr = Object(_utils_serialization__WEBPACK_IMPORTED_MODULE_12__["decodeAddress"])(input);
        const addrStr = addr.toHexString();
        const value = Object(_utils_serialization__WEBPACK_IMPORTED_MODULE_12__["decodeVarUint"])(input);
        sum = Object(_common_safeMath__WEBPACK_IMPORTED_MODULE_5__["safeAdd"])(sum, value);
        const prev = distribute.get(addrStr) || long__WEBPACK_IMPORTED_MODULE_1__["ZERO"];
        distribute.set(addrStr, prev.add(value));
    }
    if (sum.neq(_common_constants__WEBPACK_IMPORTED_MODULE_3__["ONT_TOTAL_SUPPLY"])) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_4__["TracedError"](`wrong config. total supply ${sum.toString()} != ${_common_constants__WEBPACK_IMPORTED_MODULE_3__["ONT_TOTAL_SUPPLY"].toString()}`);
    }
    for (const [addrStr, val] of distribute) {
        const addr = new _common_address__WEBPACK_IMPORTED_MODULE_2__["Address"](addrStr);
        const balanceKey = _utils__WEBPACK_IMPORTED_MODULE_16__["genBalanceKey"](contract, addr);
        const item = Object(_utils_store__WEBPACK_IMPORTED_MODULE_13__["genUInt64StorageItem"])(val);
        native.stateStore.add(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_7__["ST_STORAGE"], balanceKey, item);
        _utils__WEBPACK_IMPORTED_MODULE_16__["addNotifications"](native, contract, { from: new _common_address__WEBPACK_IMPORTED_MODULE_2__["Address"](), to: addr, value: val });
    }
    native.stateStore.add(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_7__["ST_STORAGE"], _utils__WEBPACK_IMPORTED_MODULE_16__["genTotalSupplyKey"](contract), Object(_utils_store__WEBPACK_IMPORTED_MODULE_13__["genUInt64StorageItem"])(_common_constants__WEBPACK_IMPORTED_MODULE_3__["ONT_TOTAL_SUPPLY"]));
    return _utils_params__WEBPACK_IMPORTED_MODULE_11__["BYTE_TRUE"];
}
function ontTransfer(native) {
    const source = new _vm_utils_reader__WEBPACK_IMPORTED_MODULE_8__["Reader"](native.input);
    const transfers = Object(_states__WEBPACK_IMPORTED_MODULE_15__["deserializeTransfers"])(source);
    const contract = native.contextRef.currentContext().contractAddress;
    for (const v of transfers.states) {
        if (v.value.isZero()) {
            continue;
        }
        if (v.value.gt(_common_constants__WEBPACK_IMPORTED_MODULE_3__["ONT_TOTAL_SUPPLY"])) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_4__["TracedError"](`transfer ont amount:${v.value.toString()} over totalSupply:${_common_constants__WEBPACK_IMPORTED_MODULE_3__["ONT_TOTAL_SUPPLY"]}`);
        }
        const { fromBalance, toBalance } = _utils__WEBPACK_IMPORTED_MODULE_16__["transfer"](native, contract, v);
        grantOng(native, contract, v.from, fromBalance);
        grantOng(native, contract, v.to, toBalance);
        _utils__WEBPACK_IMPORTED_MODULE_16__["addNotifications"](native, contract, v);
    }
    return _utils_params__WEBPACK_IMPORTED_MODULE_11__["BYTE_TRUE"];
}
function ontTransferFrom(native) {
    const source = new _vm_utils_reader__WEBPACK_IMPORTED_MODULE_8__["Reader"](native.input);
    const state = Object(_states__WEBPACK_IMPORTED_MODULE_15__["deserializeTransferFrom"])(source);
    if (state.value.isZero()) {
        return _utils_params__WEBPACK_IMPORTED_MODULE_11__["BYTE_FALSE"];
    }
    if (state.value.gt(_common_constants__WEBPACK_IMPORTED_MODULE_3__["ONT_TOTAL_SUPPLY"])) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_4__["TracedError"](`transferFrom ont amount:${state.value} over totalSupply: ${_common_constants__WEBPACK_IMPORTED_MODULE_3__["ONT_TOTAL_SUPPLY"]}`);
    }
    const contract = native.contextRef.currentContext().contractAddress;
    const { fromBalance, toBalance } = _utils__WEBPACK_IMPORTED_MODULE_16__["transferedFrom"](native, contract, state);
    grantOng(native, contract, state.from, fromBalance);
    grantOng(native, contract, state.to, toBalance);
    _utils__WEBPACK_IMPORTED_MODULE_16__["addNotifications"](native, contract, { from: state.from, to: state.to, value: state.value });
    return _utils_params__WEBPACK_IMPORTED_MODULE_11__["BYTE_TRUE"];
}
function ontApprove(native) {
    const source = new _vm_utils_reader__WEBPACK_IMPORTED_MODULE_8__["Reader"](native.input);
    const state = Object(_states__WEBPACK_IMPORTED_MODULE_15__["deserializeState"])(source);
    if (state.value.isZero()) {
        return _utils_params__WEBPACK_IMPORTED_MODULE_11__["BYTE_FALSE"];
    }
    if (state.value.gt(_common_constants__WEBPACK_IMPORTED_MODULE_3__["ONT_TOTAL_SUPPLY"])) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_4__["TracedError"](`approve ont amount:${state.value} over totalSupply:${_common_constants__WEBPACK_IMPORTED_MODULE_3__["ONT_TOTAL_SUPPLY"]}`);
    }
    if (native.contextRef.checkWitness(state.from) === false) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_4__["TracedError"]('authentication failed!');
    }
    const contract = native.contextRef.currentContext().contractAddress;
    native.stateStore.add(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_7__["ST_STORAGE"], _utils__WEBPACK_IMPORTED_MODULE_16__["genApproveKey"](contract, state.from, state.to), Object(_utils_store__WEBPACK_IMPORTED_MODULE_13__["genUInt64StorageItem"])(state.value));
    return _utils_params__WEBPACK_IMPORTED_MODULE_11__["BYTE_TRUE"];
}
function ontName(native) {
    return new Buffer(_common_constants__WEBPACK_IMPORTED_MODULE_3__["ONT_NAME"]);
}
function ontDecimals(native) {
    return Object(_common_utils__WEBPACK_IMPORTED_MODULE_6__["bigIntToBytes"])(big_integer__WEBPACK_IMPORTED_MODULE_0__(_common_constants__WEBPACK_IMPORTED_MODULE_3__["ONT_DECIMALS"]));
}
function ontSymbol(native) {
    return new Buffer(_common_constants__WEBPACK_IMPORTED_MODULE_3__["ONT_SYMBOL"]);
}
function ontTotalSupply(native) {
    const contract = native.contextRef.currentContext().contractAddress;
    const amount = Object(_utils_store__WEBPACK_IMPORTED_MODULE_13__["getStorageUInt64"])(native, _utils__WEBPACK_IMPORTED_MODULE_16__["genTotalSupplyKey"](contract));
    return Object(_common_utils__WEBPACK_IMPORTED_MODULE_6__["bigIntToBytes"])(big_integer__WEBPACK_IMPORTED_MODULE_0__(amount.toString()));
}
function ontBalanceOf(native) {
    return getBalanceValue(native, TRANSFER_FLAG);
}
function ontAllowance(native) {
    return getBalanceValue(native, APPROVE_FLAG);
}
function getBalanceValue(native, flag) {
    const source = new _vm_utils_reader__WEBPACK_IMPORTED_MODULE_8__["Reader"](native.input);
    const from = Object(_utils_serialization__WEBPACK_IMPORTED_MODULE_12__["decodeAddress"])(source);
    const contract = native.contextRef.currentContext().contractAddress;
    let key;
    if (flag === APPROVE_FLAG) {
        const to = Object(_utils_serialization__WEBPACK_IMPORTED_MODULE_12__["decodeAddress"])(source);
        key = _utils__WEBPACK_IMPORTED_MODULE_16__["genApproveKey"](contract, from, to);
    } else if (flag === TRANSFER_FLAG) {
        key = _utils__WEBPACK_IMPORTED_MODULE_16__["genBalanceKey"](contract, from);
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_4__["TracedError"]('invalid flag');
    }
    const amount = Object(_utils_store__WEBPACK_IMPORTED_MODULE_13__["getStorageUInt64"])(native, key);
    return Object(_common_utils__WEBPACK_IMPORTED_MODULE_6__["bigIntToBytes"])(big_integer__WEBPACK_IMPORTED_MODULE_0__(amount.toString()));
}
function grantOng(native, contract, address, balance) {
    const startOffset = _utils__WEBPACK_IMPORTED_MODULE_16__["getUnboundOffset"](native, contract, address);
    if (native.time <= _common_constants__WEBPACK_IMPORTED_MODULE_3__["GENESIS_BLOCK_TIMESTAMP"]) {
        return;
    }
    const endOffset = native.time - _common_constants__WEBPACK_IMPORTED_MODULE_3__["GENESIS_BLOCK_TIMESTAMP"];
    if (endOffset < startOffset) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_4__["TracedError"](`grant Ong error: wrong timestamp endOffset: ${endOffset} < startOffset: ${startOffset}`);
    } else if (endOffset === startOffset) {
        return;
    }
    if (!balance.isZero()) {
        const value = Object(_utils_unbindOng__WEBPACK_IMPORTED_MODULE_14__["calcUnbindOng"])(balance, startOffset, endOffset);
        const args = getApproveArgs(native, contract, _utils_params__WEBPACK_IMPORTED_MODULE_11__["OngContractAddress"], address, value);
        native.nativeCall(_utils_params__WEBPACK_IMPORTED_MODULE_11__["OngContractAddress"], 'approve', args);
    }
    native.stateStore.add(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_7__["ST_STORAGE"], _utils__WEBPACK_IMPORTED_MODULE_16__["genAddressUnboundOffsetKey"](contract, address), Object(_utils_store__WEBPACK_IMPORTED_MODULE_13__["genUInt32StorageItem"])(endOffset));
}
function getApproveArgs(native, contract, ongContract, address, value) {
    const approve = {
        from: contract,
        to: address,
        value
    };
    const stateValue = Object(_utils_store__WEBPACK_IMPORTED_MODULE_13__["getStorageUInt64"])(native, _utils__WEBPACK_IMPORTED_MODULE_16__["genApproveKey"](ongContract, approve.from, approve.to));
    approve.value = approve.value.add(stateValue);
    const w = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_9__["Writer"]();
    Object(_states__WEBPACK_IMPORTED_MODULE_15__["serializeState"])(w, approve);
    return w.getBytes();
}

/***/ }),

/***/ "./src/smartcontract/service/native/ont/states.ts":
/*!********************************************************!*\
  !*** ./src/smartcontract/service/native/ont/states.ts ***!
  \********************************************************/
/*! exports provided: deserializeTransfers, deserializeState, deserializeTransferFrom, serializeState */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deserializeTransfers", function() { return deserializeTransfers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deserializeState", function() { return deserializeState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deserializeTransferFrom", function() { return deserializeTransferFrom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "serializeState", function() { return serializeState; });
/* harmony import */ var _utils_serialization__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/serialization */ "./src/smartcontract/service/native/utils/serialization.ts");

function deserializeTransfers(r) {
    const n = Object(_utils_serialization__WEBPACK_IMPORTED_MODULE_0__["readVarUint"])(r);
    const states = [];
    for (let i = 0; i < n.toNumber(); i++) {
        const state = deserializeState(r);
        states.push(state);
    }
    return { states };
}
function deserializeState(r) {
    const from = Object(_utils_serialization__WEBPACK_IMPORTED_MODULE_0__["readAddress"])(r);
    const to = Object(_utils_serialization__WEBPACK_IMPORTED_MODULE_0__["readAddress"])(r);
    const value = Object(_utils_serialization__WEBPACK_IMPORTED_MODULE_0__["readVarUint"])(r);
    return { from, to, value };
}
function deserializeTransferFrom(r) {
    const sender = Object(_utils_serialization__WEBPACK_IMPORTED_MODULE_0__["readAddress"])(r);
    const from = Object(_utils_serialization__WEBPACK_IMPORTED_MODULE_0__["readAddress"])(r);
    const to = Object(_utils_serialization__WEBPACK_IMPORTED_MODULE_0__["readAddress"])(r);
    const value = Object(_utils_serialization__WEBPACK_IMPORTED_MODULE_0__["readVarUint"])(r);
    return {
        sender,
        from,
        to,
        value
    };
}
function serializeState(w, state) {
    Object(_utils_serialization__WEBPACK_IMPORTED_MODULE_0__["writeAddress"])(w, state.from);
    Object(_utils_serialization__WEBPACK_IMPORTED_MODULE_0__["writeAddress"])(w, state.to);
    Object(_utils_serialization__WEBPACK_IMPORTED_MODULE_0__["writeVarUint"])(w, state.value);
}

/***/ }),

/***/ "./src/smartcontract/service/native/ont/utils.ts":
/*!*******************************************************!*\
  !*** ./src/smartcontract/service/native/ont/utils.ts ***!
  \*******************************************************/
/*! exports provided: UNBOUND_TIME_OFFSET, TOTAL_SUPPLY_NAME, INIT_NAME, TRANSFER_NAME, APPROVE_NAME, TRANSFERFROM_NAME, NAME_NAME, SYMBOL_NAME, DECIMALS_NAME, TOTALSUPPLY_NAME, BALANCEOF_NAME, ALLOWANCE_NAME, addNotifications, transfer, transferedFrom, getToUInt64StorageItem, genTotalSupplyKey, genBalanceKey, fromTransfer, toTransfer, getUnboundOffset, genTransferFromKey, fromApprove, genAddressUnboundOffsetKey, genApproveKey */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNBOUND_TIME_OFFSET", function() { return UNBOUND_TIME_OFFSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOTAL_SUPPLY_NAME", function() { return TOTAL_SUPPLY_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INIT_NAME", function() { return INIT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSFER_NAME", function() { return TRANSFER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APPROVE_NAME", function() { return APPROVE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSFERFROM_NAME", function() { return TRANSFERFROM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAME_NAME", function() { return NAME_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYMBOL_NAME", function() { return SYMBOL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DECIMALS_NAME", function() { return DECIMALS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOTALSUPPLY_NAME", function() { return TOTALSUPPLY_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BALANCEOF_NAME", function() { return BALANCEOF_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALLOWANCE_NAME", function() { return ALLOWANCE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNotifications", function() { return addNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transfer", function() { return transfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transferedFrom", function() { return transferedFrom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getToUInt64StorageItem", function() { return getToUInt64StorageItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "genTotalSupplyKey", function() { return genTotalSupplyKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "genBalanceKey", function() { return genBalanceKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromTransfer", function() { return fromTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toTransfer", function() { return toTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUnboundOffset", function() { return getUnboundOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "genTransferFromKey", function() { return genTransferFromKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromApprove", function() { return fromApprove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "genAddressUnboundOffsetKey", function() { return genAddressUnboundOffsetKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "genApproveKey", function() { return genApproveKey; });
/* harmony import */ var _common_address__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../common/address */ "./src/common/address.ts");
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../common/error */ "./src/common/error.ts");
/* harmony import */ var _core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../core/state/dataEntryPrefix */ "./src/core/state/dataEntryPrefix.ts");
/* harmony import */ var _core_state_storageItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../core/state/storageItem */ "./src/core/state/storageItem.ts");
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../vm/utils/writer */ "./src/vm/utils/writer.ts");
/* harmony import */ var _utils_store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils/store */ "./src/smartcontract/service/native/utils/store.ts");






const UNBOUND_TIME_OFFSET = 'unboundTimeOffset';
const TOTAL_SUPPLY_NAME = 'totalSupply';
const INIT_NAME = 'init';
const TRANSFER_NAME = 'transfer';
const APPROVE_NAME = 'approve';
const TRANSFERFROM_NAME = 'transferFrom';
const NAME_NAME = 'name';
const SYMBOL_NAME = 'symbol';
const DECIMALS_NAME = 'decimals';
const TOTALSUPPLY_NAME = 'totalSupply';
const BALANCEOF_NAME = 'balanceOf';
const ALLOWANCE_NAME = 'allowance';
function addNotifications(native, contract, state) {
    native.addNotification({
        contractAddress: contract,
        states: [state.from.toBase58(), state.to.toBase58(), state.value]
    });
}
function transfer(native, contract, state) {
    if (!native.contextRef.checkWitness(state.from)) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('authentication failed!');
    }
    const fromBalance = fromTransfer(native, genBalanceKey(contract, state.from), state.value);
    const toBalance = toTransfer(native, genBalanceKey(contract, state.to), state.value);
    return { fromBalance, toBalance };
}
function transferedFrom(native, currentContract, state) {
    if (native.contextRef.checkWitness(state.sender) === false) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('authentication failed!');
    }
    fromApprove(native, genTransferFromKey(currentContract, state), state.value);
    const fromBalance = fromTransfer(native, genBalanceKey(currentContract, state.from), state.value);
    const toBalance = toTransfer(native, genBalanceKey(currentContract, state.to), state.value);
    return { fromBalance, toBalance };
}
function getToUInt64StorageItem(toBalance, value) {
    const w = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_4__["Writer"]();
    w.writeUint64(toBalance.add(value));
    return new _core_state_storageItem__WEBPACK_IMPORTED_MODULE_3__["StorageItem"](w.getBytes());
}
function genTotalSupplyKey(contract) {
    return Buffer.concat([contract.toArray(), new Buffer(TOTAL_SUPPLY_NAME)]);
}
function genBalanceKey(contract, addr) {
    return Buffer.concat([contract.toArray(), addr.toArray()]);
}
function fromTransfer(native, fromKey, value) {
    const fromBalance = Object(_utils_store__WEBPACK_IMPORTED_MODULE_5__["getStorageUInt64"])(native, fromKey);
    if (fromBalance.lt(value)) {
        const addr = _common_address__WEBPACK_IMPORTED_MODULE_0__["Address"].parseFromBytes(fromKey.slice(20));
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[Transfer] balance insufficient. contract:${native.contextRef.currentContext()
        // tslint:disable-next-line:max-line-length
        .contractAddress.toHexString()}, account:${addr.toBase58()},balance:${fromBalance.toString()}, transfer amount:${value.toString()}`);
    } else if (fromBalance.eq(value)) {
        native.stateStore.delete(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_2__["ST_STORAGE"], fromKey);
    } else {
        native.stateStore.add(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_2__["ST_STORAGE"], fromKey, Object(_utils_store__WEBPACK_IMPORTED_MODULE_5__["genUInt64StorageItem"])(fromBalance.subtract(value)));
    }
    return fromBalance;
}
function toTransfer(native, toKey, value) {
    const toBalance = Object(_utils_store__WEBPACK_IMPORTED_MODULE_5__["getStorageUInt64"])(native, toKey);
    native.stateStore.add(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_2__["ST_STORAGE"], toKey, getToUInt64StorageItem(toBalance, value));
    return toBalance;
}
function getUnboundOffset(native, contract, address) {
    return Object(_utils_store__WEBPACK_IMPORTED_MODULE_5__["getStorageUInt32"])(native, genAddressUnboundOffsetKey(contract, address));
}
function genTransferFromKey(contract, state) {
    return Buffer.concat([contract.toArray(), state.from.toArray(), state.sender.toArray()]);
}
function fromApprove(native, fromApproveKey, value) {
    const approveValue = Object(_utils_store__WEBPACK_IMPORTED_MODULE_5__["getStorageUInt64"])(native, fromApproveKey);
    if (approveValue.lessThan(value)) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[TransferFrom] approve balance insufficient! have ${approveValue}, got ${value}`);
    } else if (approveValue === value) {
        native.stateStore.delete(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_2__["ST_STORAGE"], fromApproveKey);
    } else {
        native.stateStore.add(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_2__["ST_STORAGE"], fromApproveKey, Object(_utils_store__WEBPACK_IMPORTED_MODULE_5__["genUInt64StorageItem"])(approveValue.subtract(value)));
    }
}
function genAddressUnboundOffsetKey(contract, address) {
    return Buffer.concat([contract.toArray(), new Buffer(UNBOUND_TIME_OFFSET), address.toArray()]);
}
function genApproveKey(contract, from, to) {
    return Buffer.concat([contract.toArray(), from.toArray(), to.toArray()]);
}

/***/ }),

/***/ "./src/smartcontract/service/native/utils/params.ts":
/*!**********************************************************!*\
  !*** ./src/smartcontract/service/native/utils/params.ts ***!
  \**********************************************************/
/*! exports provided: BYTE_FALSE, BYTE_TRUE, OntContractAddress, OngContractAddress, OntIDContractAddress, ParamContractAddress, AuthContractAddress, GovernanceContractAddress */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BYTE_FALSE", function() { return BYTE_FALSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BYTE_TRUE", function() { return BYTE_TRUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OntContractAddress", function() { return OntContractAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OngContractAddress", function() { return OngContractAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OntIDContractAddress", function() { return OntIDContractAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParamContractAddress", function() { return ParamContractAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthContractAddress", function() { return AuthContractAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GovernanceContractAddress", function() { return GovernanceContractAddress; });
/* harmony import */ var _common_address__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../common/address */ "./src/common/address.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */

const BYTE_FALSE = new Buffer('\x00');
const BYTE_TRUE = new Buffer('\x01');
const OntContractAddress = _common_address__WEBPACK_IMPORTED_MODULE_0__["Address"].parseFromBytes(new Buffer('0000000000000000000000000000000000000001', 'hex'));
const OngContractAddress = _common_address__WEBPACK_IMPORTED_MODULE_0__["Address"].parseFromBytes(new Buffer('0000000000000000000000000000000000000002', 'hex'));
const OntIDContractAddress = _common_address__WEBPACK_IMPORTED_MODULE_0__["Address"].parseFromBytes(new Buffer('0000000000000000000000000000000000000003', 'hex'));
const ParamContractAddress = _common_address__WEBPACK_IMPORTED_MODULE_0__["Address"].parseFromBytes(new Buffer('0000000000000000000000000000000000000004', 'hex'));
const AuthContractAddress = _common_address__WEBPACK_IMPORTED_MODULE_0__["Address"].parseFromBytes(new Buffer('0000000000000000000000000000000000000006', 'hex'));
const GovernanceContractAddress = _common_address__WEBPACK_IMPORTED_MODULE_0__["Address"].parseFromBytes(new Buffer('0000000000000000000000000000000000000007', 'hex'));

/***/ }),

/***/ "./src/smartcontract/service/native/utils/serialization.ts":
/*!*****************************************************************!*\
  !*** ./src/smartcontract/service/native/utils/serialization.ts ***!
  \*****************************************************************/
/*! exports provided: readVarUint, readAddress, writeAddress, writeVarUint, decodeVarUint, decodeAddress, encodeAddress, encodeVarUint */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readVarUint", function() { return readVarUint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readAddress", function() { return readAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeAddress", function() { return writeAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeVarUint", function() { return writeVarUint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decodeVarUint", function() { return decodeVarUint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decodeAddress", function() { return decodeAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encodeAddress", function() { return encodeAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encodeVarUint", function() { return encodeVarUint; });
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! big-integer */ "big-integer");
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(big_integer__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! long */ "long");
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(long__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _common_address__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../common/address */ "./src/common/address.ts");
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../common/error */ "./src/common/error.ts");
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../common/utils */ "./src/common/utils.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */





function readVarUint(r) {
    return decodeVarUint(r);
}
function readAddress(r) {
    return decodeAddress(r);
}
function writeAddress(w, address) {
    encodeAddress(w, address);
}
function writeVarUint(w, value) {
    encodeVarUint(w, value);
}
function decodeVarUint(r) {
    const value = r.readVarBytes();
    const v = long__WEBPACK_IMPORTED_MODULE_1__["fromString"](Object(_common_utils__WEBPACK_IMPORTED_MODULE_4__["bigIntFromBytes"])(value).toString());
    if (v.lessThan(0)) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_3__["TracedError"]('value should not be a negative number.');
    }
    return v;
}
function decodeAddress(source) {
    const from = source.readVarBytes();
    return _common_address__WEBPACK_IMPORTED_MODULE_2__["Address"].parseFromBytes(from);
}
function encodeAddress(sink, addr) {
    sink.writeVarBytes(addr.toArray());
}
function encodeVarUint(sink, value) {
    sink.writeVarBytes(Object(_common_utils__WEBPACK_IMPORTED_MODULE_4__["bigIntToBytes"])(big_integer__WEBPACK_IMPORTED_MODULE_0__(value.toString())));
}

/***/ }),

/***/ "./src/smartcontract/service/native/utils/store.ts":
/*!*********************************************************!*\
  !*** ./src/smartcontract/service/native/utils/store.ts ***!
  \*********************************************************/
/*! exports provided: getStorageItem, getStorageUInt64, genUInt64StorageItem, getStorageUInt32, genUInt32StorageItem */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStorageItem", function() { return getStorageItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStorageUInt64", function() { return getStorageUInt64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "genUInt64StorageItem", function() { return genUInt64StorageItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStorageUInt32", function() { return getStorageUInt32; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "genUInt32StorageItem", function() { return genUInt32StorageItem; });
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! long */ "long");
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(long__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../common/error */ "./src/common/error.ts");
/* harmony import */ var _core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../core/state/dataEntryPrefix */ "./src/core/state/dataEntryPrefix.ts");
/* harmony import */ var _core_state_storageItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../core/state/storageItem */ "./src/core/state/storageItem.ts");
/* harmony import */ var _vm_utils_reader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../vm/utils/reader */ "./src/vm/utils/reader.ts");
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../vm/utils/writer */ "./src/vm/utils/writer.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */






function getStorageItem(native, key) {
    const store = native.stateStore.get(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_2__["ST_STORAGE"], key);
    if (store === undefined) {
        return undefined;
    }
    if (Object(_core_state_storageItem__WEBPACK_IMPORTED_MODULE_3__["isStorageItem"])(store.value)) {
        return store.value;
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[GetStorageItem] instance does not StorageItem!');
    }
}
function getStorageUInt64(native, key) {
    const item = getStorageItem(native, key);
    if (item === undefined) {
        return long__WEBPACK_IMPORTED_MODULE_0__["ZERO"];
    }
    return new _vm_utils_reader__WEBPACK_IMPORTED_MODULE_4__["Reader"](item.getValue()).readUInt64();
}
function genUInt64StorageItem(value) {
    const w = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_5__["Writer"]();
    w.writeUint64(value);
    return new _core_state_storageItem__WEBPACK_IMPORTED_MODULE_3__["StorageItem"](w.getBytes());
}
function getStorageUInt32(native, key) {
    const item = getStorageItem(native, key);
    if (item === undefined) {
        return 0;
    }
    return new _vm_utils_reader__WEBPACK_IMPORTED_MODULE_4__["Reader"](item.getValue()).readUInt32();
}
function genUInt32StorageItem(value) {
    const w = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_5__["Writer"]();
    w.writeUint32(value);
    return new _core_state_storageItem__WEBPACK_IMPORTED_MODULE_3__["StorageItem"](w.getBytes());
}

/***/ }),

/***/ "./src/smartcontract/service/native/utils/unbindOng.ts":
/*!*************************************************************!*\
  !*** ./src/smartcontract/service/native/utils/unbindOng.ts ***!
  \*************************************************************/
/*! exports provided: calcUnbindOng */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calcUnbindOng", function() { return calcUnbindOng; });
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! long */ "long");
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(long__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../common/constants */ "./src/common/constants.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */


// startOffset : start timestamp offset from genesis block
// endOffset :  end timestamp offset from genesis block
function calcUnbindOng(balance, startOffset, endOffset) {
    let amount = long__WEBPACK_IMPORTED_MODULE_0__["ZERO"];
    if (startOffset >= endOffset) {
        return long__WEBPACK_IMPORTED_MODULE_0__["ZERO"];
    }
    if (startOffset < _common_constants__WEBPACK_IMPORTED_MODULE_1__["UNBOUND_DEADLINE"]) {
        let ustart = startOffset / _common_constants__WEBPACK_IMPORTED_MODULE_1__["UNBOUND_TIME_INTERVAL"];
        let istart = startOffset % _common_constants__WEBPACK_IMPORTED_MODULE_1__["UNBOUND_TIME_INTERVAL"];
        if (endOffset >= _common_constants__WEBPACK_IMPORTED_MODULE_1__["UNBOUND_DEADLINE"]) {
            endOffset = _common_constants__WEBPACK_IMPORTED_MODULE_1__["UNBOUND_DEADLINE"];
        }
        const uend = endOffset / _common_constants__WEBPACK_IMPORTED_MODULE_1__["UNBOUND_TIME_INTERVAL"];
        const iend = endOffset % _common_constants__WEBPACK_IMPORTED_MODULE_1__["UNBOUND_TIME_INTERVAL"];
        while (ustart < uend) {
            amount = amount.add(long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](_common_constants__WEBPACK_IMPORTED_MODULE_1__["UNBOUND_TIME_INTERVAL"] - istart).mul(_common_constants__WEBPACK_IMPORTED_MODULE_1__["UNBOUND_GENERATION_AMOUNT"][ustart]));
            ustart++;
            istart = 0;
        }
        amount = amount.add(long__WEBPACK_IMPORTED_MODULE_0__["fromNumber"](iend - istart).mul(_common_constants__WEBPACK_IMPORTED_MODULE_1__["UNBOUND_GENERATION_AMOUNT"][ustart]));
    }
    return amount.mul(balance);
}

/***/ }),

/***/ "./src/smartcontract/service/runtime.ts":
/*!**********************************************!*\
  !*** ./src/smartcontract/service/runtime.ts ***!
  \**********************************************/
/*! exports provided: runtimeGetTime, runtimeCheckWitness, runtimeSerialize, runtimeDeserialize, runtimeNotify, runtimeLog, runtimeGetTrigger, runtimeBase58ToAddress, runtimeAddressToBase58, runtimeGetRandomHash, serializeStackItem, deserializeStackItem, circularRefAndDepthDetection */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runtimeGetTime", function() { return runtimeGetTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runtimeCheckWitness", function() { return runtimeCheckWitness; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runtimeSerialize", function() { return runtimeSerialize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runtimeDeserialize", function() { return runtimeDeserialize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runtimeNotify", function() { return runtimeNotify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runtimeLog", function() { return runtimeLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runtimeGetTrigger", function() { return runtimeGetTrigger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runtimeBase58ToAddress", function() { return runtimeBase58ToAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runtimeAddressToBase58", function() { return runtimeAddressToBase58; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runtimeGetRandomHash", function() { return runtimeGetRandomHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "serializeStackItem", function() { return serializeStackItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deserializeStackItem", function() { return deserializeStackItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "circularRefAndDepthDetection", function() { return circularRefAndDepthDetection; });
/* harmony import */ var _common_address__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/address */ "./src/common/address.ts");
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../common/utils */ "./src/common/utils.ts");
/* harmony import */ var _crypto_publicKey__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../crypto/publicKey */ "./src/crypto/publicKey.ts");
/* harmony import */ var _vm_consts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../vm/consts */ "./src/vm/consts.ts");
/* harmony import */ var _vm_func_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../vm/func/common */ "./src/vm/func/common.ts");
/* harmony import */ var _vm_types_array__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../vm/types/array */ "./src/vm/types/array.ts");
/* harmony import */ var _vm_types_boolean__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../vm/types/boolean */ "./src/vm/types/boolean.ts");
/* harmony import */ var _vm_types_byteArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../vm/types/byteArray */ "./src/vm/types/byteArray.ts");
/* harmony import */ var _vm_types_integer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../vm/types/integer */ "./src/vm/types/integer.ts");
/* harmony import */ var _vm_types_map__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../vm/types/map */ "./src/vm/types/map.ts");
/* harmony import */ var _vm_types_struct__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../vm/types/struct */ "./src/vm/types/struct.ts");
/* harmony import */ var _vm_utils_reader__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../vm/utils/reader */ "./src/vm/utils/reader.ts");
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../vm/utils/writer */ "./src/vm/utils/writer.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../common */ "./src/smartcontract/common.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */















/**
 * HeaderGetNextConsensus put current block time to vm stack
 */
function runtimeGetTime(service, engine) {
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["pushData"])(engine, service.getTime());
}
/**
 * RuntimeCheckWitness provide check permissions service.
 * If param address isn't exist in authorization list, check fail
 */
function runtimeCheckWitness(service, engine) {
    const data = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["popByteArray"])(engine);
    let result;
    if (data.length === 20) {
        const address = _common_address__WEBPACK_IMPORTED_MODULE_0__["Address"].parseFromBytes(data);
        result = service.getContextRef().checkWitness(address);
    } else {
        try {
            const pk = _crypto_publicKey__WEBPACK_IMPORTED_MODULE_3__["PublicKey"].deserialize(data);
            result = service.getContextRef().checkWitness(_common_address__WEBPACK_IMPORTED_MODULE_0__["Address"].fromPubKey(pk));
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`[RuntimeCheckWitness] data invalid: ${e}`);
        }
    }
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["pushData"])(engine, result);
}
function runtimeSerialize(service, engine) {
    const item = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["popStackItem"])(engine);
    const buf = serializeStackItem(item);
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["pushData"])(engine, buf);
}
function runtimeDeserialize(service, engine) {
    const data = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["popByteArray"])(engine);
    const item = deserializeStackItem(data);
    if (item !== undefined) {
        Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["pushData"])(engine, item);
    }
}
// RuntimeNotify put smart contract execute event notify to notifications
function runtimeNotify(service, engine) {
    const item = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["popStackItem"])(engine);
    const context = service.getContextRef().currentContext();
    if (context === undefined) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[RuntimeNotify] No context present');
    }
    service.addNotification({ contractAddress: context.contractAddress, states: Object(_common__WEBPACK_IMPORTED_MODULE_14__["convertNeoVmTypeHexString"])(item) });
}
// RuntimeLog push smart contract execute event log to client
function runtimeLog(service, engine) {
    const item = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["popByteArray"])(engine);
    const context = service.getContextRef().currentContext();
    if (context === undefined) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[RuntimeNotify] No context present');
    }
    service.addLog({ contractAddress: context.contractAddress, message: item.toString(), tx: service.getTx().getHash() });
}
function runtimeGetTrigger(service, engine) {
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["pushData"])(engine, 0);
}
function runtimeBase58ToAddress(service, engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[RuntimeBase58ToAddress] Too few input parameters');
    }
    const item = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["popByteArray"])(engine);
    const address = _common_address__WEBPACK_IMPORTED_MODULE_0__["Address"].fromBase58(item.toString());
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["pushData"])(engine, address.toArray());
}
function runtimeAddressToBase58(service, engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('[RuntimeAddressToBase58] Too few input parameters');
    }
    const item = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["popByteArray"])(engine);
    const address = _common_address__WEBPACK_IMPORTED_MODULE_0__["Address"].parseFromBytes(item);
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["pushData"])(engine, new Buffer(address.toBase58()));
}
function runtimeGetRandomHash(service, engine) {
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["pushData"])(engine, service.getRandomHash().toArray());
}
function serializeStackItem(item) {
    if (circularRefAndDepthDetection(item)) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('runtime serialize: can not serialize circular reference data');
    }
    const writer = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_13__["LimitedWriter"](_vm_consts__WEBPACK_IMPORTED_MODULE_4__["MAX_BYTEARRAY_SIZE"]);
    serializeStackItemInternal(item, writer);
    return writer.getBytes();
}
function deserializeStackItem(data) {
    const r = new _vm_utils_reader__WEBPACK_IMPORTED_MODULE_12__["Reader"](data);
    return deserializeStackItemInternal(r);
}
function serializeStackItemInternal(item, w) {
    if (Object(_vm_types_byteArray__WEBPACK_IMPORTED_MODULE_8__["isByteArrayType"])(item)) {
        try {
            w.writeUint8(_vm_types_byteArray__WEBPACK_IMPORTED_MODULE_8__["ByteArrayType"].id);
            const ba = item.getByteArray();
            w.writeVarBytes(ba);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`Serialize ByteArray stackItems error.`, e);
        }
    } else if (Object(_vm_types_boolean__WEBPACK_IMPORTED_MODULE_7__["isBooleanType"])(item)) {
        try {
            w.writeUint8(_vm_types_boolean__WEBPACK_IMPORTED_MODULE_7__["BooleanType"].id);
            const b = item.getBoolean();
            w.writeUint8(b ? 1 : 0);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`Serialize Boolean stackItems error:`, e);
        }
    } else if (Object(_vm_types_integer__WEBPACK_IMPORTED_MODULE_9__["isIntegerType"])(item)) {
        try {
            w.writeUint8(_vm_types_integer__WEBPACK_IMPORTED_MODULE_9__["IntegerType"].id);
            const i = item.getByteArray();
            w.writeVarBytes(i);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`Serialize Integer stackItems error.`, e);
        }
    } else if (Object(_vm_types_array__WEBPACK_IMPORTED_MODULE_6__["isArrayType"])(item)) {
        try {
            w.writeUint8(_vm_types_array__WEBPACK_IMPORTED_MODULE_6__["ArrayType"].id);
            const a = item.getArray();
            w.writeVarUint(a.length);
            for (const v of a) {
                serializeStackItemInternal(v, w);
            }
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`Serialize Array stackItems error.`, e);
        }
    } else if (Object(_vm_types_struct__WEBPACK_IMPORTED_MODULE_11__["isStructType"])(item)) {
        try {
            w.writeUint8(_vm_types_struct__WEBPACK_IMPORTED_MODULE_11__["StructType"].id);
            const a = item.getStruct();
            w.writeVarUint(a.length);
            for (const v of a) {
                serializeStackItemInternal(v, w);
            }
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`Serialize Struct stackItems error.`, e);
        }
    } else if (Object(_vm_types_map__WEBPACK_IMPORTED_MODULE_10__["isMapType"])(item)) {
        const unsortKey = [];
        const keyMap = new Map();
        const mp = item.getMap();
        try {
            w.writeUint8(_vm_types_map__WEBPACK_IMPORTED_MODULE_10__["MapType"].id);
            w.writeVarUint(mp.size);
            for (const [k] of mp.entries()) {
                if (Object(_vm_types_byteArray__WEBPACK_IMPORTED_MODULE_8__["isByteArrayType"])(k) || Object(_vm_types_integer__WEBPACK_IMPORTED_MODULE_9__["isIntegerType"])(k)) {
                    const ba = k.getByteArray();
                    const key = ba.toString();
                    if (key === '') {
                        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('Serialize Map error: invalid key type');
                    }
                    unsortKey.push(key);
                    keyMap.set(key, k);
                } else {
                    throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('Unsupport map key type.');
                }
            }
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`Serialize Struct stackItems error.`, e);
        }
        unsortKey.sort();
        for (const v of unsortKey) {
            const key = keyMap.get(v);
            serializeStackItemInternal(key, w);
            serializeStackItemInternal(mp.get(key), w);
        }
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('unknown type');
    }
}
function deserializeStackItemInternal(r) {
    try {
        const t = r.readByte();
        if (t === _vm_types_byteArray__WEBPACK_IMPORTED_MODULE_8__["ByteArrayType"].id) {
            try {
                const b = r.readVarBytes();
                return new _vm_types_byteArray__WEBPACK_IMPORTED_MODULE_8__["ByteArrayType"](b);
            } catch (e) {
                throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`Deserialize stackItems ByteArray error.`, e);
            }
        } else if (t === _vm_types_boolean__WEBPACK_IMPORTED_MODULE_7__["BooleanType"].id) {
            try {
                const b = r.readByte() > 0;
                return new _vm_types_boolean__WEBPACK_IMPORTED_MODULE_7__["BooleanType"](b);
            } catch (e) {
                throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`Deserialize stackItems Boolean error.`, e);
            }
        } else if (t === _vm_types_integer__WEBPACK_IMPORTED_MODULE_9__["IntegerType"].id) {
            try {
                const b = r.readVarBytes();
                return new _vm_types_integer__WEBPACK_IMPORTED_MODULE_9__["IntegerType"](Object(_common_utils__WEBPACK_IMPORTED_MODULE_2__["bigIntFromBytes"])(b));
            } catch (e) {
                throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`Deserialize stackItems Integer error.`, e);
            }
        } else if (t === _vm_types_array__WEBPACK_IMPORTED_MODULE_6__["ArrayType"].id || t === _vm_types_struct__WEBPACK_IMPORTED_MODULE_11__["StructType"].id) {
            try {
                const count = r.readVarUInt().toNumber();
                const arr = [];
                for (let i = 0; i < count; i++) {
                    const item = deserializeStackItemInternal(r);
                    arr.push(item);
                }
                if (t === _vm_types_struct__WEBPACK_IMPORTED_MODULE_11__["StructType"].id) {
                    return new _vm_types_struct__WEBPACK_IMPORTED_MODULE_11__["StructType"](arr);
                } else {
                    return new _vm_types_array__WEBPACK_IMPORTED_MODULE_6__["ArrayType"](arr);
                }
            } catch (e) {
                throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`Deserialize stackItems error.`, e);
            }
        } else if (t === _vm_types_map__WEBPACK_IMPORTED_MODULE_10__["MapType"].id) {
            try {
                const count = r.readVarUInt().toNumber();
                const mp = new _vm_types_map__WEBPACK_IMPORTED_MODULE_10__["MapType"]();
                const m = mp.getMap();
                for (let i = 0; i < count; i++) {
                    const key = deserializeStackItemInternal(r);
                    const value = deserializeStackItemInternal(r);
                    m.set(key, value);
                }
                return mp;
            } catch (e) {
                throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`Deserialize stackItems map error.`, e);
            }
        } else {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('unknown type');
        }
    } catch (e) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"](`Deserialize error.`, e);
    }
}
function circularRefAndDepthDetection(value) {
    return circularRefAndDepthDetectionInternal(value, new Map(), 0);
}
function circularRefAndDepthDetectionInternal(value, visited, depth) {
    if (depth > _vm_types_struct__WEBPACK_IMPORTED_MODULE_11__["MAX_STRUCT_DEPTH"]) {
        return true;
    }
    if (Object(_vm_types_array__WEBPACK_IMPORTED_MODULE_6__["isArrayType"])(value)) {
        const a = value.getArray();
        if (a.length === 0) {
            return false;
        }
        if (visited.get(a)) {
            return true;
        }
        visited.set(a, true);
        for (const v of a) {
            if (circularRefAndDepthDetectionInternal(v, visited, depth + 1)) {
                return true;
            }
        }
        visited.delete(a);
        return false;
    } else if (Object(_vm_types_struct__WEBPACK_IMPORTED_MODULE_11__["isStructType"])(value)) {
        const s = value.getStruct();
        if (s.length === 0) {
            return false;
        }
        if (visited.get(s)) {
            return true;
        }
        visited.set(s, true);
        for (const v of s) {
            if (circularRefAndDepthDetectionInternal(v, visited, depth + 1)) {
                return true;
            }
        }
        visited.delete(s);
        return false;
    } else if (Object(_vm_types_map__WEBPACK_IMPORTED_MODULE_10__["isMapType"])(value)) {
        const mp = value.getMap();
        if (visited.get(mp)) {
            return true;
        }
        visited.set(mp, true);
        for (const [k, v] of mp.entries()) {
            if (circularRefAndDepthDetectionInternal(k, visited, depth + 1)) {
                return true;
            }
            if (circularRefAndDepthDetectionInternal(v, visited, depth + 1)) {
                return true;
            }
        }
        visited.delete(mp);
        return false;
    } else {
        return false;
    }
}

/***/ }),

/***/ "./src/smartcontract/service/storage.ts":
/*!**********************************************!*\
  !*** ./src/smartcontract/service/storage.ts ***!
  \**********************************************/
/*! exports provided: storagePut, storageDelete, storageGet, storageGetContext, storageGetReadOnlyContext, checkStorageContext, getContext, getStorageKey */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storagePut", function() { return storagePut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storageDelete", function() { return storageDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storageGet", function() { return storageGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storageGetContext", function() { return storageGetContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storageGetReadOnlyContext", function() { return storageGetReadOnlyContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkStorageContext", function() { return checkStorageContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStorageKey", function() { return getStorageKey; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/* harmony import */ var _core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/state/dataEntryPrefix */ "./src/core/state/dataEntryPrefix.ts");
/* harmony import */ var _core_state_storageItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../core/state/storageItem */ "./src/core/state/storageItem.ts");
/* harmony import */ var _vm_func_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../vm/func/common */ "./src/vm/func/common.ts");
/* harmony import */ var _vm_utils_writer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../vm/utils/writer */ "./src/vm/utils/writer.ts");
/* harmony import */ var _storageContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../storageContext */ "./src/smartcontract/storageContext.ts");






/**
 * StoragePut put smart contract storage item to cache
 */
function storagePut(service, engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["evaluationStackCount"])(engine) < 3) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[Context] Too few input parameters ');
    }
    try {
        const context = getContext(engine);
        if (context.isReadOnly()) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[StoragePut] storage read only!');
        }
        try {
            checkStorageContext(service, context);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"](`[StoragePut] check context error.`, e);
        }
        const key = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["popByteArray"])(engine);
        if (key.length > 1024) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[StoragePut] Storage key to long');
        }
        const value = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["popByteArray"])(engine);
        service.getStateStore().add(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_1__["ST_STORAGE"], getStorageKey(context.getAddress(), key), new _core_state_storageItem__WEBPACK_IMPORTED_MODULE_2__["StorageItem"](value));
    } catch (e) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[StoragePut] get pop context error!', e);
    }
}
/**
 * StorageDelete delete smart contract storage item from cache
 */
function storageDelete(service, engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["evaluationStackCount"])(engine) < 2) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[Context] Too few input parameters ');
    }
    try {
        const context = getContext(engine);
        if (context.isReadOnly()) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[StorageDelete] storage read only!');
        }
        try {
            checkStorageContext(service, context);
        } catch (e) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"](`[StorageDelete] check context error.`, e);
        }
        const ba = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["popByteArray"])(engine);
        service.getStateStore().delete(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_1__["ST_STORAGE"], getStorageKey(context.getAddress(), ba));
    } catch (e) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[StorageDelete] get pop context error!', e);
    }
}
/**
 * StorageGet push smart contract storage item from cache to vm stack
 */
function storageGet(service, engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["evaluationStackCount"])(engine) < 2) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[Context] Too few input parameters ');
    }
    try {
        const context = getContext(engine);
        const ba = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["popByteArray"])(engine);
        const item = service.getStateStore().get(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_1__["ST_STORAGE"], getStorageKey(context.getAddress(), ba));
        if (item === undefined) {
            Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["pushData"])(engine, new Buffer(''));
        } else {
            if (Object(_core_state_storageItem__WEBPACK_IMPORTED_MODULE_2__["isStorageItem"])(item.value)) {
                Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["pushData"])(engine, item.value.getValue());
            }
        }
    } catch (e) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"](`[StorageGet] get pop context error.`, e);
    }
}
/**
 * StorageGetContext push smart contract storage context to vm stack
 */
function storageGetContext(service, engine) {
    const ctx = service.getContextRef().currentContext();
    if (ctx === undefined) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[storageGetContext] Context is empty');
    }
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["pushData"])(engine, new _storageContext__WEBPACK_IMPORTED_MODULE_5__["StorageContext"](ctx.contractAddress));
}
function storageGetReadOnlyContext(service, engine) {
    const ctx = service.getContextRef().currentContext();
    if (ctx === undefined) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[storageGetContext] Context is empty');
    }
    const context = new _storageContext__WEBPACK_IMPORTED_MODULE_5__["StorageContext"](ctx.contractAddress);
    context.setReadOnly(true);
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["pushData"])(engine, context);
}
function checkStorageContext(service, context) {
    try {
        const item = service.getStateStore().get(_core_state_dataEntryPrefix__WEBPACK_IMPORTED_MODULE_1__["ST_CONTRACT"], context.getAddress().toArray());
        if (item === undefined) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[CheckStorageContext] get context null!');
        }
    } catch (e) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[CheckStorageContext] get context fail!', e);
    }
}
function getContext(engine) {
    const opInterface = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_3__["popInteropInterface"])(engine);
    if (Object(_storageContext__WEBPACK_IMPORTED_MODULE_5__["isStorageContext"])(opInterface)) {
        return opInterface;
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[Context] Get storageContext invalid');
    }
}
function getStorageKey(address, key) {
    const w = new _vm_utils_writer__WEBPACK_IMPORTED_MODULE_4__["Writer"]();
    w.writeBytes(address.toArray());
    w.writeBytes(key);
    return w.getBytes();
}

/***/ }),

/***/ "./src/smartcontract/service/storageContext.ts":
/*!*****************************************************!*\
  !*** ./src/smartcontract/service/storageContext.ts ***!
  \*****************************************************/
/*! exports provided: storageContextAsReadOnly */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storageContextAsReadOnly", function() { return storageContextAsReadOnly; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/* harmony import */ var _vm_func_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../vm/func/common */ "./src/vm/func/common.ts");
/* harmony import */ var _storageContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../storageContext */ "./src/smartcontract/storageContext.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */



function storageContextAsReadOnly(service, engine) {
    const data = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["popInteropInterface"])(engine);
    if (Object(_storageContext__WEBPACK_IMPORTED_MODULE_2__["isStorageContext"])(data)) {
        let context = data;
        if (!context.isReadOnly()) {
            context = new _storageContext__WEBPACK_IMPORTED_MODULE_2__["StorageContext"](context.getAddress());
            context.setReadOnly(true);
        }
        Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["pushData"])(engine, context);
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('pop storage context type invalid');
    }
}

/***/ }),

/***/ "./src/smartcontract/service/system.ts":
/*!*********************************************!*\
  !*** ./src/smartcontract/service/system.ts ***!
  \*********************************************/
/*! exports provided: getCodeContainer, getExecutingAddress, getCallingAddress, getEntryAddress */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCodeContainer", function() { return getCodeContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getExecutingAddress", function() { return getExecutingAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCallingAddress", function() { return getCallingAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEntryAddress", function() { return getEntryAddress; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/* harmony import */ var _vm_func_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../vm/func/common */ "./src/vm/func/common.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */


/**
 * GetCodeContainer push current transaction to vm stack
 */
function getCodeContainer(service, engine) {
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["pushData"])(engine, service.getTx());
}
/**
 * GetExecutingAddress push current context to vm stack
 */
function getExecutingAddress(service, engine) {
    const context = service.getContextRef().currentContext();
    if (context === undefined) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Current context invalid');
    }
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["pushData"])(engine, context.contractAddress.toArray());
}
/**
 * GetExecutingAddress push previous context to vm stack
 */
function getCallingAddress(service, engine) {
    const context = service.getContextRef().callingContext();
    if (context === undefined) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Calling context invalid');
    }
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["pushData"])(engine, context.contractAddress.toArray());
}
/**
 * GetExecutingAddress push entry call context to vm stack
 */
function getEntryAddress(service, engine) {
    const context = service.getContextRef().entryContext();
    if (context === undefined) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Entry context invalid');
    }
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["pushData"])(engine, context.contractAddress.toArray());
}

/***/ }),

/***/ "./src/smartcontract/service/transaction.ts":
/*!**************************************************!*\
  !*** ./src/smartcontract/service/transaction.ts ***!
  \**************************************************/
/*! exports provided: transactionGetHash, transactionGetType, transactionGetAttributes */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transactionGetHash", function() { return transactionGetHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transactionGetType", function() { return transactionGetType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transactionGetAttributes", function() { return transactionGetAttributes; });
/* harmony import */ var _core_transaction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../core/transaction */ "./src/core/transaction.ts");
/* harmony import */ var _vm_func_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../vm/func/common */ "./src/vm/func/common.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */


/**
 * GetExecutingAddress push transaction's hash to vm stack
 */
function transactionGetHash(service, engine) {
    const txn = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["popInteropInterface"])(engine);
    if (Object(_core_transaction__WEBPACK_IMPORTED_MODULE_0__["isTransaction"])(txn)) {
        const txHash = txn.getHash();
        Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["pushData"])(engine, txHash.toArray());
    }
}
/**
 * TransactionGetType push transaction's type to vm stack
 */
function transactionGetType(service, engine) {
    const txn = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["popInteropInterface"])(engine);
    if (Object(_core_transaction__WEBPACK_IMPORTED_MODULE_0__["isTransaction"])(txn)) {
        Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["pushData"])(engine, txn.getTxType());
    }
}
/**
 * TransactionGetAttributes push transaction's attributes to vm stack
 */
function transactionGetAttributes(service, engine) {
    const txn = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["popInteropInterface"])(engine);
    if (Object(_core_transaction__WEBPACK_IMPORTED_MODULE_0__["isTransaction"])(txn)) {
        const attributList = [];
        Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_1__["pushData"])(engine, attributList);
    }
}

/***/ }),

/***/ "./src/smartcontract/service/validate.ts":
/*!***********************************************!*\
  !*** ./src/smartcontract/service/validate.ts ***!
  \***********************************************/
/*! exports provided: validatorAttribute, validatorBlock, validatorBlockTransaction, validatorBlockChainHeader, validatorBlockChainBlock, validatorBlockChainTransaction, validatorBlockChainContract, validatorHeader, validatorTransaction, validatorGetCode, validatorCheckWitness, validatorNotify, validatorLog, validatorSerialize, validatorDeserialize, validatorContextAsReadOnly */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorAttribute", function() { return validatorAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorBlock", function() { return validatorBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorBlockTransaction", function() { return validatorBlockTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorBlockChainHeader", function() { return validatorBlockChainHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorBlockChainBlock", function() { return validatorBlockChainBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorBlockChainTransaction", function() { return validatorBlockChainTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorBlockChainContract", function() { return validatorBlockChainContract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorHeader", function() { return validatorHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorTransaction", function() { return validatorTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorGetCode", function() { return validatorGetCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorCheckWitness", function() { return validatorCheckWitness; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorNotify", function() { return validatorNotify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorLog", function() { return validatorLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorSerialize", function() { return validatorSerialize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorDeserialize", function() { return validatorDeserialize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorContextAsReadOnly", function() { return validatorContextAsReadOnly; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/* harmony import */ var _core_block__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/block */ "./src/core/block.ts");
/* harmony import */ var _core_payload_deployCode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../core/payload/deployCode */ "./src/core/payload/deployCode.ts");
/* harmony import */ var _core_transaction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../core/transaction */ "./src/core/transaction.ts");
/* harmony import */ var _core_transactionAttribute__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../core/transactionAttribute */ "./src/core/transactionAttribute.ts");
/* harmony import */ var _vm_func_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../vm/func/common */ "./src/vm/func/common.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */






function validatorAttribute(engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorAttribute] Too few input parameters ');
    }
    const d = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["peekInteropInterface"])(engine);
    if (!Object(_core_transactionAttribute__WEBPACK_IMPORTED_MODULE_4__["isTransactionAttribute"])(d)) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorAttribute] Wrong type!');
    }
}
function validatorBlock(engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[Block] Too few input parameters ');
    }
    try {
        peekBlock(engine);
    } catch (e) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"](`[validatorBlock] Validate block fail.`, e);
    }
}
function validatorBlockTransaction(engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 2) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorBlockTransaction] Too few input parameters ');
    }
    try {
        const block = peekBlock(engine);
        const item = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["peekNBigInt"])(1, engine);
        const index = item.toJSNumber();
        if (index < 0) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorBlockTransaction] Pop index invalid!');
        }
        if (index >= block.getTransactions().length) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorBlockTransaction] index invalid!');
        }
    } catch (e) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"](`[validatorBlockTransaction] Validate block fail.`, e);
    }
}
function validatorBlockChainHeader(engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorBlockChainHeader] Too few input parameters ');
    }
}
function validatorBlockChainBlock(engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorBlockChainBlock] Too few input parameters ');
    }
}
function validatorBlockChainTransaction(engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorBlockChainTransaction] Too few input parameters ');
    }
}
function validatorBlockChainContract(engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorBlockChainContract] Too few input parameters ');
    }
}
function validatorHeader(engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorHeader] Too few input parameters ');
    }
    Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["peekInteropInterface"])(engine);
}
function validatorTransaction(engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorTransaction] Too few input parameters ');
    }
    const item = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["peekInteropInterface"])(engine);
    if (!Object(_core_transaction__WEBPACK_IMPORTED_MODULE_3__["isTransaction"])(item)) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorTransaction] Transaction wrong type!');
    }
}
function validatorGetCode(engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorGetCode] Too few input parameters ');
    }
    const item = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["peekInteropInterface"])(engine);
    if (!Object(_core_payload_deployCode__WEBPACK_IMPORTED_MODULE_2__["isDeployCode"])(item)) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorGetCode] DeployCode wrong type!');
    }
}
function validatorCheckWitness(engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorCheckWitness] Too few input parameters ');
    }
}
function validatorNotify(engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorNotify] Too few input parameters ');
    }
}
function validatorLog(engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorLog] Too few input parameters ');
    }
}
function validatorSerialize(engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorSerialize] Too few input parameters ');
    }
}
function validatorDeserialize(engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorDeSerialize] Too few input parameters ');
    }
}
function validatorContextAsReadOnly(engine) {
    if (Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["evaluationStackCount"])(engine) < 1) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[validatorContextAsReadOnly] Too few input parameters ');
    }
}
function peekBlock(engine) {
    const d = Object(_vm_func_common__WEBPACK_IMPORTED_MODULE_5__["peekInteropInterface"])(engine);
    if (Object(_core_block__WEBPACK_IMPORTED_MODULE_1__["isBlock"])(d)) {
        return d;
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('[Block] Wrong type!');
    }
}

/***/ }),

/***/ "./src/smartcontract/serviceMap.ts":
/*!*****************************************!*\
  !*** ./src/smartcontract/serviceMap.ts ***!
  \*****************************************/
/*! exports provided: ServiceMap */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServiceMap", function() { return ServiceMap; });
/* harmony import */ var _consts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./consts */ "./src/smartcontract/consts.ts");
/* harmony import */ var _service_attribute__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./service/attribute */ "./src/smartcontract/service/attribute.ts");
/* harmony import */ var _service_block__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./service/block */ "./src/smartcontract/service/block.ts");
/* harmony import */ var _service_blockchain__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./service/blockchain */ "./src/smartcontract/service/blockchain.ts");
/* harmony import */ var _service_contract__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./service/contract */ "./src/smartcontract/service/contract.ts");
/* harmony import */ var _service_header__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./service/header */ "./src/smartcontract/service/header.ts");
/* harmony import */ var _service_native__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./service/native */ "./src/smartcontract/service/native.ts");
/* harmony import */ var _service_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./service/runtime */ "./src/smartcontract/service/runtime.ts");
/* harmony import */ var _service_storage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./service/storage */ "./src/smartcontract/service/storage.ts");
/* harmony import */ var _service_storageContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./service/storageContext */ "./src/smartcontract/service/storageContext.ts");
/* harmony import */ var _service_system__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./service/system */ "./src/smartcontract/service/system.ts");
/* harmony import */ var _service_transaction__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./service/transaction */ "./src/smartcontract/service/transaction.ts");
/* harmony import */ var _service_validate__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./service/validate */ "./src/smartcontract/service/validate.ts");













const ServiceMap = new Map([[_consts__WEBPACK_IMPORTED_MODULE_0__["ATTRIBUTE_GETUSAGE_NAME"], { execute: _service_attribute__WEBPACK_IMPORTED_MODULE_1__["attributeGetUsage"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorAttribute"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["ATTRIBUTE_GETDATA_NAME"], { execute: _service_attribute__WEBPACK_IMPORTED_MODULE_1__["attributeGetData"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorAttribute"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["BLOCK_GETTRANSACTIONCOUNT_NAME"], { execute: _service_block__WEBPACK_IMPORTED_MODULE_2__["blockGetTransactionCount"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorBlock"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["BLOCK_GETTRANSACTIONS_NAME"], { execute: _service_block__WEBPACK_IMPORTED_MODULE_2__["blockGetTransactions"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorBlock"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["BLOCK_GETTRANSACTION_NAME"], { execute: _service_block__WEBPACK_IMPORTED_MODULE_2__["blockGetTransaction"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorBlockTransaction"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["BLOCKCHAIN_GETHEIGHT_NAME"], { execute: _service_blockchain__WEBPACK_IMPORTED_MODULE_3__["blockChainGetHeight"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["BLOCKCHAIN_GETHEADER_NAME"], { execute: _service_blockchain__WEBPACK_IMPORTED_MODULE_3__["blockChainGetHeader"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorBlockChainHeader"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["BLOCKCHAIN_GETBLOCK_NAME"], { execute: _service_blockchain__WEBPACK_IMPORTED_MODULE_3__["blockChainGetBlock"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorBlockChainBlock"] }],
// tslint:disable-next-line:max-line-length
[_consts__WEBPACK_IMPORTED_MODULE_0__["BLOCKCHAIN_GETTRANSACTION_NAME"], { execute: _service_blockchain__WEBPACK_IMPORTED_MODULE_3__["blockChainGetTransaction"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorBlockChainTransaction"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["BLOCKCHAIN_GETCONTRACT_NAME"], { execute: _service_blockchain__WEBPACK_IMPORTED_MODULE_3__["blockChainGetContract"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorBlockChainContract"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["BLOCKCHAIN_GETTRANSACTIONHEIGHT_NAME"], { execute: _service_blockchain__WEBPACK_IMPORTED_MODULE_3__["blockChainGetTransactionHeight"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["HEADER_GETINDEX_NAME"], { execute: _service_header__WEBPACK_IMPORTED_MODULE_5__["headerGetIndex"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorHeader"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["HEADER_GETHASH_NAME"], { execute: _service_header__WEBPACK_IMPORTED_MODULE_5__["headerGetHash"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorHeader"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["HEADER_GETVERSION_NAME"], { execute: _service_header__WEBPACK_IMPORTED_MODULE_5__["headerGetVersion"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorHeader"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["HEADER_GETPREVHASH_NAME"], { execute: _service_header__WEBPACK_IMPORTED_MODULE_5__["headerGetPrevHash"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorHeader"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["HEADER_GETTIMESTAMP_NAME"], { execute: _service_header__WEBPACK_IMPORTED_MODULE_5__["headerGetTimestamp"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorHeader"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["HEADER_GETCONSENSUSDATA_NAME"], { execute: _service_header__WEBPACK_IMPORTED_MODULE_5__["headerGetConsensusData"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorHeader"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["HEADER_GETNEXTCONSENSUS_NAME"], { execute: _service_header__WEBPACK_IMPORTED_MODULE_5__["headerGetNextConsensus"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorHeader"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["HEADER_GETMERKLEROOT_NAME"], { execute: _service_header__WEBPACK_IMPORTED_MODULE_5__["headerGetMerkleRoot"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorHeader"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["TRANSACTION_GETHASH_NAME"], { execute: _service_transaction__WEBPACK_IMPORTED_MODULE_11__["transactionGetHash"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorTransaction"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["TRANSACTION_GETTYPE_NAME"], { execute: _service_transaction__WEBPACK_IMPORTED_MODULE_11__["transactionGetType"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorTransaction"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["TRANSACTION_GETATTRIBUTES_NAME"], { execute: _service_transaction__WEBPACK_IMPORTED_MODULE_11__["transactionGetAttributes"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorTransaction"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["CONTRACT_CREATE_NAME"], { execute: _service_contract__WEBPACK_IMPORTED_MODULE_4__["contractCreate"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["CONTRACT_MIGRATE_NAME"], { execute: _service_contract__WEBPACK_IMPORTED_MODULE_4__["contractMigrate"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["CONTRACT_GETSTORAGECONTEXT_NAME"], { execute: _service_contract__WEBPACK_IMPORTED_MODULE_4__["contractGetStorageContext"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["CONTRACT_DESTROY_NAME"], { execute: _service_contract__WEBPACK_IMPORTED_MODULE_4__["contractDestroy"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["CONTRACT_GETSCRIPT_NAME"], { execute: _service_contract__WEBPACK_IMPORTED_MODULE_4__["contractGetCode"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorGetCode"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["RUNTIME_GETTIME_NAME"], { execute: _service_runtime__WEBPACK_IMPORTED_MODULE_7__["runtimeGetTime"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["RUNTIME_CHECKWITNESS_NAME"], { execute: _service_runtime__WEBPACK_IMPORTED_MODULE_7__["runtimeCheckWitness"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorCheckWitness"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["RUNTIME_NOTIFY_NAME"], { execute: _service_runtime__WEBPACK_IMPORTED_MODULE_7__["runtimeNotify"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorNotify"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["RUNTIME_LOG_NAME"], { execute: _service_runtime__WEBPACK_IMPORTED_MODULE_7__["runtimeLog"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorLog"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["RUNTIME_GETTRIGGER_NAME"], { execute: _service_runtime__WEBPACK_IMPORTED_MODULE_7__["runtimeGetTrigger"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["RUNTIME_SERIALIZE_NAME"], { execute: _service_runtime__WEBPACK_IMPORTED_MODULE_7__["runtimeSerialize"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorSerialize"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["RUNTIME_DESERIALIZE_NAME"], { execute: _service_runtime__WEBPACK_IMPORTED_MODULE_7__["runtimeDeserialize"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorDeserialize"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["RUNTIME_BASE58TOADDRESS_NAME"], { execute: _service_runtime__WEBPACK_IMPORTED_MODULE_7__["runtimeBase58ToAddress"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["RUNTIME_ADDRESSTOBASE58_NAME"], { execute: _service_runtime__WEBPACK_IMPORTED_MODULE_7__["runtimeAddressToBase58"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["RUNTIME_GETRANDOMHASH_NAME"], { execute: _service_runtime__WEBPACK_IMPORTED_MODULE_7__["runtimeGetRandomHash"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["NATIVE_INVOKE_NAME"], { execute: _service_native__WEBPACK_IMPORTED_MODULE_6__["nativeInvoke"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["STORAGE_GET_NAME"], { execute: _service_storage__WEBPACK_IMPORTED_MODULE_8__["storageGet"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["STORAGE_PUT_NAME"], { execute: _service_storage__WEBPACK_IMPORTED_MODULE_8__["storagePut"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["STORAGE_DELETE_NAME"], { execute: _service_storage__WEBPACK_IMPORTED_MODULE_8__["storageDelete"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["STORAGE_GETCONTEXT_NAME"], { execute: _service_storage__WEBPACK_IMPORTED_MODULE_8__["storageGetContext"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["STORAGE_GETREADONLYCONTEXT_NAME"], { execute: _service_storage__WEBPACK_IMPORTED_MODULE_8__["storageGetReadOnlyContext"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["STORAGECONTEXT_ASREADONLY_NAME"], { execute: _service_storageContext__WEBPACK_IMPORTED_MODULE_9__["storageContextAsReadOnly"], validator: _service_validate__WEBPACK_IMPORTED_MODULE_12__["validatorContextAsReadOnly"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["GETSCRIPTCONTAINER_NAME"], { execute: _service_system__WEBPACK_IMPORTED_MODULE_10__["getCodeContainer"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["GETEXECUTINGSCRIPTHASH_NAME"], { execute: _service_system__WEBPACK_IMPORTED_MODULE_10__["getExecutingAddress"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["GETCALLINGSCRIPTHASH_NAME"], { execute: _service_system__WEBPACK_IMPORTED_MODULE_10__["getCallingAddress"] }], [_consts__WEBPACK_IMPORTED_MODULE_0__["GETENTRYSCRIPTHASH_NAME"], { execute: _service_system__WEBPACK_IMPORTED_MODULE_10__["getEntryAddress"] }]]);

/***/ }),

/***/ "./src/smartcontract/smartContract.ts":
/*!********************************************!*\
  !*** ./src/smartcontract/smartContract.ts ***!
  \********************************************/
/*! exports provided: SmartContract */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SmartContract", function() { return SmartContract; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/error */ "./src/common/error.ts");
/* harmony import */ var _common_uint256__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common/uint256 */ "./src/common/uint256.ts");
/* harmony import */ var _vm_vmEngine__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../vm/vmEngine */ "./src/vm/vmEngine.ts");
/* harmony import */ var _consts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./consts */ "./src/smartcontract/consts.ts");
/* harmony import */ var _neoVmService__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./neoVmService */ "./src/smartcontract/neoVmService.ts");
/* harmony import */ var _runtime_runtimeLedgerStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./runtime/runtimeLedgerStore */ "./src/smartcontract/runtime/runtimeLedgerStore.ts");
/* harmony import */ var _runtime_runtimeStateStore__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./runtime/runtimeStateStore */ "./src/smartcontract/runtime/runtimeStateStore.ts");







class SmartContract {
    constructor(config) {
        this.contexts = [];
        this.notifications = [];
        this.logs = [];
        this.execStep = 0;
        this.time = config.time;
        this.tx = config.tx;
        this.gas = config.gas;
        this.store = config.store !== undefined ? config.store : new _runtime_runtimeLedgerStore__WEBPACK_IMPORTED_MODULE_5__["RuntimeLedgerStore"]();
        this.stateStore = config.stateStore !== undefined ? config.stateStore : new _runtime_runtimeStateStore__WEBPACK_IMPORTED_MODULE_6__["RuntimeStateStore"]();
        this.enableSecurity = config.enableSecurity !== undefined ? config.enableSecurity : true;
        this.enableGas = config.enableGas !== undefined ? config.enableGas : true;
        this.randomHash = config.randomHash !== undefined ? config.randomHash : new _common_uint256__WEBPACK_IMPORTED_MODULE_1__["Uint256"]();
        this.notificationCallback = config.notificationCallback;
        this.logCallback = config.logCallback;
    }
    getNotifications() {
        return this.notifications;
    }
    getLogs() {
        return this.logs;
    }
    // PushContext push current context to smart contract
    pushContext(context) {
        this.contexts.push(context);
    }
    /**
     * CurrentContext return smart contract current context
     */
    currentContext() {
        if (this.contexts.length < 1) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]();
        }
        return this.contexts[this.contexts.length - 1];
    }
    /**
     * CallingContext return smart contract caller context
     */
    callingContext() {
        if (this.contexts.length < 2) {
            return undefined;
        }
        return this.contexts[this.contexts.length - 2];
    }
    // EntryContext return smart contract entry entrance context
    entryContext() {
        if (this.contexts.length < 1) {
            return undefined;
        }
        return this.contexts[0];
    }
    // PopContext pop smart contract current context
    popContext() {
        if (this.contexts.length > 1) {
            this.contexts.pop();
        }
    }
    // PushNotifications push smart contract event info
    pushNotifications(notifications) {
        this.notifications.push(...notifications);
    }
    pushLogs(logs) {
        this.logs.push(...logs);
    }
    checkExecStep() {
        if (this.execStep >= _consts__WEBPACK_IMPORTED_MODULE_3__["VM_STEP_LIMIT"]) {
            return false;
        }
        this.execStep += 1;
        return true;
    }
    checkUseGas(gas) {
        if (this.enableGas === false) {
            return true;
        }
        if (this.gas.lt(gas)) {
            return false;
        }
        this.gas = this.gas.sub(gas);
        return true;
    }
    checkContexts() {
        if (this.contexts.length > _consts__WEBPACK_IMPORTED_MODULE_3__["MAX_EXECUTE_ENGINE"]) {
            return false;
        }
        return true;
    }
    /**
     * Execute is smart contract execute manager
     * According different vm type to launch different service
     * @param code
     */
    newExecuteEngine(code) {
        if (!this.checkContexts()) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('engine over max limit!');
        }
        const service = new _neoVmService__WEBPACK_IMPORTED_MODULE_4__["NeoVmService"]({
            store: this.store,
            stateStore: this.stateStore,
            contextRef: this,
            code,
            tx: this.tx,
            time: this.time,
            // height: this.config.height, - unused
            randomHash: this.randomHash,
            engine: new _vm_vmEngine__WEBPACK_IMPORTED_MODULE_2__["VMEngine"](),
            notificationCallback: this.notificationCallback,
            logCallback: this.logCallback
        });
        return service;
    }
    /**
     * CheckWitness check whether authorization correct
     * If address is wallet address, check whether in the signature addressed list
     * Else check whether address is calling contract address
     * Param address: wallet address or contract address
     * @param this
     * @param
     * @param SmartContract
     */
    checkWitness(address) {
        if (!this.enableSecurity || this.checkAccountAddress(address) || this.checkContractAddress(address)) {
            return true;
        }
        return false;
    }
    checkAccountAddress(address) {
        try {
            const addresses = this.tx.getSignatureAddresses();
            for (const v of addresses) {
                if (v.equals(address)) {
                    return true;
                }
            }
            return false;
        } catch (e) {
            // log.Errorf("get signature address error:%v", err)
            return false;
        }
    }
    checkContractAddress(address) {
        const callingContext = this.callingContext();
        if (callingContext !== undefined && callingContext.contractAddress.equals(address)) {
            return true;
        }
        return false;
    }
}

/***/ }),

/***/ "./src/smartcontract/states/contract.ts":
/*!**********************************************!*\
  !*** ./src/smartcontract/states/contract.ts ***!
  \**********************************************/
/*! exports provided: Contract */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Contract", function() { return Contract; });
/* harmony import */ var _common_address__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/address */ "./src/common/address.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */

class Contract {
    static deserialize(r) {
        const version = r.readByte();
        const address = new _common_address__WEBPACK_IMPORTED_MODULE_0__["Address"]();
        address.deserialize(r);
        const method = r.readVarBytes();
        const args = r.readVarBytes();
        return new Contract({
            version,
            address,
            method: method.toString(),
            args
        });
    }
    constructor({ version, address, method, args }) {
        this.version = version;
        this.address = address;
        this.method = method;
        this.args = args;
    }
    serialize(w) {
        w.writeUint8(this.version);
        this.address.serialize(w);
        w.writeVarBytes(new Buffer(this.method));
        w.writeVarBytes(new Buffer(this.args));
    }
}

/***/ }),

/***/ "./src/smartcontract/storageContext.ts":
/*!*********************************************!*\
  !*** ./src/smartcontract/storageContext.ts ***!
  \*********************************************/
/*! exports provided: StorageContext, isStorageContext */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StorageContext", function() { return StorageContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStorageContext", function() { return isStorageContext; });
class StorageContext {
    constructor(address) {
        this.address = address;
        this.readOnly = false;
    }
    getAddress() {
        return this.address;
    }
    isReadOnly() {
        return this.readOnly;
    }
    setReadOnly(readOnly) {
        this.readOnly = readOnly;
    }
    toArray() {
        return this.address.toArray();
    }
}
function isStorageContext(item) {
    return item instanceof StorageContext;
}

/***/ }),

/***/ "./src/vm/consts.ts":
/*!**************************!*\
  !*** ./src/vm/consts.ts ***!
  \**************************/
/*! exports provided: STACK_LIMIT, MAX_INVOCATION_STACK_SIZE, MAX_SIZE_FOR_BIGINTEGER, MAX_BYTEARRAY_SIZE, MAX_ARRAY_SIZE */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STACK_LIMIT", function() { return STACK_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_INVOCATION_STACK_SIZE", function() { return MAX_INVOCATION_STACK_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_SIZE_FOR_BIGINTEGER", function() { return MAX_SIZE_FOR_BIGINTEGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_BYTEARRAY_SIZE", function() { return MAX_BYTEARRAY_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_ARRAY_SIZE", function() { return MAX_ARRAY_SIZE; });
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */
const STACK_LIMIT = 2 * 1024;
const MAX_INVOCATION_STACK_SIZE = 1024;
const MAX_SIZE_FOR_BIGINTEGER = 32;
const MAX_BYTEARRAY_SIZE = 1024 * 1024;
const MAX_ARRAY_SIZE = 1024;

/***/ }),

/***/ "./src/vm/errors.ts":
/*!**************************!*\
  !*** ./src/vm/errors.ts ***!
  \**************************/
/*! exports provided: ERR_BAD_VALUE, ERR_BAD_TYPE, ERR_OVER_STACK_LEN, ERR_OVER_CODE_LEN, ERR_UNDER_STACK_LEN, ERR_FAULT, ERR_NOT_SUPPORT_SERVICE, ERR_NOT_SUPPORT_OPCODE, ERR_OVER_LIMIT_STACK, ERR_OVER_MAX_ITEM_SIZE, ERR_OVER_MAX_ARRAY_SIZE, ERR_OVER_MAX_BIGINTEGER_SIZE, ERR_OUT_OF_GAS, ERR_NOT_ARRAY, ERR_TABLE_IS_NIL, ERR_SERVICE_IS_NIL, ERR_DIV_MOD_BY_ZERO, ERR_SHIFT_BY_NEG, ERR_EXECUTION_CONTEXT_NIL, ERR_CURRENT_CONTEXT_NIL, ERR_CALLING_CONTEXT_NIL, ERR_ENTRY_CONTEXT_NIL, ERR_APPEND_NOT_ARRAY, ERR_NOT_SUPPORT_TYPE, ERR_MAP_NOT_EXIST, ERR_NOT_MAP_KEY, ERR_REMOVE_NOT_SUPPORT */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_BAD_VALUE", function() { return ERR_BAD_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_BAD_TYPE", function() { return ERR_BAD_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_OVER_STACK_LEN", function() { return ERR_OVER_STACK_LEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_OVER_CODE_LEN", function() { return ERR_OVER_CODE_LEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_UNDER_STACK_LEN", function() { return ERR_UNDER_STACK_LEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_FAULT", function() { return ERR_FAULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_NOT_SUPPORT_SERVICE", function() { return ERR_NOT_SUPPORT_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_NOT_SUPPORT_OPCODE", function() { return ERR_NOT_SUPPORT_OPCODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_OVER_LIMIT_STACK", function() { return ERR_OVER_LIMIT_STACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_OVER_MAX_ITEM_SIZE", function() { return ERR_OVER_MAX_ITEM_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_OVER_MAX_ARRAY_SIZE", function() { return ERR_OVER_MAX_ARRAY_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_OVER_MAX_BIGINTEGER_SIZE", function() { return ERR_OVER_MAX_BIGINTEGER_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_OUT_OF_GAS", function() { return ERR_OUT_OF_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_NOT_ARRAY", function() { return ERR_NOT_ARRAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_TABLE_IS_NIL", function() { return ERR_TABLE_IS_NIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_SERVICE_IS_NIL", function() { return ERR_SERVICE_IS_NIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_DIV_MOD_BY_ZERO", function() { return ERR_DIV_MOD_BY_ZERO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_SHIFT_BY_NEG", function() { return ERR_SHIFT_BY_NEG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_EXECUTION_CONTEXT_NIL", function() { return ERR_EXECUTION_CONTEXT_NIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_CURRENT_CONTEXT_NIL", function() { return ERR_CURRENT_CONTEXT_NIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_CALLING_CONTEXT_NIL", function() { return ERR_CALLING_CONTEXT_NIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_ENTRY_CONTEXT_NIL", function() { return ERR_ENTRY_CONTEXT_NIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_APPEND_NOT_ARRAY", function() { return ERR_APPEND_NOT_ARRAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_NOT_SUPPORT_TYPE", function() { return ERR_NOT_SUPPORT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_MAP_NOT_EXIST", function() { return ERR_MAP_NOT_EXIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_NOT_MAP_KEY", function() { return ERR_NOT_MAP_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERR_REMOVE_NOT_SUPPORT", function() { return ERR_REMOVE_NOT_SUPPORT; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/error */ "./src/common/error.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */

const ERR_BAD_VALUE = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('bad value');
const ERR_BAD_TYPE = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('bad type');
const ERR_OVER_STACK_LEN = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('the count over the stack length');
const ERR_OVER_CODE_LEN = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('the count over the code length');
const ERR_UNDER_STACK_LEN = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('the count under the stack length');
const ERR_FAULT = (msg = '') => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"](`the exceution meet fault: ${msg}`);
const ERR_NOT_SUPPORT_SERVICE = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('the service is not registered');
const ERR_NOT_SUPPORT_OPCODE = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('does not support the operation code');
const ERR_OVER_LIMIT_STACK = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('the stack over max size');
const ERR_OVER_MAX_ITEM_SIZE = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('the item over max size');
const ERR_OVER_MAX_ARRAY_SIZE = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('the array over max size');
const ERR_OVER_MAX_BIGINTEGER_SIZE = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('the biginteger over max size 32bit');
const ERR_OUT_OF_GAS = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('out of gas');
const ERR_NOT_ARRAY = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('not array');
const ERR_TABLE_IS_NIL = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('table is nil');
const ERR_SERVICE_IS_NIL = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('service is nil');
const ERR_DIV_MOD_BY_ZERO = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('div or mod by zero');
const ERR_SHIFT_BY_NEG = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('shift by negtive value');
const ERR_EXECUTION_CONTEXT_NIL = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('execution context is nil');
const ERR_CURRENT_CONTEXT_NIL = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('current context is nil');
const ERR_CALLING_CONTEXT_NIL = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('calling context is nil');
const ERR_ENTRY_CONTEXT_NIL = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('entry context is nil');
const ERR_APPEND_NOT_ARRAY = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('append not array');
const ERR_NOT_SUPPORT_TYPE = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('not a supported type');
const ERR_MAP_NOT_EXIST = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('map not contain key');
// tslint:disable-next-line:quotemark
const ERR_NOT_MAP_KEY = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]("type cann't as map key");
// tslint:disable-next-line:quotemark
const ERR_REMOVE_NOT_SUPPORT = () => new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]("type don't support remove");

/***/ }),

/***/ "./src/vm/executionContext.ts":
/*!************************************!*\
  !*** ./src/vm/executionContext.ts ***!
  \************************************/
/*! exports provided: ExecutionContext */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExecutionContext", function() { return ExecutionContext; });
/* harmony import */ var _utils_reader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils/reader */ "./src/vm/utils/reader.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */

class ExecutionContext {
    constructor(code) {
        this.code = code;
        this.opReader = new _utils_reader__WEBPACK_IMPORTED_MODULE_0__["Reader"](code);
    }
    getInstructionPointer() {
        return this.opReader.position();
    }
    setInstructionPointer(offset) {
        this.opReader.seek(offset, 'start');
    }
    // nextInstruction(): OpCode {
    //   return this.code[this.opReader.position()];
    // }
    clone() {
        const executionContext = new ExecutionContext(this.code);
        executionContext.setInstructionPointer(this.getInstructionPointer());
        return executionContext;
    }
    getReader() {
        return this.opReader;
    }
    getCodeLength() {
        return this.code.length;
    }
    getCode() {
        return this.code;
    }
}

/***/ }),

/***/ "./src/vm/func/arithmetic.ts":
/*!***********************************!*\
  !*** ./src/vm/func/arithmetic.ts ***!
  \***********************************/
/*! exports provided: opBigInt, opSign, opNot, opNz, opBigIntZip, opBoolZip, opBigIntComp, opWithIn */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opBigInt", function() { return opBigInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opSign", function() { return opSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opNot", function() { return opNot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opNz", function() { return opNz; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opBigIntZip", function() { return opBigIntZip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opBoolZip", function() { return opBoolZip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opBigIntComp", function() { return opBigIntComp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opWithIn", function() { return opWithIn; });
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common */ "./src/vm/func/common.ts");

function opBigInt(e) {
    const x = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popBigInt"])(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_0__["pushData"])(e, Object(_common__WEBPACK_IMPORTED_MODULE_0__["bigIntOp"])(x, e.getOpCode()));
}
function opSign(e) {
    const x = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popBigInt"])(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_0__["pushData"])(e, x.isPositive() ? 1 : -1);
}
function opNot(e) {
    const x = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popBoolean"])(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_0__["pushData"])(e, !x);
}
function opNz(e) {
    const x = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popBigInt"])(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_0__["pushData"])(e, Object(_common__WEBPACK_IMPORTED_MODULE_0__["bigIntComp"])(x, e.getOpCode()));
}
function opBigIntZip(e) {
    const x2 = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popBigInt"])(e);
    const x1 = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popBigInt"])(e);
    const b = Object(_common__WEBPACK_IMPORTED_MODULE_0__["bigIntZip"])(x1, x2, e.getOpCode());
    Object(_common__WEBPACK_IMPORTED_MODULE_0__["pushData"])(e, b);
}
function opBoolZip(e) {
    const x2 = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popBoolean"])(e);
    const x1 = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popBoolean"])(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_0__["pushData"])(e, Object(_common__WEBPACK_IMPORTED_MODULE_0__["boolZip"])(x1, x2, e.getOpCode()));
}
function opBigIntComp(e) {
    const x2 = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popBigInt"])(e);
    const x1 = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popBigInt"])(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_0__["pushData"])(e, Object(_common__WEBPACK_IMPORTED_MODULE_0__["bigIntMultiComp"])(x1, x2, e.getOpCode()));
}
function opWithIn(e) {
    const b = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popBigInt"])(e);
    const a = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popBigInt"])(e);
    const c = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popBigInt"])(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_0__["pushData"])(e, Object(_common__WEBPACK_IMPORTED_MODULE_0__["withInOp"])(c, a, b));
}

/***/ }),

/***/ "./src/vm/func/array.ts":
/*!******************************!*\
  !*** ./src/vm/func/array.ts ***!
  \******************************/
/*! exports provided: opArraySize, opPack, opUnpack, opPickItem, opSetItem, opNewArray, opNewStruct, opNewMap, opAppend, opReverse, opRemove, opHasKey, opKeys, opValues */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opArraySize", function() { return opArraySize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opPack", function() { return opPack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opUnpack", function() { return opUnpack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opPickItem", function() { return opPickItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opSetItem", function() { return opSetItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opNewArray", function() { return opNewArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opNewStruct", function() { return opNewStruct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opNewMap", function() { return opNewMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opAppend", function() { return opAppend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opReverse", function() { return opReverse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opRemove", function() { return opRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opHasKey", function() { return opHasKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opKeys", function() { return opKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opValues", function() { return opValues; });
/* harmony import */ var _errors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../errors */ "./src/vm/errors.ts");
/* harmony import */ var _types_array__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../types/array */ "./src/vm/types/array.ts");
/* harmony import */ var _types_boolean__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../types/boolean */ "./src/vm/types/boolean.ts");
/* harmony import */ var _types_integer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../types/integer */ "./src/vm/types/integer.ts");
/* harmony import */ var _types_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../types/map */ "./src/vm/types/map.ts");
/* harmony import */ var _types_struct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../types/struct */ "./src/vm/types/struct.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./common */ "./src/vm/func/common.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */







function opArraySize(e) {
    const item = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popStackItem"])(e);
    if (Object(_types_array__WEBPACK_IMPORTED_MODULE_1__["isArrayType"])(item)) {
        const a = item.getArray();
        Object(_common__WEBPACK_IMPORTED_MODULE_6__["pushData"])(e, a.length);
    } else {
        const b = item.getByteArray();
        Object(_common__WEBPACK_IMPORTED_MODULE_6__["pushData"])(e, b.length);
    }
}
function opPack(e) {
    const size = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popInt"])(e);
    const items = [];
    for (let i = 0; i < size; i++) {
        items.push(Object(_common__WEBPACK_IMPORTED_MODULE_6__["popStackItem"])(e));
    }
    Object(_common__WEBPACK_IMPORTED_MODULE_6__["pushData"])(e, items);
}
function opUnpack(e) {
    const arr = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popArray"])(e);
    const l = arr.length;
    for (let i = l - 1; i >= 0; i--) {
        Object(_common__WEBPACK_IMPORTED_MODULE_6__["push"])(e, arr[i]);
    }
    Object(_common__WEBPACK_IMPORTED_MODULE_6__["pushData"])(e, l);
}
function opPickItem(e) {
    const index = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popStackItem"])(e);
    const items = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popStackItem"])(e);
    if (Object(_types_array__WEBPACK_IMPORTED_MODULE_1__["isArrayType"])(items)) {
        const bi = index.getBigInteger();
        const i = bi.toJSNumber();
        const a = items.getArray();
        if (i < 0 || i >= a.length) {
            throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_OVER_MAX_ARRAY_SIZE"]();
        }
        Object(_common__WEBPACK_IMPORTED_MODULE_6__["pushData"])(e, a[i]);
    } else if (Object(_types_struct__WEBPACK_IMPORTED_MODULE_5__["isStructType"])(items)) {
        const bi = index.getBigInteger();
        const i = bi.toJSNumber();
        const s = items.getStruct();
        if (i < 0 || i >= s.length) {
            throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_OVER_MAX_ARRAY_SIZE"]();
        }
        Object(_common__WEBPACK_IMPORTED_MODULE_6__["pushData"])(e, s[i]);
    } else if (Object(_types_map__WEBPACK_IMPORTED_MODULE_4__["isMapType"])(items)) {
        Object(_common__WEBPACK_IMPORTED_MODULE_6__["pushData"])(e, items.tryGetValue(index));
    } else {
        throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_BAD_TYPE"]();
    }
}
function opSetItem(e) {
    let newItem = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popStackItem"])(e);
    if (Object(_types_struct__WEBPACK_IMPORTED_MODULE_5__["isStructType"])(newItem)) {
        newItem = newItem.clone();
    }
    const index = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popStackItem"])(e);
    const item = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popStackItem"])(e);
    if (Object(_types_map__WEBPACK_IMPORTED_MODULE_4__["isMapType"])(item)) {
        item.add(index, newItem);
    } else if (Object(_types_array__WEBPACK_IMPORTED_MODULE_1__["isArrayType"])(item)) {
        const items = item.getArray();
        const bi = index.getBigInteger();
        const i = bi.toJSNumber();
        if (i < 0 || i >= items.length) {
            throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_OVER_MAX_ARRAY_SIZE"]();
        }
        items[i] = newItem;
    } else if (Object(_types_struct__WEBPACK_IMPORTED_MODULE_5__["isStructType"])(item)) {
        const items = item.getStruct();
        const bi = index.getBigInteger();
        const i = bi.toJSNumber();
        if (i < 0 || i >= items.length) {
            throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_OVER_MAX_ARRAY_SIZE"]();
        }
        items[i] = newItem;
    } else {
        throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_BAD_TYPE"]();
    }
}
function opNewArray(e) {
    const count = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popInt"])(e);
    const items = [];
    for (let i = 0; i < count; i++) {
        items.push(new _types_boolean__WEBPACK_IMPORTED_MODULE_2__["BooleanType"](false));
    }
    Object(_common__WEBPACK_IMPORTED_MODULE_6__["pushData"])(e, new _types_array__WEBPACK_IMPORTED_MODULE_1__["ArrayType"](items));
}
function opNewStruct(e) {
    const count = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popInt"])(e);
    const items = [];
    for (let i = 0; i < count; i++) {
        items.push(new _types_boolean__WEBPACK_IMPORTED_MODULE_2__["BooleanType"](false));
    }
    Object(_common__WEBPACK_IMPORTED_MODULE_6__["pushData"])(e, new _types_struct__WEBPACK_IMPORTED_MODULE_5__["StructType"](items));
}
function opNewMap(e) {
    Object(_common__WEBPACK_IMPORTED_MODULE_6__["pushData"])(e, new _types_map__WEBPACK_IMPORTED_MODULE_4__["MapType"]());
}
function opAppend(e) {
    let newItem = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popStackItem"])(e);
    if (Object(_types_struct__WEBPACK_IMPORTED_MODULE_5__["isStructType"])(newItem)) {
        newItem = newItem.clone();
    }
    const items = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popStackItem"])(e);
    if (Object(_types_array__WEBPACK_IMPORTED_MODULE_1__["isArrayType"])(items)) {
        items.add(newItem);
    } else if (Object(_types_struct__WEBPACK_IMPORTED_MODULE_5__["isStructType"])(items)) {
        items.add(newItem);
    }
}
function opReverse(e) {
    const itemArr = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popArray"])(e);
    itemArr.reverse();
}
function opRemove(e) {
    const index = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popStackItem"])(e);
    const item = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popStackItem"])(e);
    if (Object(_types_map__WEBPACK_IMPORTED_MODULE_4__["isMapType"])(item)) {
        item.remove(index);
    } else if (Object(_types_array__WEBPACK_IMPORTED_MODULE_1__["isArrayType"])(item) || Object(_types_struct__WEBPACK_IMPORTED_MODULE_5__["isStructType"])(item)) {
        if (!Object(_types_integer__WEBPACK_IMPORTED_MODULE_3__["isIntegerType"])(index)) {
            throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_BAD_TYPE"]();
        }
        item.removeAt(index.getBigInteger().toJSNumber());
    } else {
        throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_BAD_TYPE"]();
    }
}
function opHasKey(e) {
    const index = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popStackItem"])(e);
    const item = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popStackItem"])(e);
    if (Object(_types_map__WEBPACK_IMPORTED_MODULE_4__["isMapType"])(item)) {
        Object(_common__WEBPACK_IMPORTED_MODULE_6__["pushData"])(e, item.tryGetValue(index) !== undefined);
    } else if (Object(_types_array__WEBPACK_IMPORTED_MODULE_1__["isArrayType"])(item) || Object(_types_struct__WEBPACK_IMPORTED_MODULE_5__["isStructType"])(item)) {
        // todo: this implements HASKEY the same way as NEOVM in C# and Go, but it is against the logic
        Object(_common__WEBPACK_IMPORTED_MODULE_6__["pushData"])(e, index.getBigInteger().toJSNumber() < item.count());
        // correct implementation
        // pushData(e, item.contains(index));
    } else {
        throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_BAD_TYPE"]();
    }
}
function opKeys(e) {
    const item = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popStackItem"])(e);
    if (Object(_types_map__WEBPACK_IMPORTED_MODULE_4__["isMapType"])(item)) {
        const keys = Array.from(item.getMap().keys());
        Object(_common__WEBPACK_IMPORTED_MODULE_6__["pushData"])(e, new _types_array__WEBPACK_IMPORTED_MODULE_1__["ArrayType"](keys));
    } else {
        throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_BAD_TYPE"]();
    }
}
function opValues(e) {
    const item = Object(_common__WEBPACK_IMPORTED_MODULE_6__["popStackItem"])(e);
    if (Object(_types_map__WEBPACK_IMPORTED_MODULE_4__["isMapType"])(item)) {
        const values = Array.from(item.getMap().values());
        Object(_common__WEBPACK_IMPORTED_MODULE_6__["pushData"])(e, new _types_array__WEBPACK_IMPORTED_MODULE_1__["ArrayType"](values));
    } else if (Object(_types_array__WEBPACK_IMPORTED_MODULE_1__["isArrayType"])(item)) {
        const array = item.getArray();
        const cloned = array.map(it => {
            if (Object(_types_struct__WEBPACK_IMPORTED_MODULE_5__["isStructType"])(it)) {
                return it.clone();
            } else {
                return it;
            }
        });
        Object(_common__WEBPACK_IMPORTED_MODULE_6__["pushData"])(e, new _types_array__WEBPACK_IMPORTED_MODULE_1__["ArrayType"](cloned));
    } else {
        throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_BAD_TYPE"]();
    }
}

/***/ }),

/***/ "./src/vm/func/bitwise.ts":
/*!********************************!*\
  !*** ./src/vm/func/bitwise.ts ***!
  \********************************/
/*! exports provided: opInvert, opEqual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opInvert", function() { return opInvert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opEqual", function() { return opEqual; });
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common */ "./src/vm/func/common.ts");

function opInvert(e) {
    const i = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popBigInt"])(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_0__["pushData"])(e, i.not());
}
function opEqual(e) {
    const b1 = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popStackItem"])(e);
    const b2 = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popStackItem"])(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_0__["pushData"])(e, b1.equals(b2));
}

/***/ }),

/***/ "./src/vm/func/common.ts":
/*!*******************************!*\
  !*** ./src/vm/func/common.ts ***!
  \*******************************/
/*! exports provided: pushData, popBigInt, popInt, popBoolean, popArray, popInteropInterface, popByteArray, popStackItem, peekArray, peekInteropInterface, peekInt, peekBigInteger, peekStackItem, peekNBigInt, peekNByteArray, peekNStackItem, bigIntOp, bigIntZip, bigIntComp, bigIntMultiComp, boolZip, withInOp, newStackItem, evaluationStackCount, push, count, hash */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pushData", function() { return pushData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "popBigInt", function() { return popBigInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "popInt", function() { return popInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "popBoolean", function() { return popBoolean; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "popArray", function() { return popArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "popInteropInterface", function() { return popInteropInterface; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "popByteArray", function() { return popByteArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "popStackItem", function() { return popStackItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "peekArray", function() { return peekArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "peekInteropInterface", function() { return peekInteropInterface; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "peekInt", function() { return peekInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "peekBigInteger", function() { return peekBigInteger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "peekStackItem", function() { return peekStackItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "peekNBigInt", function() { return peekNBigInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "peekNByteArray", function() { return peekNByteArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "peekNStackItem", function() { return peekNStackItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bigIntOp", function() { return bigIntOp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bigIntZip", function() { return bigIntZip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bigIntComp", function() { return bigIntComp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bigIntMultiComp", function() { return bigIntMultiComp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "boolZip", function() { return boolZip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withInOp", function() { return withInOp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "newStackItem", function() { return newStackItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "evaluationStackCount", function() { return evaluationStackCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "push", function() { return push; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "count", function() { return count; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hash", function() { return hash; });
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! big-integer */ "big-integer");
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(big_integer__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! crypto */ "crypto");
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(crypto__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/* harmony import */ var _errors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../errors */ "./src/vm/errors.ts");
/* harmony import */ var _interfaces_interop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../interfaces/interop */ "./src/vm/interfaces/interop.ts");
/* harmony import */ var _opCode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../opCode */ "./src/vm/opCode.ts");
/* harmony import */ var _types_array__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../types/array */ "./src/vm/types/array.ts");
/* harmony import */ var _types_boolean__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../types/boolean */ "./src/vm/types/boolean.ts");
/* harmony import */ var _types_byteArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../types/byteArray */ "./src/vm/types/byteArray.ts");
/* harmony import */ var _types_integer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../types/integer */ "./src/vm/types/integer.ts");
/* harmony import */ var _types_interop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../types/interop */ "./src/vm/types/interop.ts");
/* harmony import */ var _types_map__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../types/map */ "./src/vm/types/map.ts");
/* harmony import */ var _types_stackItem__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../types/stackItem */ "./src/vm/types/stackItem.ts");
/* harmony import */ var _types_struct__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../types/struct */ "./src/vm/types/struct.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */














function pushData(e, data) {
    e.getEvaluationStack().push(newStackItem(data));
}
function popBigInt(e) {
    const x = popStackItem(e);
    return x.getBigInteger();
}
function popInt(e) {
    const x = popBigInt(e);
    return x.toJSNumber();
}
function popBoolean(e) {
    const x = popStackItem(e);
    return x.getBoolean();
}
function popArray(e) {
    const x = popStackItem(e);
    return x.getArray();
}
function popInteropInterface(e) {
    const x = popStackItem(e);
    return x.getInterface();
}
function popByteArray(e) {
    const x = popStackItem(e);
    return x.getByteArray();
}
function popStackItem(e) {
    const item = e.getEvaluationStack().pop();
    if (item === undefined) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_STACK_LEN"]();
    }
    return item;
}
function peekArray(e) {
    const x = peekStackItem(e);
    return x.getArray();
}
function peekInteropInterface(e) {
    const x = peekStackItem(e);
    return x.getInterface();
}
function peekInt(e) {
    const x = peekBigInteger(e);
    return x.toJSNumber();
}
function peekBigInteger(e) {
    const x = peekStackItem(e);
    return x.getBigInteger();
}
function peekStackItem(e) {
    const item = e.getEvaluationStack().peek(0);
    if (item === undefined) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_STACK_LEN"]();
    }
    return item;
}
function peekNBigInt(i, e) {
    const x = peekNStackItem(i, e);
    return x.getBigInteger();
}
function peekNByteArray(i, e) {
    const x = peekNStackItem(i, e);
    return x.getByteArray();
}
function peekNStackItem(i, e) {
    const item = e.getEvaluationStack().peek(i);
    if (item === undefined) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_STACK_LEN"]();
    }
    return item;
}
function bigIntOp(bi, op) {
    let nb;
    switch (op) {
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["INC"]:
            nb = bi.add(big_integer__WEBPACK_IMPORTED_MODULE_0__["one"]);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["DEC"]:
            nb = bi.subtract(big_integer__WEBPACK_IMPORTED_MODULE_0__["one"]);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["NEGATE"]:
            nb = bi.negate();
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["ABS"]:
            nb = bi.abs();
            break;
        default:
            nb = bi;
    }
    return nb;
}
function bigIntZip(ints1, ints2, op) {
    let nb;
    switch (op) {
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["AND"]:
            nb = ints1.and(ints2);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["OR"]:
            nb = ints1.or(ints2);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["XOR"]:
            nb = ints1.xor(ints2);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["ADD"]:
            nb = ints1.add(ints2);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["SUB"]:
            nb = ints1.subtract(ints2);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["MUL"]:
            nb = ints1.multiply(ints2);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["DIV"]:
            nb = ints1.divide(ints2);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["MOD"]:
            nb = ints1.mod(ints2);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["SHL"]:
            nb = ints1.shiftLeft(ints2.toJSNumber());
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["SHR"]:
            nb = ints1.shiftRight(ints2.toJSNumber());
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["MIN"]:
            nb = big_integer__WEBPACK_IMPORTED_MODULE_0__["min"](ints1, ints2);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["MAX"]:
            nb = big_integer__WEBPACK_IMPORTED_MODULE_0__["max"](ints1, ints2);
            break;
        default:
            throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_NOT_SUPPORT_OPCODE"]();
    }
    return nb;
}
function bigIntComp(bigint, op) {
    let nb;
    switch (op) {
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["NZ"]:
            nb = !bigint.isZero();
            break;
        default:
            throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_NOT_SUPPORT_OPCODE"]();
    }
    return nb;
}
function bigIntMultiComp(ints1, ints2, op) {
    let nb;
    switch (op) {
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["NUMEQUAL"]:
            nb = ints1.equals(ints2);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["NUMNOTEQUAL"]:
            nb = ints1.notEquals(ints2);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["LT"]:
            nb = ints1.lesser(ints2);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["GT"]:
            nb = ints1.greater(ints2);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["LTE"]:
            nb = ints1.lesserOrEquals(ints2);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["GTE"]:
            nb = ints1.greaterOrEquals(ints2);
            break;
        default:
            throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_NOT_SUPPORT_OPCODE"]();
    }
    return nb;
}
function boolZip(bi1, bi2, op) {
    let nb;
    switch (op) {
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["BOOLAND"]:
            nb = bi1 && bi2;
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["BOOLOR"]:
            nb = bi1 || bi2;
            break;
        default:
            throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_NOT_SUPPORT_OPCODE"]();
    }
    return nb;
}
function withInOp(int1, int2, int3) {
    const b1 = bigIntMultiComp(int1, int2, _opCode__WEBPACK_IMPORTED_MODULE_5__["GTE"]);
    const b2 = bigIntMultiComp(int1, int3, _opCode__WEBPACK_IMPORTED_MODULE_5__["LT"]);
    return boolZip(b1, b2, _opCode__WEBPACK_IMPORTED_MODULE_5__["BOOLAND"]);
}
function newStackItem(data) {
    let stackItem;
    if (typeof data === 'number') {
        stackItem = new _types_integer__WEBPACK_IMPORTED_MODULE_9__["IntegerType"](big_integer__WEBPACK_IMPORTED_MODULE_0__(data));
    } else if (big_integer__WEBPACK_IMPORTED_MODULE_0__["isInstance"](data)) {
        stackItem = new _types_integer__WEBPACK_IMPORTED_MODULE_9__["IntegerType"](data);
    } else if (typeof data === 'boolean') {
        stackItem = new _types_boolean__WEBPACK_IMPORTED_MODULE_7__["BooleanType"](data);
    } else if (data instanceof Buffer) {
        stackItem = new _types_byteArray__WEBPACK_IMPORTED_MODULE_8__["ByteArrayType"](data);
    } else if (data instanceof Uint8Array) {
        stackItem = new _types_byteArray__WEBPACK_IMPORTED_MODULE_8__["ByteArrayType"](Buffer.from(data.buffer));
    } else if (Object(_types_integer__WEBPACK_IMPORTED_MODULE_9__["isIntegerType"])(data)) {
        stackItem = data;
    } else if (Object(_types_boolean__WEBPACK_IMPORTED_MODULE_7__["isBooleanType"])(data)) {
        stackItem = data;
    } else if (Object(_types_byteArray__WEBPACK_IMPORTED_MODULE_8__["isByteArrayType"])(data)) {
        stackItem = data;
    } else if (Object(_types_array__WEBPACK_IMPORTED_MODULE_6__["isArrayType"])(data)) {
        stackItem = data;
    } else if (Object(_types_stackItem__WEBPACK_IMPORTED_MODULE_12__["isStackItemArrayType"])(data)) {
        stackItem = new _types_array__WEBPACK_IMPORTED_MODULE_6__["ArrayType"](data);
    } else if (Object(_types_map__WEBPACK_IMPORTED_MODULE_11__["isMapType"])(data)) {
        stackItem = data;
    } else if (Object(_types_struct__WEBPACK_IMPORTED_MODULE_13__["isStructType"])(data)) {
        stackItem = data;
    } else if (Object(_types_stackItem__WEBPACK_IMPORTED_MODULE_12__["isStackItemType"])(data)) {
        stackItem = data;
    } else if (Object(_interfaces_interop__WEBPACK_IMPORTED_MODULE_4__["isInterop"])(data)) {
        stackItem = new _types_interop__WEBPACK_IMPORTED_MODULE_10__["InteropType"](data);
    } else {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_2__["TracedError"]('Invalid data type!');
    }
    return stackItem;
}
function evaluationStackCount(e) {
    return e.getEvaluationStack().count();
}
function push(e, element) {
    e.getEvaluationStack().push(element);
}
function count(e) {
    return e.getEvaluationStack().count();
}
function hash(b, op) {
    let sh;
    let rp;
    switch (op) {
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["SHA1"]:
            sh = Object(crypto__WEBPACK_IMPORTED_MODULE_1__["createHash"])('sha1');
            sh.update(b);
            return sh.digest();
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["SHA256"]:
            sh = Object(crypto__WEBPACK_IMPORTED_MODULE_1__["createHash"])('sha256');
            sh.update(b);
            return sh.digest();
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["HASH160"]:
            sh = Object(crypto__WEBPACK_IMPORTED_MODULE_1__["createHash"])('sha256');
            rp = Object(crypto__WEBPACK_IMPORTED_MODULE_1__["createHash"])('ripemd160');
            sh.update(b);
            rp.update(sh.digest());
            return rp.digest();
        case _opCode__WEBPACK_IMPORTED_MODULE_5__["HASH256"]:
            sh = Object(crypto__WEBPACK_IMPORTED_MODULE_1__["createHash"])('sha256');
            rp = Object(crypto__WEBPACK_IMPORTED_MODULE_1__["createHash"])('sha256');
            sh.update(b);
            rp.update(sh.digest());
            return rp.digest();
        default:
            throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_NOT_SUPPORT_OPCODE"]();
    }
}

/***/ }),

/***/ "./src/vm/func/exceptions.ts":
/*!***********************************!*\
  !*** ./src/vm/func/exceptions.ts ***!
  \***********************************/
/*! exports provided: opThrow, opThrowIfNot */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opThrow", function() { return opThrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opThrowIfNot", function() { return opThrowIfNot; });
/* harmony import */ var _errors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../errors */ "./src/vm/errors.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./common */ "./src/vm/func/common.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */


function opThrow(e) {
    const message = Object(_common__WEBPACK_IMPORTED_MODULE_1__["popByteArray"])(e);
    throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_FAULT"](message.toString());
}
function opThrowIfNot(e) {
    const b = Object(_common__WEBPACK_IMPORTED_MODULE_1__["popBoolean"])(e);
    if (!b) {
        throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_FAULT"]();
    }
}

/***/ }),

/***/ "./src/vm/func/flowControl.ts":
/*!************************************!*\
  !*** ./src/vm/func/flowControl.ts ***!
  \************************************/
/*! exports provided: opNop, opJmp, opCall, opRet */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opNop", function() { return opNop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opJmp", function() { return opJmp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opCall", function() { return opCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opRet", function() { return opRet; });
/* harmony import */ var _errors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../errors */ "./src/vm/errors.ts");
/* harmony import */ var _opCode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../opCode */ "./src/vm/opCode.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./common */ "./src/vm/func/common.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */



function opNop(e) {
    // noop
}
function opJmp(e) {
    const context = e.getContext();
    const opCode = e.getOpCode();
    let offset = context.getReader().readInt16();
    offset = context.getInstructionPointer() + offset - 3;
    if (offset < 0 || offset > context.getCodeLength()) {
        throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_FAULT"]();
    }
    let fValue = true;
    if (opCode > _opCode__WEBPACK_IMPORTED_MODULE_1__["JMP"]) {
        if (Object(_common__WEBPACK_IMPORTED_MODULE_2__["evaluationStackCount"])(e) < 1) {
            throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_UNDER_STACK_LEN"]();
        }
        fValue = Object(_common__WEBPACK_IMPORTED_MODULE_2__["popBoolean"])(e);
        if (opCode === _opCode__WEBPACK_IMPORTED_MODULE_1__["JMPIFNOT"]) {
            fValue = !fValue;
        }
    }
    if (fValue) {
        context.setInstructionPointer(offset);
    }
}
function opCall(e) {
    const context = e.getContext().clone();
    e.getContext().setInstructionPointer(e.getContext().getInstructionPointer() + 2);
    e.setOpCode(_opCode__WEBPACK_IMPORTED_MODULE_1__["JMP"]);
    e.pushContext(context);
    opJmp(e);
}
function opRet(e) {
    e.popContext();
}

/***/ }),

/***/ "./src/vm/func/hash.ts":
/*!*****************************!*\
  !*** ./src/vm/func/hash.ts ***!
  \*****************************/
/*! exports provided: opHash */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opHash", function() { return opHash; });
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common */ "./src/vm/func/common.ts");

function opHash(e) {
    const x = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popByteArray"])(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_0__["pushData"])(e, Object(_common__WEBPACK_IMPORTED_MODULE_0__["hash"])(x, e.getOpCode()));
}

/***/ }),

/***/ "./src/vm/func/pushData.ts":
/*!*********************************!*\
  !*** ./src/vm/func/pushData.ts ***!
  \*********************************/
/*! exports provided: opPushData, getPushData */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opPushData", function() { return opPushData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPushData", function() { return getPushData; });
/* harmony import */ var _opCode__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../opCode */ "./src/vm/opCode.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./common */ "./src/vm/func/common.ts");


function opPushData(e) {
    const data = getPushData(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["pushData"])(e, data);
}
function getPushData(e) {
    const reader = e.getContext().getReader();
    const opCode = e.getOpCode();
    let data;
    if (opCode >= _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSHBYTES1"] && opCode <= _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSHBYTES75"]) {
        data = reader.readBytes(opCode);
    }
    switch (opCode) {
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH0"]:
            data = 0;
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSHDATA1"]:
            const d = reader.readByte();
            data = reader.readBytes(d);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSHDATA2"]:
            data = reader.readBytes(reader.readUInt16());
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSHDATA4"]:
            const i = reader.readInt32();
            data = reader.readBytes(i);
            break;
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSHM1"]:
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH1"]:
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH2"]:
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH3"]:
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH4"]:
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH5"]:
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH6"]:
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH7"]:
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH8"]:
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH9"]:
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH10"]:
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH11"]:
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH12"]:
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH13"]:
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH14"]:
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH15"]:
        case _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH16"]:
            data = opCode - _opCode__WEBPACK_IMPORTED_MODULE_0__["PUSH1"] + 1;
            break;
    }
    return data;
}

/***/ }),

/***/ "./src/vm/func/splice.ts":
/*!*******************************!*\
  !*** ./src/vm/func/splice.ts ***!
  \*******************************/
/*! exports provided: opCat, opSubStr, opLeft, opRight, opSize */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opCat", function() { return opCat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opSubStr", function() { return opSubStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opLeft", function() { return opLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opRight", function() { return opRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opSize", function() { return opSize; });
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common */ "./src/vm/func/common.ts");

function opCat(e) {
    const b2 = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popByteArray"])(e);
    const b1 = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popByteArray"])(e);
    const r = Buffer.concat([b1, b2]);
    Object(_common__WEBPACK_IMPORTED_MODULE_0__["pushData"])(e, r);
}
function opSubStr(e) {
    const count = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popInt"])(e);
    const index = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popInt"])(e);
    const arr = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popByteArray"])(e);
    const b = arr.slice(index, index + count);
    Object(_common__WEBPACK_IMPORTED_MODULE_0__["pushData"])(e, b);
}
function opLeft(e) {
    const count = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popInt"])(e);
    const s = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popByteArray"])(e);
    const b = s.slice(0, count);
    Object(_common__WEBPACK_IMPORTED_MODULE_0__["pushData"])(e, b);
}
/**
 * TODO: check if correct
 * @param e
 */
function opRight(e) {
    const count = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popInt"])(e);
    const arr = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popByteArray"])(e);
    const b = arr.slice(arr.length - count, arr.length);
    Object(_common__WEBPACK_IMPORTED_MODULE_0__["pushData"])(e, b);
}
function opSize(e) {
    const b = Object(_common__WEBPACK_IMPORTED_MODULE_0__["popByteArray"])(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_0__["pushData"])(e, b.length);
}

/***/ }),

/***/ "./src/vm/func/stack.ts":
/*!******************************!*\
  !*** ./src/vm/func/stack.ts ***!
  \******************************/
/*! exports provided: opToDupFromAltStack, opToAltStack, opFromAltStack, opXDrop, opXSwap, opXTuck, opDepth, opDrop, opDup, opNip, opOver, opPick, opRoll, opRot, opSwap, opTuck */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opToDupFromAltStack", function() { return opToDupFromAltStack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opToAltStack", function() { return opToAltStack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opFromAltStack", function() { return opFromAltStack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opXDrop", function() { return opXDrop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opXSwap", function() { return opXSwap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opXTuck", function() { return opXTuck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opDepth", function() { return opDepth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opDrop", function() { return opDrop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opDup", function() { return opDup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opNip", function() { return opNip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opOver", function() { return opOver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opPick", function() { return opPick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opRoll", function() { return opRoll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opRot", function() { return opRot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opSwap", function() { return opSwap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opTuck", function() { return opTuck; });
/* harmony import */ var _errors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../errors */ "./src/vm/errors.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./common */ "./src/vm/func/common.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */


function opToDupFromAltStack(e) {
    const item = e.getAltStack().peek(0);
    if (item === undefined) {
        throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_OVER_STACK_LEN"]();
    }
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["push"])(e, item);
}
function opToAltStack(e) {
    e.getAltStack().push(Object(_common__WEBPACK_IMPORTED_MODULE_1__["popStackItem"])(e));
}
function opFromAltStack(e) {
    const item = e.getAltStack().pop();
    if (item === undefined) {
        throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_OVER_STACK_LEN"]();
    }
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["push"])(e, item);
}
function opXDrop(e) {
    const n = Object(_common__WEBPACK_IMPORTED_MODULE_1__["popInt"])(e);
    e.getEvaluationStack().remove(n);
}
function opXSwap(e) {
    const n = Object(_common__WEBPACK_IMPORTED_MODULE_1__["popInt"])(e);
    if (n === 0) {
        return;
    }
    e.getEvaluationStack().swap(0, n);
}
function opXTuck(e) {
    const n = Object(_common__WEBPACK_IMPORTED_MODULE_1__["popInt"])(e);
    e.getEvaluationStack().insert(n, Object(_common__WEBPACK_IMPORTED_MODULE_1__["peekStackItem"])(e));
}
function opDepth(e) {
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["pushData"])(e, Object(_common__WEBPACK_IMPORTED_MODULE_1__["count"])(e));
}
function opDrop(e) {
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["popStackItem"])(e);
}
function opDup(e) {
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["push"])(e, Object(_common__WEBPACK_IMPORTED_MODULE_1__["peekStackItem"])(e));
}
function opNip(e) {
    const x2 = Object(_common__WEBPACK_IMPORTED_MODULE_1__["popStackItem"])(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["popStackItem"])(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["push"])(e, x2);
}
function opOver(e) {
    const x2 = Object(_common__WEBPACK_IMPORTED_MODULE_1__["popStackItem"])(e);
    const x1 = Object(_common__WEBPACK_IMPORTED_MODULE_1__["peekStackItem"])(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["push"])(e, x2);
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["push"])(e, x1);
}
function opPick(e) {
    const n = Object(_common__WEBPACK_IMPORTED_MODULE_1__["popInt"])(e);
    const item = e.getEvaluationStack().peek(n);
    if (item === undefined) {
        throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_OVER_STACK_LEN"]();
    }
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["push"])(e, item);
}
function opRoll(e) {
    const n = Object(_common__WEBPACK_IMPORTED_MODULE_1__["popInt"])(e);
    if (n === 0) {
        return;
    }
    const item = e.getEvaluationStack().remove(n);
    if (item === undefined) {
        throw _errors__WEBPACK_IMPORTED_MODULE_0__["ERR_OVER_STACK_LEN"]();
    }
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["push"])(e, item);
}
function opRot(e) {
    const x3 = Object(_common__WEBPACK_IMPORTED_MODULE_1__["popStackItem"])(e);
    const x2 = Object(_common__WEBPACK_IMPORTED_MODULE_1__["popStackItem"])(e);
    const x1 = Object(_common__WEBPACK_IMPORTED_MODULE_1__["popStackItem"])(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["push"])(e, x2);
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["push"])(e, x3);
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["push"])(e, x1);
}
function opSwap(e) {
    const x2 = Object(_common__WEBPACK_IMPORTED_MODULE_1__["popStackItem"])(e);
    const x1 = Object(_common__WEBPACK_IMPORTED_MODULE_1__["popStackItem"])(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["push"])(e, x2);
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["push"])(e, x1);
}
function opTuck(e) {
    const x2 = Object(_common__WEBPACK_IMPORTED_MODULE_1__["popStackItem"])(e);
    const x1 = Object(_common__WEBPACK_IMPORTED_MODULE_1__["popStackItem"])(e);
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["push"])(e, x2);
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["push"])(e, x1);
    Object(_common__WEBPACK_IMPORTED_MODULE_1__["push"])(e, x2);
}

/***/ }),

/***/ "./src/vm/func/validate.ts":
/*!*********************************!*\
  !*** ./src/vm/func/validate.ts ***!
  \*********************************/
/*! exports provided: validateCount1, validateAltStackCount1, validateCount2, validateCount3, validateShiftLeft, validateShift, validatorPushData4, validateCall, validateInvocationStack, validateOpStack, validateXDrop, validateXSwap, validateXTuck, validatePick, validateRoll, validateCat, validateSubStr, validateLeft, validateRight, validateInc, validateDec, validateSign, validateAdd, validateSub, validateMul, validateDiv, validateMod, validatePack, validateUnpack, validatePickItem, validatorSetItem, validateNewArray, validateNewStruct, validateAppend, validatorReverse, validatorRemove, validatorHasKey, validatorKeys, validatorValues, validatorThrowIfNot, checkBigInteger, logStackTrace */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateCount1", function() { return validateCount1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateAltStackCount1", function() { return validateAltStackCount1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateCount2", function() { return validateCount2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateCount3", function() { return validateCount3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateShiftLeft", function() { return validateShiftLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateShift", function() { return validateShift; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorPushData4", function() { return validatorPushData4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateCall", function() { return validateCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateInvocationStack", function() { return validateInvocationStack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateOpStack", function() { return validateOpStack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateXDrop", function() { return validateXDrop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateXSwap", function() { return validateXSwap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateXTuck", function() { return validateXTuck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatePick", function() { return validatePick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateRoll", function() { return validateRoll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateCat", function() { return validateCat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateSubStr", function() { return validateSubStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateLeft", function() { return validateLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateRight", function() { return validateRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateInc", function() { return validateInc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateDec", function() { return validateDec; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateSign", function() { return validateSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateAdd", function() { return validateAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateSub", function() { return validateSub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateMul", function() { return validateMul; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateDiv", function() { return validateDiv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateMod", function() { return validateMod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatePack", function() { return validatePack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateUnpack", function() { return validateUnpack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatePickItem", function() { return validatePickItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorSetItem", function() { return validatorSetItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateNewArray", function() { return validateNewArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateNewStruct", function() { return validateNewStruct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateAppend", function() { return validateAppend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorReverse", function() { return validatorReverse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorRemove", function() { return validatorRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorHasKey", function() { return validatorHasKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorKeys", function() { return validatorKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorValues", function() { return validatorValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatorThrowIfNot", function() { return validatorThrowIfNot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkBigInteger", function() { return checkBigInteger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logStackTrace", function() { return logStackTrace; });
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! big-integer */ "big-integer");
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(big_integer__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../common/utils */ "./src/common/utils.ts");
/* harmony import */ var _consts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../consts */ "./src/vm/consts.ts");
/* harmony import */ var _errors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../errors */ "./src/vm/errors.ts");
/* harmony import */ var _types_array__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../types/array */ "./src/vm/types/array.ts");
/* harmony import */ var _types_integer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../types/integer */ "./src/vm/types/integer.ts");
/* harmony import */ var _types_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../types/map */ "./src/vm/types/map.ts");
/* harmony import */ var _types_struct__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../types/struct */ "./src/vm/types/struct.ts");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./common */ "./src/vm/func/common.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */









function validateCount1(e) {
    logStackTrace(e, 1, '[validateCount1]');
}
function validateAltStackCount1(e) {
    const stackCount = e.getAltStack().count();
    if (stackCount < 1) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_UNDER_STACK_LEN"]();
    }
}
function validateCount2(e) {
    logStackTrace(e, 2, '[validateCount2]');
}
function validateCount3(e) {
    logStackTrace(e, 3, '[validateCount3]');
}
function validateShiftLeft(e) {
    logStackTrace(e, 2, '[validateShift]');
    // x1 << x2
    const x2 = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekInt"])(e);
    const x1 = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNBigInt"])(1, e);
    if (x2 < 0) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_SHIFT_BY_NEG"]();
    }
    if (!x1.isZero() && x2 > _consts__WEBPACK_IMPORTED_MODULE_2__["MAX_SIZE_FOR_BIGINTEGER"] * 8) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_MAX_BIGINTEGER_SIZE"]();
    }
    if (checkBigInteger(x1.shiftLeft(x2)) === false) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_MAX_BIGINTEGER_SIZE"]();
    }
}
function validateShift(e) {
    logStackTrace(e, 2, '[validateShift]');
    const bi = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekBigInteger"])(e);
    if (bi.isNegative()) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_SHIFT_BY_NEG"]();
    }
}
function validatorPushData4(e) {
    const index = e.getContext().getInstructionPointer();
    if (index + 4 >= e.getContext().getCodeLength()) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_CODE_LEN"]();
    }
    const l = e.getContext().getCode().readUInt32LE(index);
    if (l > _consts__WEBPACK_IMPORTED_MODULE_2__["MAX_BYTEARRAY_SIZE"]) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_MAX_ITEM_SIZE"]();
    }
}
function validateCall(e) {
    validateInvocationStack(e);
}
function validateInvocationStack(e) {
    if (e.getContexts().length >= _consts__WEBPACK_IMPORTED_MODULE_2__["MAX_INVOCATION_STACK_SIZE"]) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_STACK_LEN"]();
    }
}
function validateOpStack(e, desc) {
    const total = Object(_common__WEBPACK_IMPORTED_MODULE_8__["evaluationStackCount"])(e);
    if (total < 1) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_UNDER_STACK_LEN"]();
    }
    const index = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekBigInteger"])(e);
    const count = index.add(big_integer__WEBPACK_IMPORTED_MODULE_0__(2));
    if (index.isNegative() || count.compare(big_integer__WEBPACK_IMPORTED_MODULE_0__(total)) > 0) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
}
function validateXDrop(e) {
    return validateOpStack(e, '[validateXDrop]');
}
function validateXSwap(e) {
    return validateOpStack(e, '[validateXSwap]');
}
function validateXTuck(e) {
    return validateOpStack(e, '[validateXTuck]');
}
function validatePick(e) {
    return validateOpStack(e, '[validatePick]');
}
function validateRoll(e) {
    return validateOpStack(e, '[validateRoll]');
}
function validateCat(e) {
    logStackTrace(e, 2, '[validateCat]');
    const p0 = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNByteArray"])(0, e);
    const p1 = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNByteArray"])(1, e);
    const l = p0.length + p1.length;
    if (l > _consts__WEBPACK_IMPORTED_MODULE_2__["MAX_BYTEARRAY_SIZE"]) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_MAX_ITEM_SIZE"]();
    }
}
function validateSubStr(e) {
    logStackTrace(e, 3, '[validateSubStr]');
    const count = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNBigInt"])(0, e);
    if (count.isNegative()) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
    const index = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNBigInt"])(1, e);
    if (index.isNegative()) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
    const arr = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNByteArray"])(2, e);
    const temp = index.add(count);
    if (big_integer__WEBPACK_IMPORTED_MODULE_0__(arr.length).compare(temp) < 0) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_MAX_ARRAY_SIZE"]();
    }
}
function validateLeft(e) {
    logStackTrace(e, 2, '[validateLeft]');
    const count = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNBigInt"])(0, e);
    if (count.isNegative()) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
    const arr = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNByteArray"])(1, e);
    if (big_integer__WEBPACK_IMPORTED_MODULE_0__(arr.length).compare(count) < 0) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_MAX_ARRAY_SIZE"]();
    }
}
function validateRight(e) {
    logStackTrace(e, 2, '[validateRight]');
    const count = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNBigInt"])(0, e);
    if (count.isNegative()) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
    const arr = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNByteArray"])(1, e);
    if (big_integer__WEBPACK_IMPORTED_MODULE_0__(arr.length).compare(count) < 0) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_MAX_ARRAY_SIZE"]();
    }
}
function validateInc(e) {
    logStackTrace(e, 1, '[validateInc]');
    const x = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekBigInteger"])(e);
    if (!checkBigInteger(x) || !checkBigInteger(x.add(big_integer__WEBPACK_IMPORTED_MODULE_0__["one"]))) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
}
function validateDec(e) {
    logStackTrace(e, 1, '[validateDec]');
    const x = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekBigInteger"])(e);
    if (!checkBigInteger(x) || (x.isNegative() || x.isZero()) && !checkBigInteger(x.subtract(big_integer__WEBPACK_IMPORTED_MODULE_0__["one"]))) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
}
function validateSign(e) {
    logStackTrace(e, 1, '[validateSign]');
}
function validateAdd(e) {
    logStackTrace(e, 2, '[validateAdd]');
    const x2 = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekBigInteger"])(e);
    const x1 = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNBigInt"])(1, e);
    if (!checkBigInteger(x1) || !checkBigInteger(x2) || !checkBigInteger(x1.add(x2))) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
}
function validateSub(e) {
    logStackTrace(e, 2, '[validateSub]');
    const x2 = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekBigInteger"])(e);
    const x1 = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNBigInt"])(1, e);
    if (!checkBigInteger(x1) || !checkBigInteger(x2) || !checkBigInteger(x1.subtract(x2))) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_MAX_BIGINTEGER_SIZE"]();
    }
}
function validateMul(e) {
    logStackTrace(e, 2, '[validateMul]');
    const x2 = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekBigInteger"])(e);
    const x1 = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNBigInt"])(1, e);
    const lx2 = Object(_common_utils__WEBPACK_IMPORTED_MODULE_1__["bigIntToBytes"])(x2).length;
    const lx1 = Object(_common_utils__WEBPACK_IMPORTED_MODULE_1__["bigIntToBytes"])(x1).length;
    if (lx2 > _consts__WEBPACK_IMPORTED_MODULE_2__["MAX_SIZE_FOR_BIGINTEGER"] || lx1 > _consts__WEBPACK_IMPORTED_MODULE_2__["MAX_SIZE_FOR_BIGINTEGER"] || lx1 + lx2 > _consts__WEBPACK_IMPORTED_MODULE_2__["MAX_SIZE_FOR_BIGINTEGER"]) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_MAX_BIGINTEGER_SIZE"]();
    }
}
function validateDiv(e) {
    logStackTrace(e, 2, '[validateAdd]');
    const x2 = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekBigInteger"])(e);
    const x1 = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNBigInt"])(1, e);
    if (!checkBigInteger(x2) || !checkBigInteger(x1)) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_MAX_BIGINTEGER_SIZE"]();
    }
    if (x2.isZero()) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_DIV_MOD_BY_ZERO"]();
    }
}
function validateMod(e) {
    logStackTrace(e, 2, '[validateMod]');
    const x2 = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekBigInteger"])(e);
    const x1 = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNBigInt"])(1, e);
    if (!checkBigInteger(x2) || !checkBigInteger(x1)) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_MAX_BIGINTEGER_SIZE"]();
    }
    if (x2.isZero()) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_DIV_MOD_BY_ZERO"]();
    }
}
function validatePack(e) {
    logStackTrace(e, 1, '[validatePack]');
    const total = Object(_common__WEBPACK_IMPORTED_MODULE_8__["evaluationStackCount"])(e);
    const temp = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekBigInteger"])(e);
    let count = temp;
    if (count.isNegative()) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
    if (count.compare(big_integer__WEBPACK_IMPORTED_MODULE_0__(_consts__WEBPACK_IMPORTED_MODULE_2__["MAX_ARRAY_SIZE"])) > 0) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_MAX_ARRAY_SIZE"]();
    }
    count = count.add(big_integer__WEBPACK_IMPORTED_MODULE_0__["one"]);
    if (count.compare(big_integer__WEBPACK_IMPORTED_MODULE_0__(total)) > 0) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_STACK_LEN"]();
    }
}
function validateUnpack(e) {
    logStackTrace(e, 1, '[validateUnpack]');
    const item = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekStackItem"])(e);
    if (!Object(_types_array__WEBPACK_IMPORTED_MODULE_4__["isArrayType"])(item)) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_NOT_ARRAY"]();
    }
}
/**
 * TODO: check if peekNStackItem can throw error
 * @param e
 */
function validatePickItem(e) {
    logStackTrace(e, 2, '[validatePickItem]');
    const item = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNStackItem"])(1, e);
    if (item === null) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
    if (Object(_types_array__WEBPACK_IMPORTED_MODULE_4__["isArrayType"])(item) || Object(_types_struct__WEBPACK_IMPORTED_MODULE_7__["isStructType"])(item)) {
        const index = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekBigInteger"])(e);
        if (index.isNegative()) {
            throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
        }
        const arr = item.getArray();
        if (index.compare(big_integer__WEBPACK_IMPORTED_MODULE_0__(arr.length)) >= 0) {
            throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_MAX_ARRAY_SIZE"]();
        }
    } else if (Object(_types_map__WEBPACK_IMPORTED_MODULE_6__["isMapType"])(item)) {
        const key = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNStackItem"])(0, e);
        if (key == null) {
            throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
        }
        if (!key.isMapKey()) {
            throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_NOT_MAP_KEY"]();
        }
        if (item.tryGetValue(key) === undefined) {
            throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_MAP_NOT_EXIST"]();
        }
    } else {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_NOT_SUPPORT_TYPE"]();
    }
}
function validatorSetItem(e) {
    logStackTrace(e, 3, '[validatorSetItem]');
    const value = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNStackItem"])(0, e);
    if (value === undefined) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
    const item = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNStackItem"])(2, e);
    if (item === undefined) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
    if (Object(_types_array__WEBPACK_IMPORTED_MODULE_4__["isArrayType"])(item) || Object(_types_struct__WEBPACK_IMPORTED_MODULE_7__["isStructType"])(item)) {
        const index = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNBigInt"])(1, e);
        if (index.isNegative()) {
            throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
        }
        const arr = item.getArray();
        if (index.compare(big_integer__WEBPACK_IMPORTED_MODULE_0__(arr.length)) >= 0) {
            throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_MAX_ARRAY_SIZE"]();
        }
    } else if (Object(_types_map__WEBPACK_IMPORTED_MODULE_6__["isMapType"])(item)) {
        const key = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNStackItem"])(1, e);
        if (key === undefined) {
            throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
        }
        if (!key.isMapKey()) {
            throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_NOT_MAP_KEY"]();
        }
    } else {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_NOT_SUPPORT_TYPE"]();
    }
}
function validateNewArray(e) {
    logStackTrace(e, 1, '[validateNewArray]');
    const count = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekBigInteger"])(e);
    if (count.isNegative()) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
    if (count.compare(big_integer__WEBPACK_IMPORTED_MODULE_0__(_consts__WEBPACK_IMPORTED_MODULE_2__["MAX_ARRAY_SIZE"])) > 0) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_MAX_ARRAY_SIZE"]();
    }
}
function validateNewStruct(e) {
    logStackTrace(e, 1, '[validateNewStruct]');
    const count = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekBigInteger"])(e);
    if (count.isNegative()) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
    if (count.compare(big_integer__WEBPACK_IMPORTED_MODULE_0__(_consts__WEBPACK_IMPORTED_MODULE_2__["MAX_ARRAY_SIZE"])) > 0) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_OVER_MAX_ARRAY_SIZE"]();
    }
}
function validateAppend(e) {
    logStackTrace(e, 2, '[validateAppend]');
    const arrItem = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNStackItem"])(1, e);
    if (!Object(_types_array__WEBPACK_IMPORTED_MODULE_4__["isArrayType"])(arrItem) && !Object(_types_struct__WEBPACK_IMPORTED_MODULE_7__["isStructType"])(arrItem)) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_NOT_SUPPORT_TYPE"]();
    }
}
function validatorReverse(e) {
    logStackTrace(e, 1, '[validatorReverse]');
    const arrItem = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekStackItem"])(e);
    if (!Object(_types_array__WEBPACK_IMPORTED_MODULE_4__["isArrayType"])(arrItem) && !Object(_types_struct__WEBPACK_IMPORTED_MODULE_7__["isStructType"])(arrItem)) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_NOT_SUPPORT_TYPE"]();
    }
}
function validatorRemove(e) {
    logStackTrace(e, 2, '[validatorRemove]');
    const value = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNStackItem"])(0, e);
    if (value === undefined) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
    if (!value.isMapKey()) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_NOT_MAP_KEY"]();
    }
    const item = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNStackItem"])(1, e);
    if (item === undefined) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
    if (Object(_types_array__WEBPACK_IMPORTED_MODULE_4__["isArrayType"])(item) || Object(_types_struct__WEBPACK_IMPORTED_MODULE_7__["isStructType"])(item)) {
        if (!Object(_types_integer__WEBPACK_IMPORTED_MODULE_5__["isIntegerType"])(value)) {
            throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_TYPE"]();
        }
    } else if (!Object(_types_map__WEBPACK_IMPORTED_MODULE_6__["isMapType"])(item)) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_REMOVE_NOT_SUPPORT"]();
    }
}
function validatorHasKey(e) {
    const value = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNStackItem"])(0, e);
    if (value === undefined) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
    const item = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNStackItem"])(1, e);
    if (item === undefined) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
    if (Object(_types_map__WEBPACK_IMPORTED_MODULE_6__["isMapType"])(item)) {
        if (!value.isMapKey()) {
            throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_NOT_MAP_KEY"]();
        }
    } else if (!Object(_types_array__WEBPACK_IMPORTED_MODULE_4__["isArrayType"])(item) && !Object(_types_struct__WEBPACK_IMPORTED_MODULE_7__["isStructType"])(item)) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
}
function validatorKeys(e) {
    const item = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNStackItem"])(0, e);
    if (item === undefined) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
    if (!Object(_types_map__WEBPACK_IMPORTED_MODULE_6__["isMapType"])(item)) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
}
function validatorValues(e) {
    const item = Object(_common__WEBPACK_IMPORTED_MODULE_8__["peekNStackItem"])(0, e);
    if (item === undefined) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
    if (!Object(_types_map__WEBPACK_IMPORTED_MODULE_6__["isMapType"])(item) && !Object(_types_array__WEBPACK_IMPORTED_MODULE_4__["isArrayType"])(item) && !Object(_types_struct__WEBPACK_IMPORTED_MODULE_7__["isStructType"])(item)) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_BAD_VALUE"]();
    }
}
function validatorThrowIfNot(e) {
    logStackTrace(e, 1, '[validatorThrowIfNot]');
}
function checkBigInteger(value) {
    if (value === undefined) {
        return false;
    }
    if (Object(_common_utils__WEBPACK_IMPORTED_MODULE_1__["bigIntToBytes"])(value).length > _consts__WEBPACK_IMPORTED_MODULE_2__["MAX_SIZE_FOR_BIGINTEGER"]) {
        return false;
    }
    return true;
}
function logStackTrace(e, needStackCount, desc) {
    const stackCount = Object(_common__WEBPACK_IMPORTED_MODULE_8__["evaluationStackCount"])(e);
    if (stackCount < needStackCount) {
        throw _errors__WEBPACK_IMPORTED_MODULE_3__["ERR_UNDER_STACK_LEN"]();
    }
}

/***/ }),

/***/ "./src/vm/interfaces/engine.ts":
/*!*************************************!*\
  !*** ./src/vm/interfaces/engine.ts ***!
  \*************************************/
/*! exports provided: NONE, HALT, FAULT, BREAK, INSUFFICIENT_RESOURCE */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NONE", function() { return NONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HALT", function() { return HALT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FAULT", function() { return FAULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BREAK", function() { return BREAK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INSUFFICIENT_RESOURCE", function() { return INSUFFICIENT_RESOURCE; });
const NONE = 0;
const HALT = 1;
const FAULT = 2;
const BREAK = 4;
const INSUFFICIENT_RESOURCE = 8;

/***/ }),

/***/ "./src/vm/interfaces/interop.ts":
/*!**************************************!*\
  !*** ./src/vm/interfaces/interop.ts ***!
  \**************************************/
/*! exports provided: isInterop */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInterop", function() { return isInterop; });
function isInterop(item) {
    return item.toArray !== undefined;
}

/***/ }),

/***/ "./src/vm/opCode.ts":
/*!**************************!*\
  !*** ./src/vm/opCode.ts ***!
  \**************************/
/*! exports provided: PUSH0, PUSHF, PUSHBYTES1, PUSHBYTES75, PUSHDATA1, PUSHDATA2, PUSHDATA4, PUSHM1, PUSH1, PUSHT, PUSH2, PUSH3, PUSH4, PUSH5, PUSH6, PUSH7, PUSH8, PUSH9, PUSH10, PUSH11, PUSH12, PUSH13, PUSH14, PUSH15, PUSH16, NOP, JMP, JMPIF, JMPIFNOT, CALL, RET, APPCALL, SYSCALL, TAILCALL, DUPFROMALTSTACK, TOALTSTACK, FROMALTSTACK, XDROP, XSWAP, XTUCK, DEPTH, DROP, DUP, NIP, OVER, PICK, ROLL, ROT, SWAP, TUCK, CAT, SUBSTR, LEFT, RIGHT, SIZE, INVERT, AND, OR, XOR, EQUAL, INC, DEC, SIGN, NEGATE, ABS, NOT, NZ, ADD, SUB, MUL, DIV, MOD, SHL, SHR, BOOLAND, BOOLOR, NUMEQUAL, NUMNOTEQUAL, LT, GT, LTE, GTE, MIN, MAX, WITHIN, SHA1, SHA256, HASH160, HASH256, CHECKSIG, VERIFY, CHECKMULTISIG, ARRAYSIZE, PACK, UNPACK, PICKITEM, SETITEM, NEWARRAY, NEWSTRUCT, NEWMAP, APPEND, REVERSE, REMOVE, HASKEY, KEYS, VALUES, THROW, THROWIFNOT */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH0", function() { return PUSH0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSHF", function() { return PUSHF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSHBYTES1", function() { return PUSHBYTES1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSHBYTES75", function() { return PUSHBYTES75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSHDATA1", function() { return PUSHDATA1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSHDATA2", function() { return PUSHDATA2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSHDATA4", function() { return PUSHDATA4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSHM1", function() { return PUSHM1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH1", function() { return PUSH1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSHT", function() { return PUSHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH2", function() { return PUSH2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH3", function() { return PUSH3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH4", function() { return PUSH4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH5", function() { return PUSH5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH6", function() { return PUSH6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH7", function() { return PUSH7; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH8", function() { return PUSH8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH9", function() { return PUSH9; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH10", function() { return PUSH10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH11", function() { return PUSH11; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH12", function() { return PUSH12; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH13", function() { return PUSH13; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH14", function() { return PUSH14; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH15", function() { return PUSH15; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH16", function() { return PUSH16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NOP", function() { return NOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JMP", function() { return JMP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JMPIF", function() { return JMPIF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JMPIFNOT", function() { return JMPIFNOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALL", function() { return CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RET", function() { return RET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APPCALL", function() { return APPCALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYSCALL", function() { return SYSCALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAILCALL", function() { return TAILCALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DUPFROMALTSTACK", function() { return DUPFROMALTSTACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOALTSTACK", function() { return TOALTSTACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FROMALTSTACK", function() { return FROMALTSTACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XDROP", function() { return XDROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XSWAP", function() { return XSWAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XTUCK", function() { return XTUCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEPTH", function() { return DEPTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DROP", function() { return DROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DUP", function() { return DUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NIP", function() { return NIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OVER", function() { return OVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PICK", function() { return PICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ROLL", function() { return ROLL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ROT", function() { return ROT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SWAP", function() { return SWAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TUCK", function() { return TUCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAT", function() { return CAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBSTR", function() { return SUBSTR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LEFT", function() { return LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RIGHT", function() { return RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIZE", function() { return SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INVERT", function() { return INVERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AND", function() { return AND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OR", function() { return OR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XOR", function() { return XOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EQUAL", function() { return EQUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INC", function() { return INC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEC", function() { return DEC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGN", function() { return SIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NEGATE", function() { return NEGATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ABS", function() { return ABS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NOT", function() { return NOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NZ", function() { return NZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD", function() { return ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUB", function() { return SUB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MUL", function() { return MUL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIV", function() { return DIV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOD", function() { return MOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHL", function() { return SHL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHR", function() { return SHR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOLAND", function() { return BOOLAND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOLOR", function() { return BOOLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMEQUAL", function() { return NUMEQUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMNOTEQUAL", function() { return NUMNOTEQUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LT", function() { return LT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GT", function() { return GT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LTE", function() { return LTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GTE", function() { return GTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIN", function() { return MIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX", function() { return MAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WITHIN", function() { return WITHIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHA1", function() { return SHA1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHA256", function() { return SHA256; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HASH160", function() { return HASH160; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HASH256", function() { return HASH256; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHECKSIG", function() { return CHECKSIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERIFY", function() { return VERIFY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHECKMULTISIG", function() { return CHECKMULTISIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAYSIZE", function() { return ARRAYSIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PACK", function() { return PACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNPACK", function() { return UNPACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PICKITEM", function() { return PICKITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SETITEM", function() { return SETITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NEWARRAY", function() { return NEWARRAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NEWSTRUCT", function() { return NEWSTRUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NEWMAP", function() { return NEWMAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APPEND", function() { return APPEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REVERSE", function() { return REVERSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE", function() { return REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HASKEY", function() { return HASKEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KEYS", function() { return KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VALUES", function() { return VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THROW", function() { return THROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THROWIFNOT", function() { return THROWIFNOT; });
const PUSH0 = 0x00; // An empty array of bytes is pushed onto the stack.
const PUSHF = PUSH0;
const PUSHBYTES1 = 0x01; // 0x01-0x4B The next bytes is data to be pushed onto the stack
const PUSHBYTES75 = 0x4b;
const PUSHDATA1 = 0x4c; // The next byte contains the number of bytes to be pushed onto the stack.
const PUSHDATA2 = 0x4d; // The next two bytes contain the number of bytes to be pushed onto the stack.
const PUSHDATA4 = 0x4e; // The next four bytes contain the number of bytes to be pushed onto the stack.
const PUSHM1 = 0x4f; // The number -1 is pushed onto the stack.
const PUSH1 = 0x51; // The number 1 is pushed onto the stack.
const PUSHT = PUSH1;
const PUSH2 = 0x52; // The number 2 is pushed onto the stack.
const PUSH3 = 0x53; // The number 3 is pushed onto the stack.
const PUSH4 = 0x54; // The number 4 is pushed onto the stack.
const PUSH5 = 0x55; // The number 5 is pushed onto the stack.
const PUSH6 = 0x56; // The number 6 is pushed onto the stack.
const PUSH7 = 0x57; // The number 7 is pushed onto the stack.
const PUSH8 = 0x58; // The number 8 is pushed onto the stack.
const PUSH9 = 0x59; // The number 9 is pushed onto the stack.
const PUSH10 = 0x5a; // The number 10 is pushed onto the stack.
const PUSH11 = 0x5b; // The number 11 is pushed onto the stack.
const PUSH12 = 0x5c; // The number 12 is pushed onto the stack.
const PUSH13 = 0x5d; // The number 13 is pushed onto the stack.
const PUSH14 = 0x5e; // The number 14 is pushed onto the stack.
const PUSH15 = 0x5f; // The number 15 is pushed onto the stack.
const PUSH16 = 0x60; // The number 16 is pushed onto the stack.
// Flow control
const NOP = 0x61; // Does nothing.
const JMP = 0x62;
const JMPIF = 0x63;
const JMPIFNOT = 0x64;
const CALL = 0x65;
const RET = 0x66;
const APPCALL = 0x67;
const SYSCALL = 0x68;
const TAILCALL = 0x69;
const DUPFROMALTSTACK = 0x6a;
// Stack
const TOALTSTACK = 0x6b; // Puts the input onto the top of the alt stack. Removes it from the main stack.
const FROMALTSTACK = 0x6c; // Puts the input onto the top of the main stack. Removes it from the alt stack.
const XDROP = 0x6d;
const XSWAP = 0x72;
const XTUCK = 0x73;
const DEPTH = 0x74; // Puts the number of stack items onto the stack.
const DROP = 0x75; // Removes the top stack item.
const DUP = 0x76; // Duplicates the top stack item.
const NIP = 0x77; // Removes the second-to-top stack item.
const OVER = 0x78; // Copies the second-to-top stack item to the top.
const PICK = 0x79; // The item n back in the stack is copied to the top.
const ROLL = 0x7a; // The item n back in the stack is moved to the top.
const ROT = 0x7b; // The top three items on the stack are rotated to the left.
const SWAP = 0x7c; // The top two items on the stack are swapped.
const TUCK = 0x7d; // The item at the top of the stack is copied and inserted before the second-to-top item.
// Splice
const CAT = 0x7e; // Concatenates two strings.
const SUBSTR = 0x7f; // Returns a section of a string.
const LEFT = 0x80; // Keeps only characters left of the specified point in a string.
const RIGHT = 0x81; // Keeps only characters right of the specified point in a string.
const SIZE = 0x82; // Returns the length of the input string.
// Bitwise logic
const INVERT = 0x83; // Flips all of the bits in the input.
const AND = 0x84; // Boolean and between each bit in the inputs.
const OR = 0x85; // Boolean or between each bit in the inputs.
const XOR = 0x86; // Boolean exclusive or between each bit in the inputs.
const EQUAL = 0x87; // Returns 1 if the inputs are exactly equal, 0 otherwise.
// export const EQUALVERIFY = 0x88; // Same as EQUAL, but runs VERIFY afterward.
// export const RESERVED1 = 0x89; // Transaction is invalid unless occuring in an unexecuted IF branch
// export const RESERVED2 = 0x8A; // Transaction is invalid unless occuring in an unexecuted IF branch
// Arithmetic
// Note: Arithmetic inputs are limited to signed 32-bit integers, but may overflow their output.
const INC = 0x8b; // 1 is added to the input.
const DEC = 0x8c; // 1 is subtracted from the input.
const SIGN = 0x8d;
// export const SAL           = 0x8D; // The input is multiplied by 2.
// export const SAR           = 0x8E; // The input is divided by 2.
const NEGATE = 0x8f; // The sign of the input is flipped.
const ABS = 0x90; // The input is made positive.
const NOT = 0x91; // If the input is 0 or 1, it is flipped. Otherwise the output will be 0.
const NZ = 0x92; // Returns 0 if the input is 0. 1 otherwise.
const ADD = 0x93; // a is added to b.
const SUB = 0x94; // b is subtracted from a.
const MUL = 0x95; // a is multiplied by b.
const DIV = 0x96; // a is divided by b.
const MOD = 0x97; // Returns the remainder after dividing a by b.
const SHL = 0x98; // Shifts a left b bits, preserving sign.
const SHR = 0x99; // Shifts a right b bits, preserving sign.
const BOOLAND = 0x9a; // If both a and b are not 0, the output is 1. Otherwise 0.
const BOOLOR = 0x9b; // If a or b is not 0, the output is 1. Otherwise 0.
const NUMEQUAL = 0x9c; // Returns 1 if the numbers are equal, 0 otherwise.
const NUMNOTEQUAL = 0x9e; // Returns 1 if the numbers are not equal, 0 otherwise.
const LT = 0x9f; // Returns 1 if a is less than b, 0 otherwise.
const GT = 0xa0; // Returns 1 if a is greater than b, 0 otherwise.
const LTE = 0xa1; // Returns 1 if a is less than or equal to b, 0 otherwise.
const GTE = 0xa2; // Returns 1 if a is greater than or equal to b, 0 otherwise.
const MIN = 0xa3; // Returns the smaller of a and b.
const MAX = 0xa4; // Returns the larger of a and b.
const WITHIN = 0xa5; // Returns 1 if x is within the specified range (left-inclusive), 0 otherwise.
// Crypto
// export const RIPEMD160 = 0xA6; // The input is hashed using RIPEMD-160.
const SHA1 = 0xa7; // The input is hashed using SHA-1.
const SHA256 = 0xa8; // The input is hashed using SHA-256.
const HASH160 = 0xa9;
const HASH256 = 0xaa;
// tslint:disable-next-line:max-line-length
const CHECKSIG = 0xac; // The entire transaction's outputs inputs and script (from the most recently-executed CODESEPARATOR to the end) are hashed. The signature used by CHECKSIG must be a valid signature for this hash and public key. If it is 1 is returned 0 otherwise.
const VERIFY = 0xad;
// tslint:disable-next-line:max-line-length
const CHECKMULTISIG = 0xae; // For each signature and public key pair CHECKSIG is executed. If more public keys than signatures are listed some key/sig pairs can fail. All signatures need to match a public key. If all signatures are valid 1 is returned 0 otherwise. Due to a bug one extra unused value is removed from the stack.
// Array
// tslint:disable:indent
const ARRAYSIZE = 0xc0;
const PACK = 0xc1;
const UNPACK = 0xc2;
const PICKITEM = 0xc3;
const SETITEM = 0xc4;
const NEWARRAY = 0xc5;
const NEWSTRUCT = 0xc6;
const NEWMAP = 0xc7;
const APPEND = 0xc8;
const REVERSE = 0xc9;
const REMOVE = 0xca;
const HASKEY = 0xcb;
const KEYS = 0xcc;
const VALUES = 0xcd;
// Exception
const THROW = 0xf0;
const THROWIFNOT = 0xf1;

/***/ }),

/***/ "./src/vm/opExec.ts":
/*!**************************!*\
  !*** ./src/vm/opExec.ts ***!
  \**************************/
/*! exports provided: OpExecList */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OpExecList", function() { return OpExecList; });
/* harmony import */ var _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./func/arithmetic */ "./src/vm/func/arithmetic.ts");
/* harmony import */ var _func_array__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./func/array */ "./src/vm/func/array.ts");
/* harmony import */ var _func_bitwise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./func/bitwise */ "./src/vm/func/bitwise.ts");
/* harmony import */ var _func_exceptions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./func/exceptions */ "./src/vm/func/exceptions.ts");
/* harmony import */ var _func_flowControl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./func/flowControl */ "./src/vm/func/flowControl.ts");
/* harmony import */ var _func_hash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./func/hash */ "./src/vm/func/hash.ts");
/* harmony import */ var _func_pushData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./func/pushData */ "./src/vm/func/pushData.ts");
/* harmony import */ var _func_splice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./func/splice */ "./src/vm/func/splice.ts");
/* harmony import */ var _func_stack__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./func/stack */ "./src/vm/func/stack.ts");
/* harmony import */ var _func_validate__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./func/validate */ "./src/vm/func/validate.ts");
/* harmony import */ var _opCode__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./opCode */ "./src/vm/opCode.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */











const OpExecList = new Map([
// control flow
[_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH0"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH0"], name: 'PUSH0', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSHBYTES1"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSHBYTES1"], name: 'PUSHBYTES1', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSHBYTES75"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSHBYTES75"], name: 'PUSHBYTES75', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSHDATA1"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSHDATA1"], name: 'PUSHDATA1', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSHDATA2"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSHDATA2"], name: 'PUSHDATA2', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSHDATA4"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSHDATA4"], name: 'PUSHDATA4', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validatorPushData4"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSHM1"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSHM1"], name: 'PUSHM1', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH1"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH1"], name: 'PUSH1', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH2"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH2"], name: 'PUSH2', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH3"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH3"], name: 'PUSH3', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH4"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH4"], name: 'PUSH4', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH5"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH5"], name: 'PUSH5', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH6"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH6"], name: 'PUSH6', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH7"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH7"], name: 'PUSH7', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH8"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH8"], name: 'PUSH8', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH9"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH9"], name: 'PUSH9', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH10"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH10"], name: 'PUSH10', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH11"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH11"], name: 'PUSH11', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH12"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH12"], name: 'PUSH12', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH13"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH13"], name: 'PUSH13', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH14"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH14"], name: 'PUSH14', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH15"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH15"], name: 'PUSH15', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH16"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PUSH16"], name: 'PUSH16', exec: _func_pushData__WEBPACK_IMPORTED_MODULE_6__["opPushData"] }],
// Control
[_opCode__WEBPACK_IMPORTED_MODULE_10__["NOP"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["NOP"], name: 'NOP', exec: _func_flowControl__WEBPACK_IMPORTED_MODULE_4__["opNop"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["JMP"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["JMP"], name: 'JMP', exec: _func_flowControl__WEBPACK_IMPORTED_MODULE_4__["opJmp"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["JMPIF"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["JMPIF"], name: 'JMPIF', exec: _func_flowControl__WEBPACK_IMPORTED_MODULE_4__["opJmp"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["JMPIFNOT"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["JMPIFNOT"], name: 'JMPIFNOT', exec: _func_flowControl__WEBPACK_IMPORTED_MODULE_4__["opJmp"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["CALL"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["CALL"], name: 'CALL', exec: _func_flowControl__WEBPACK_IMPORTED_MODULE_4__["opCall"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCall"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["RET"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["RET"], name: 'RET', exec: _func_flowControl__WEBPACK_IMPORTED_MODULE_4__["opRet"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["APPCALL"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["APPCALL"], name: 'APPCALL' }],
// [O.TAILCALL, {opCode: O.TAILCALL, name: 'TAILCALL', exec: opAppCall},
[_opCode__WEBPACK_IMPORTED_MODULE_10__["SYSCALL"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["SYSCALL"], name: 'SYSCALL' }],
// Stack ops
[_opCode__WEBPACK_IMPORTED_MODULE_10__["DUPFROMALTSTACK"], {
    opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["DUPFROMALTSTACK"],
    name: 'DUPFROMALTSTACK',
    exec: _func_stack__WEBPACK_IMPORTED_MODULE_8__["opToDupFromAltStack"],
    validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateAltStackCount1"]
}], [_opCode__WEBPACK_IMPORTED_MODULE_10__["TOALTSTACK"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["TOALTSTACK"], name: 'TOALTSTACK', exec: _func_stack__WEBPACK_IMPORTED_MODULE_8__["opToAltStack"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount1"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["FROMALTSTACK"], {
    opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["FROMALTSTACK"],
    name: 'FROMALTSTACK',
    exec: _func_stack__WEBPACK_IMPORTED_MODULE_8__["opFromAltStack"],
    validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateAltStackCount1"]
}], [_opCode__WEBPACK_IMPORTED_MODULE_10__["XDROP"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["XDROP"], name: 'XDROP', exec: _func_stack__WEBPACK_IMPORTED_MODULE_8__["opXDrop"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateXDrop"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["XSWAP"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["XSWAP"], name: 'XSWAP', exec: _func_stack__WEBPACK_IMPORTED_MODULE_8__["opXSwap"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateXSwap"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["XTUCK"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["XTUCK"], name: 'XTUCK', exec: _func_stack__WEBPACK_IMPORTED_MODULE_8__["opXTuck"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateXTuck"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["DEPTH"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["DEPTH"], name: 'DEPTH', exec: _func_stack__WEBPACK_IMPORTED_MODULE_8__["opDepth"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["DROP"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["DROP"], name: 'DROP', exec: _func_stack__WEBPACK_IMPORTED_MODULE_8__["opDrop"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount1"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["DUP"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["DUP"], name: 'DUP', exec: _func_stack__WEBPACK_IMPORTED_MODULE_8__["opDup"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount1"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["NIP"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["NIP"], name: 'NIP', exec: _func_stack__WEBPACK_IMPORTED_MODULE_8__["opNip"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["OVER"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["OVER"], name: 'OVER', exec: _func_stack__WEBPACK_IMPORTED_MODULE_8__["opOver"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PICK"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PICK"], name: 'PICK', exec: _func_stack__WEBPACK_IMPORTED_MODULE_8__["opPick"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validatePick"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["ROLL"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["ROLL"], name: 'ROLL', exec: _func_stack__WEBPACK_IMPORTED_MODULE_8__["opRoll"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateRoll"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["ROT"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["ROT"], name: 'ROT', exec: _func_stack__WEBPACK_IMPORTED_MODULE_8__["opRot"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount3"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["SWAP"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["SWAP"], name: 'SWAP', exec: _func_stack__WEBPACK_IMPORTED_MODULE_8__["opSwap"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["TUCK"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["TUCK"], name: 'TUCK', exec: _func_stack__WEBPACK_IMPORTED_MODULE_8__["opTuck"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }],
// Splice
[_opCode__WEBPACK_IMPORTED_MODULE_10__["CAT"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["CAT"], name: 'CAT', exec: _func_splice__WEBPACK_IMPORTED_MODULE_7__["opCat"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCat"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["SUBSTR"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["SUBSTR"], name: 'SUBSTR', exec: _func_splice__WEBPACK_IMPORTED_MODULE_7__["opSubStr"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateSubStr"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["LEFT"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["LEFT"], name: 'LEFT', exec: _func_splice__WEBPACK_IMPORTED_MODULE_7__["opLeft"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateLeft"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["RIGHT"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["RIGHT"], name: 'RIGHT', exec: _func_splice__WEBPACK_IMPORTED_MODULE_7__["opRight"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateRight"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["SIZE"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["SIZE"], name: 'SIZE', exec: _func_splice__WEBPACK_IMPORTED_MODULE_7__["opSize"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount1"] }],
// Bitwise logic
[_opCode__WEBPACK_IMPORTED_MODULE_10__["INVERT"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["INVERT"], name: 'INVERT', exec: _func_bitwise__WEBPACK_IMPORTED_MODULE_2__["opInvert"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount1"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["AND"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["AND"], name: 'AND', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntZip"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["OR"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["OR"], name: 'OR', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntZip"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["XOR"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["XOR"], name: 'XOR', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntZip"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["EQUAL"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["EQUAL"], name: 'EQUAL', exec: _func_bitwise__WEBPACK_IMPORTED_MODULE_2__["opEqual"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }],
// Arithmetic
[_opCode__WEBPACK_IMPORTED_MODULE_10__["INC"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["INC"], name: 'INC', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigInt"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateInc"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["DEC"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["DEC"], name: 'DEC', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigInt"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateDec"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["SIGN"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["SIGN"], name: 'SIGN', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opSign"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateSign"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["NEGATE"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["NEGATE"], name: 'NEGATE', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigInt"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount1"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["ABS"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["ABS"], name: 'ABS', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigInt"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount1"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["NOT"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["NOT"], name: 'NOT', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opNot"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount1"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["NZ"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["NZ"], name: 'NZ', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opNz"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount1"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["ADD"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["ADD"], name: 'ADD', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntZip"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateAdd"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["SUB"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["SUB"], name: 'SUB', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntZip"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateSub"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["MUL"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["MUL"], name: 'MUL', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntZip"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateMul"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["DIV"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["DIV"], name: 'DIV', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntZip"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateDiv"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["MOD"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["MOD"], name: 'MOD', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntZip"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateMod"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["SHL"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["SHL"], name: 'SHL', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntZip"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateShiftLeft"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["SHR"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["SHR"], name: 'SHR', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntZip"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateShift"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["BOOLAND"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["BOOLAND"], name: 'BOOLAND', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBoolZip"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["BOOLOR"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["BOOLOR"], name: 'BOOLOR', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBoolZip"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["NUMEQUAL"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["NUMEQUAL"], name: 'NUMEQUAL', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntComp"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["NUMNOTEQUAL"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["NUMNOTEQUAL"], name: 'NUMNOTEQUAL', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntComp"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["LT"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["LT"], name: 'LT', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntComp"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["GT"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["GT"], name: 'GT', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntComp"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["LTE"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["LTE"], name: 'LTE', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntComp"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["GTE"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["GTE"], name: 'GTE', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntComp"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["MIN"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["MIN"], name: 'MIN', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntZip"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["MAX"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["MAX"], name: 'MAX', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opBigIntZip"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount2"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["WITHIN"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["WITHIN"], name: 'WITHIN', exec: _func_arithmetic__WEBPACK_IMPORTED_MODULE_0__["opWithIn"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount3"] }],
// Crypto
[_opCode__WEBPACK_IMPORTED_MODULE_10__["SHA1"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["SHA1"], name: 'SHA1', exec: _func_hash__WEBPACK_IMPORTED_MODULE_5__["opHash"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount1"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["SHA256"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["SHA256"], name: 'SHA256', exec: _func_hash__WEBPACK_IMPORTED_MODULE_5__["opHash"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount1"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["HASH160"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["HASH160"], name: 'HASH160', exec: _func_hash__WEBPACK_IMPORTED_MODULE_5__["opHash"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount1"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["HASH256"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["HASH256"], name: 'HASH256', exec: _func_hash__WEBPACK_IMPORTED_MODULE_5__["opHash"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount1"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["VERIFY"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["VERIFY"], name: 'VERIFY' }],
// [O.CHECKSIG,      {opCode: O.CHECKSIG, name: 'CHECKSIG', exec: opCheckSig, validator: validateCount2},
// tslint:disable-next-line:max-line-length
// [O.CHECKMULTISIG, {opCode: O.CHECKMULTISIG, name: 'CHECKMULTISIG', exec: opCheckMultiSig, validator: validateCount2},
// Array
[_opCode__WEBPACK_IMPORTED_MODULE_10__["ARRAYSIZE"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["ARRAYSIZE"], name: 'ARRAYSIZE', exec: _func_array__WEBPACK_IMPORTED_MODULE_1__["opArraySize"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateCount1"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PACK"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PACK"], name: 'PACK', exec: _func_array__WEBPACK_IMPORTED_MODULE_1__["opPack"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validatePack"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["UNPACK"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["UNPACK"], name: 'UNPACK', exec: _func_array__WEBPACK_IMPORTED_MODULE_1__["opUnpack"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateUnpack"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["PICKITEM"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["PICKITEM"], name: 'PICKITEM', exec: _func_array__WEBPACK_IMPORTED_MODULE_1__["opPickItem"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validatePickItem"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["SETITEM"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["SETITEM"], name: 'SETITEM', exec: _func_array__WEBPACK_IMPORTED_MODULE_1__["opSetItem"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validatorSetItem"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["NEWARRAY"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["NEWARRAY"], name: 'NEWARRAY', exec: _func_array__WEBPACK_IMPORTED_MODULE_1__["opNewArray"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateNewArray"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["NEWMAP"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["NEWMAP"], name: 'NEWMAP', exec: _func_array__WEBPACK_IMPORTED_MODULE_1__["opNewMap"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["NEWSTRUCT"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["NEWSTRUCT"], name: 'NEWSTRUCT', exec: _func_array__WEBPACK_IMPORTED_MODULE_1__["opNewStruct"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateNewStruct"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["APPEND"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["APPEND"], name: 'APPEND', exec: _func_array__WEBPACK_IMPORTED_MODULE_1__["opAppend"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validateAppend"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["REVERSE"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["REVERSE"], name: 'REVERSE', exec: _func_array__WEBPACK_IMPORTED_MODULE_1__["opReverse"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validatorReverse"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["REMOVE"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["REMOVE"], name: 'REMOVE', exec: _func_array__WEBPACK_IMPORTED_MODULE_1__["opRemove"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validatorRemove"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["HASKEY"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["HASKEY"], name: 'HASKEY', exec: _func_array__WEBPACK_IMPORTED_MODULE_1__["opHasKey"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validatorHasKey"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["KEYS"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["KEYS"], name: 'KEYS', exec: _func_array__WEBPACK_IMPORTED_MODULE_1__["opKeys"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validatorKeys"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["VALUES"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["VALUES"], name: 'VALUES', exec: _func_array__WEBPACK_IMPORTED_MODULE_1__["opValues"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validatorValues"] }],
// Exceptions
[_opCode__WEBPACK_IMPORTED_MODULE_10__["THROW"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["THROW"], name: 'THROW', exec: _func_exceptions__WEBPACK_IMPORTED_MODULE_3__["opThrow"] }], [_opCode__WEBPACK_IMPORTED_MODULE_10__["THROWIFNOT"], { opCode: _opCode__WEBPACK_IMPORTED_MODULE_10__["THROWIFNOT"], name: 'THROWIFNOT', exec: _func_exceptions__WEBPACK_IMPORTED_MODULE_3__["opThrowIfNot"], validator: _func_validate__WEBPACK_IMPORTED_MODULE_9__["validatorThrowIfNot"] }]]);

/***/ }),

/***/ "./src/vm/types/array.ts":
/*!*******************************!*\
  !*** ./src/vm/types/array.ts ***!
  \*******************************/
/*! exports provided: ArrayType, isArrayType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrayType", function() { return ArrayType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArrayType", function() { return isArrayType; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");

class ArrayType {
    constructor(value = []) {
        this.value = value;
        this.type = 'ArrayType';
    }
    equals(other) {
        return this === other;
    }
    getBigInteger() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support array to integer');
    }
    getBoolean() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support array to boolean');
    }
    getByteArray() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support array to byte array');
    }
    getInterface() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support array to interface');
    }
    getArray() {
        return this.value;
    }
    getStruct() {
        return this.value;
    }
    getMap() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support array to map');
    }
    isMapKey() {
        return false;
    }
    add(item) {
        this.value.push(item);
    }
    removeAt(index) {
        this.value.splice(index, 1);
    }
    count() {
        return this.value.length;
    }
    contains(item) {
        for (const val of this.value) {
            if (val.equals(item)) {
                return true;
            }
        }
        return false;
    }
    toString() {
        const children = this.value.map(child => child.toString());
        const childrenString = children.join(', ');
        return `Array([${childrenString}])`;
    }
    getEncodedValue() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Unsupported');
    }
    setEncodedValue(value) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Unsupported');
    }
    getType() {
        return this.type;
    }
}
ArrayType.id = 0x80;
function isArrayType(item) {
    return item.type === 'ArrayType';
}

/***/ }),

/***/ "./src/vm/types/boolean.ts":
/*!*********************************!*\
  !*** ./src/vm/types/boolean.ts ***!
  \*********************************/
/*! exports provided: BooleanType, isBooleanType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BooleanType", function() { return BooleanType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBooleanType", function() { return isBooleanType; });
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! big-integer */ "big-integer");
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(big_integer__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */


class BooleanType {
    constructor(value) {
        this.value = value;
        this.type = 'BooleanType';
    }
    equals(other) {
        if (this === other) {
            return true;
        }
        try {
            const b = other.getByteArray();
            const tb = this.getByteArray();
            return tb.equals(b);
        } catch (e) {
            return false;
        }
    }
    getBigInteger() {
        return this.value ? big_integer__WEBPACK_IMPORTED_MODULE_0__["one"] : big_integer__WEBPACK_IMPORTED_MODULE_0__["zero"];
    }
    getBoolean() {
        return this.value;
    }
    getByteArray() {
        const buffer = new Uint8Array(1);
        buffer.set([Number(this.value)]);
        return new Buffer(buffer);
    }
    getInterface() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('Not support boolean to interface');
    }
    getArray() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('Not support boolean to array');
    }
    getStruct() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('Not support boolean to struct');
    }
    getMap() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('Not support boolean to map');
    }
    isMapKey() {
        return true;
    }
    toString() {
        return `Boolean(${String(this.value)})`;
    }
    getEncodedValue() {
        return String(this.value);
    }
    setEncodedValue(value) {
        this.value = Boolean(value);
    }
    getType() {
        return this.type;
    }
}
BooleanType.id = 0x01;
function isBooleanType(item) {
    return item.type === 'BooleanType';
}

/***/ }),

/***/ "./src/vm/types/byteArray.ts":
/*!***********************************!*\
  !*** ./src/vm/types/byteArray.ts ***!
  \***********************************/
/*! exports provided: ByteArrayType, isByteArrayType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ByteArrayType", function() { return ByteArrayType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isByteArrayType", function() { return isByteArrayType; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../common/utils */ "./src/common/utils.ts");


class ByteArrayType {
    constructor(value = new Buffer(0)) {
        this.value = value;
        this.type = 'ByteArrayType';
    }
    equals(other) {
        if (this === other) {
            return true;
        }
        try {
            const a1 = this.value;
            const a2 = other.getByteArray();
            return a1.equals(a2);
        } catch (e) {
            return false;
        }
    }
    getBigInteger() {
        return Object(_common_utils__WEBPACK_IMPORTED_MODULE_1__["bigIntFromBytes"])(this.value);
    }
    getBoolean() {
        return this.value.reduce((previous, current) => previous || current !== 0, false);
    }
    getByteArray() {
        return this.value;
    }
    getInterface() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support byte array to interface');
    }
    getArray() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support byte array to array');
    }
    getStruct() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support byte array to struct');
    }
    getMap() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support byte array to map');
    }
    isMapKey() {
        return true;
    }
    toString() {
        return `ByteArray(0x${this.value.toString('hex')})`;
    }
    getEncodedValue() {
        return this.value.toString('hex');
    }
    setEncodedValue(value) {
        this.value = new Buffer(value, 'hex');
    }
    getType() {
        return this.type;
    }
}
ByteArrayType.id = 0x00;
function isByteArrayType(item) {
    return item.type === 'ByteArrayType';
}

/***/ }),

/***/ "./src/vm/types/integer.ts":
/*!*********************************!*\
  !*** ./src/vm/types/integer.ts ***!
  \*********************************/
/*! exports provided: IntegerType, isIntegerType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntegerType", function() { return IntegerType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIntegerType", function() { return isIntegerType; });
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! big-integer */ "big-integer");
/* harmony import */ var big_integer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(big_integer__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../common/utils */ "./src/common/utils.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */



class IntegerType {
    constructor(value) {
        this.value = value;
        this.type = 'IntegerType';
    }
    equals(other) {
        if (this === other) {
            return true;
        }
        if (other === undefined) {
            return false;
        }
        try {
            const v = other.getBigInteger();
            return this.value.eq(v);
        } catch (e) {
            const b = other.getByteArray();
            const tb = this.getByteArray();
            return b.equals(tb);
        }
    }
    getBigInteger() {
        return this.value;
    }
    getBoolean() {
        return this.value.neq(big_integer__WEBPACK_IMPORTED_MODULE_0__["zero"]);
    }
    getByteArray() {
        return Object(_common_utils__WEBPACK_IMPORTED_MODULE_2__["bigIntToBytes"])(this.value);
    }
    getInterface() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('Not support integer to interface');
    }
    getArray() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('Not support integer to array');
    }
    getStruct() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('Not support integer to struct');
    }
    getMap() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_1__["TracedError"]('Not support integer to map');
    }
    isMapKey() {
        return true;
    }
    toString() {
        return `Integer(${this.value.toString()})`;
    }
    getEncodedValue() {
        return this.value.toString();
    }
    setEncodedValue(value) {
        this.value = big_integer__WEBPACK_IMPORTED_MODULE_0__(value);
    }
    getType() {
        return this.type;
    }
}
IntegerType.id = 0x02;
function isIntegerType(item) {
    return item.type === 'IntegerType';
}

/***/ }),

/***/ "./src/vm/types/interop.ts":
/*!*********************************!*\
  !*** ./src/vm/types/interop.ts ***!
  \*********************************/
/*! exports provided: InteropType, isInteropType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteropType", function() { return InteropType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInteropType", function() { return isInteropType; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");

class EmptyInterop {
    toArray() {
        return new Buffer(0);
    }
}
const EMPTY_INTEROP = new EmptyInterop();
class InteropType {
    constructor(value = EMPTY_INTEROP) {
        this.value = value;
        this.type = 'InteropType';
    }
    equals(other) {
        try {
            const v = other.getInterface();
            if (this.value === EMPTY_INTEROP || v === EMPTY_INTEROP) {
                return false;
            }
            if (!this.value.toArray().equals(v.toArray())) {
                return false;
            }
            return true;
        } catch (e) {
            return false;
        }
    }
    getBigInteger() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support interface to integer');
    }
    getBoolean() {
        return this.value !== undefined;
    }
    getByteArray() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support interface to byte array');
    }
    getInterface() {
        return this.value;
    }
    getArray() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support interface to array');
    }
    getStruct() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support interface to struct');
    }
    getMap() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support interface to map');
    }
    isMapKey() {
        return false;
    }
    toString() {
        return `Interop(${this.value.toArray().toString('hex')})`;
    }
    getEncodedValue() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Unsupported');
    }
    setEncodedValue(value) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Unsupported');
    }
    getType() {
        return this.type;
    }
}
InteropType.id = 0x40;
function isInteropType(item) {
    return item.type === 'InteropType';
}

/***/ }),

/***/ "./src/vm/types/map.ts":
/*!*****************************!*\
  !*** ./src/vm/types/map.ts ***!
  \*****************************/
/*! exports provided: MapType, isMapType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MapType", function() { return MapType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMapType", function() { return isMapType; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");

class MapType {
    constructor(value = new Map()) {
        this.value = value;
        this.type = 'MapType';
    }
    equals(other) {
        return this === other;
    }
    getBigInteger() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support map to integer');
    }
    getBoolean() {
        return true;
    }
    getByteArray() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support map to byte array');
    }
    getInterface() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support map to interface');
    }
    getArray() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support map to array');
    }
    getStruct() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support map to struct');
    }
    getMap() {
        return this.value;
    }
    isMapKey() {
        return false;
    }
    add(k, value) {
        for (const [key] of this.value) {
            if (key.equals(k)) {
                this.value.delete(key);
                break;
            }
        }
        this.value.set(k, value);
    }
    clear() {
        return this.value.clear();
    }
    remove(k) {
        for (const [key] of this.value) {
            if (key.equals(k)) {
                this.value.delete(key);
                break;
            }
        }
    }
    tryGetValue(k) {
        for (const [key, val] of this.value) {
            if (key.equals(k)) {
                return val;
            }
        }
    }
    toString() {
        const children = [];
        this.value.forEach((value, key) => {
            const child = `${key.toString()}: ${value.toString()}`;
            children.push(child);
        });
        const childrenString = children.join(', ');
        return `Map({${childrenString}})`;
    }
    getEncodedValue() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Unsupported');
    }
    setEncodedValue(value) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Unsupported');
    }
    getType() {
        return this.type;
    }
}
MapType.id = 0x82;
function isMapType(item) {
    return item.type === 'MapType';
}

/***/ }),

/***/ "./src/vm/types/stackItem.ts":
/*!***********************************!*\
  !*** ./src/vm/types/stackItem.ts ***!
  \***********************************/
/*! exports provided: isStackItemType, isStackItemArrayType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStackItemType", function() { return isStackItemType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStackItemArrayType", function() { return isStackItemArrayType; });
function isStackItemType(item) {
    return item.type !== undefined && item.equals !== undefined;
}
function isStackItemArrayType(array) {
    if (Array.isArray(array)) {
        return array.reduce((previous, current) => previous && isStackItemType(current), true);
    } else {
        return false;
    }
}

/***/ }),

/***/ "./src/vm/types/struct.ts":
/*!********************************!*\
  !*** ./src/vm/types/struct.ts ***!
  \********************************/
/*! exports provided: MAX_STRUCT_DEPTH, MAX_CLONE_LENGTH, StructType, isStructType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_STRUCT_DEPTH", function() { return MAX_STRUCT_DEPTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_CLONE_LENGTH", function() { return MAX_CLONE_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructType", function() { return StructType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStructType", function() { return isStructType; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");

const MAX_STRUCT_DEPTH = 10;
const MAX_CLONE_LENGTH = 1024;
class StructType {
    constructor(value = []) {
        this.value = value;
        this.type = 'StructType';
    }
    /**
     * TODO: check if implemented correctly
     * @param other
     */
    equals(other) {
        if (!(other instanceof StructType)) {
            return false;
        }
        if (other.value.length !== this.value.length) {
            return false;
        }
        for (let i = 0; i < this.value.length; i++) {
            if (!this.value[i].equals(other.value[i])) {
                return false;
            }
        }
        return true;
    }
    getBigInteger() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support struct to integer');
    }
    getBoolean() {
        return true;
    }
    getByteArray() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support struct to byte array');
    }
    getInterface() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support struct to interface');
    }
    getArray() {
        return this.value;
    }
    getStruct() {
        return this.value;
    }
    getMap() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Not support struct to map');
    }
    isMapKey() {
        return false;
    }
    add(item) {
        this.value.push(item);
    }
    removeAt(index) {
        this.value.splice(index, 1);
    }
    count() {
        return this.value.length;
    }
    contains(item) {
        for (const val of this.value) {
            if (val.equals(item)) {
                return true;
            }
        }
        return false;
    }
    clone() {
        return this.cloneInternal(0);
    }
    cloneInternal(length) {
        if (length > MAX_CLONE_LENGTH) {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('over max struct clone length');
        }
        const arr = [];
        for (const v of this.value) {
            length++;
            if (isStructType(v)) {
                const vc = v.cloneInternal(length);
                arr.push(vc);
            } else {
                arr.push(v);
            }
        }
        return new StructType(arr);
    }
    toString() {
        const children = this.value.map(child => child.toString());
        const childrenString = children.join(', ');
        return `Struct([${childrenString}])`;
    }
    getEncodedValue() {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Unsupported');
    }
    setEncodedValue(value) {
        throw new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"]('Unsupported');
    }
    getType() {
        return this.type;
    }
}
StructType.id = 0x81;
function isStructType(item) {
    return item.type === 'StructType';
}

/***/ }),

/***/ "./src/vm/utils/reader.ts":
/*!********************************!*\
  !*** ./src/vm/utils/reader.ts ***!
  \********************************/
/*! exports provided: Reader */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Reader", function() { return Reader; });
/* harmony import */ var bytebuffer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! bytebuffer */ "bytebuffer");
/* harmony import */ var bytebuffer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bytebuffer__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! long */ "long");
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(long__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../common/error */ "./src/common/error.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */



class Reader {
    constructor(b) {
        this.reader = bytebuffer__WEBPACK_IMPORTED_MODULE_0__["wrap"](b, 'utf-8', true);
    }
    readByte() {
        return this.reader.readUint8();
    }
    readBytes(count) {
        return new Buffer(this.reader.readBytes(count).toBuffer());
    }
    readUInt16() {
        return this.reader.readUint16();
    }
    readUInt32() {
        return this.reader.readUint32();
    }
    readUInt64() {
        return this.reader.readUint64();
    }
    readInt16() {
        return this.reader.readInt16();
    }
    readInt32() {
        return this.reader.readInt32();
    }
    readInt64() {
        return this.reader.readInt64();
    }
    position() {
        return this.reader.offset;
    }
    length() {
        return this.reader.limit;
    }
    seek(offset, whence) {
        if (whence === 'start') {
            const oldOffset = this.reader.offset;
            this.reader.offset = offset;
            return oldOffset;
        } else if (whence === 'relative') {
            const oldOffset = this.reader.offset;
            this.reader.offset = oldOffset + offset;
            return oldOffset;
        } else {
            throw new _common_error__WEBPACK_IMPORTED_MODULE_2__["TracedError"]('Unsupported Whence');
        }
    }
    readVarBytes(max) {
        const n = this.readVarUInt(max !== undefined ? long__WEBPACK_IMPORTED_MODULE_1__["fromNumber"](max) : undefined).toNumber();
        return this.readBytes(n);
    }
    readVarInt(max) {
        const fb = this.readByte();
        let value;
        switch (fb) {
            case 0xfd:
                value = long__WEBPACK_IMPORTED_MODULE_1__["fromNumber"](this.readUInt16());
                break;
            case 0xfe:
                value = long__WEBPACK_IMPORTED_MODULE_1__["fromNumber"](this.readUInt32());
                break;
            case 0xff:
                value = this.readUInt64();
                break;
            default:
                value = long__WEBPACK_IMPORTED_MODULE_1__["fromNumber"](fb);
        }
        if (max !== undefined && value.gt(max)) {
            return long__WEBPACK_IMPORTED_MODULE_1__["ZERO"];
        }
        return value;
    }
    readVarUInt(max) {
        const fb = this.readByte();
        let value;
        switch (fb) {
            case 0xfd:
                value = long__WEBPACK_IMPORTED_MODULE_1__["fromNumber"](this.readInt16());
                break;
            case 0xfe:
                value = long__WEBPACK_IMPORTED_MODULE_1__["fromNumber"](this.readInt32());
                break;
            case 0xff:
                value = this.readInt64();
                break;
            default:
                value = long__WEBPACK_IMPORTED_MODULE_1__["fromNumber"](fb);
        }
        if (max !== undefined && value.gt(max)) {
            return long__WEBPACK_IMPORTED_MODULE_1__["ZERO"];
        }
        return value;
    }
    readVarString(maxlen) {
        const bs = this.readVarBytes(maxlen);
        return bs.toString('utf-8');
    }
}

/***/ }),

/***/ "./src/vm/utils/stack.ts":
/*!*******************************!*\
  !*** ./src/vm/utils/stack.ts ***!
  \*******************************/
/*! exports provided: Stack */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Stack", function() { return Stack; });
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */
class Stack {
    constructor() {
        this.store = [];
    }
    count() {
        return this.store.length;
    }
    push(val) {
        this.store.push(val);
    }
    pop() {
        return this.store.pop();
    }
    /**
     * Peek returns the element (n) far in the stack beginning from
     * the top of the stack.
     * 	n = 0 => will return the element on top of the stack.
     */
    peek(n) {
        if (n >= this.store.length) {
            return undefined;
        }
        return this.store[this.store.length - n - 1];
    }
    /**
     * TODO: check if properly implemented.
     * @param index
     * @param t
     */
    insert(index, t) {
        if (t === undefined) {
            return;
        }
        if (index > this.store.length) {
            return;
        }
        index = this.store.length - index;
        this.store.splice(index, 0, t);
    }
    remove(index) {
        if (index >= this.store.length) {
            return undefined;
        }
        index = this.store.length - index;
        return this.store.splice(index - 1, 1)[0];
    }
    /**
     * Beware the index is from the end
     * @param index
     * @param t
     */
    set(index, t) {
        if (index >= this.store.length) {
            return;
        }
        this.store[index] = t;
    }
    swap(i, j) {
        const length = this.store.length;
        if (i >= length) {
            return;
        }
        if (j >= length) {
            return;
        }
        const temp = this.store[length - i - 1];
        this.store[length - i - 1] = this.store[length - j - 1];
        this.store[length - j - 1] = temp;
    }
    copyTo(stack) {
        stack.store = [...stack.store, ...this.store];
    }
}

/***/ }),

/***/ "./src/vm/utils/writer.ts":
/*!********************************!*\
  !*** ./src/vm/utils/writer.ts ***!
  \********************************/
/*! exports provided: Writer, LimitedWriter */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Writer", function() { return Writer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LimitedWriter", function() { return LimitedWriter; });
/* harmony import */ var bytebuffer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! bytebuffer */ "bytebuffer");
/* harmony import */ var bytebuffer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bytebuffer__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! long */ "long");
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(long__WEBPACK_IMPORTED_MODULE_1__);
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */


class Writer {
    constructor() {
        this.writer = new bytebuffer__WEBPACK_IMPORTED_MODULE_0__(undefined, true, true);
    }
    getBytes() {
        this.writer.mark();
        this.writer.flip();
        const buffer = new Buffer(this.writer.toBuffer());
        this.writer.reset();
        return buffer;
    }
    writeVarUint(value) {
        if (typeof value === 'number') {
            value = long__WEBPACK_IMPORTED_MODULE_1__["fromNumber"](value);
        }
        if (value.lt(0xfd)) {
            this.writer.writeUint8(value.toNumber());
        } else if (value.lte(0xffff)) {
            this.writer.writeUint8(0xfd);
            this.writer.writeUint16(value.toNumber());
        } else if (value.lte(0xffffffff)) {
            this.writer.writeUint8(0xfe);
            this.writer.writeUint32(value.toNumber());
        } else {
            this.writer.writeUint8(0xff);
            this.writer.writeUint64(value);
        }
    }
    writeVarBytes(value) {
        this.writeVarUint(value.length);
        this.writeBytes(value);
    }
    writeString(value) {
        return this.writeVarBytes(new Buffer(value, 'utf-8'));
    }
    writeBytes(value) {
        this.writer.append(value);
    }
    writeUint8(val) {
        this.writer.writeUint8(val);
    }
    writeUint16(val) {
        this.writer.writeUint16(val);
    }
    writeUint32(val) {
        this.writer.writeUint32(val);
    }
    writeUint64(val) {
        this.writer.writeUint64(val);
    }
    writeBool(val) {
        this.writeUint8(val ? 1 : 0);
    }
}
/**
 * TODO: might implement
 */
class LimitedWriter extends Writer {
    constructor(limit) {
        super();
        this.limit = limit;
    }
}

/***/ }),

/***/ "./src/vm/vmEngine.ts":
/*!****************************!*\
  !*** ./src/vm/vmEngine.ts ***!
  \****************************/
/*! exports provided: VMEngine */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VMEngine", function() { return VMEngine; });
/* harmony import */ var _common_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/error */ "./src/common/error.ts");
/* harmony import */ var _errors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./errors */ "./src/vm/errors.ts");
/* harmony import */ var _func_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./func/common */ "./src/vm/func/common.ts");
/* harmony import */ var _interfaces_engine__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./interfaces/engine */ "./src/vm/interfaces/engine.ts");
/* harmony import */ var _opCode__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./opCode */ "./src/vm/opCode.ts");
/* harmony import */ var _opExec__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./opExec */ "./src/vm/opExec.ts");
/* harmony import */ var _utils_stack__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./utils/stack */ "./src/vm/utils/stack.ts");
/*
 * Copyright (C) 2018 Matus Zamborsky & The ontology Authors
 * This file is part of The ontology library.
 *
 * The ontology is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The ontology is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
 */







class VMEngine {
    constructor() {
        this.contexts = [];
        this.evaluationStack = new _utils_stack__WEBPACK_IMPORTED_MODULE_6__["Stack"]();
        this.altStack = new _utils_stack__WEBPACK_IMPORTED_MODULE_6__["Stack"]();
        this.state = _interfaces_engine__WEBPACK_IMPORTED_MODULE_3__["BREAK"];
        this.opCode = 0;
    }
    getContext() {
        return this.context;
    }
    getContexts() {
        return this.contexts;
    }
    getOpCode() {
        return this.opCode;
    }
    getOpExec() {
        return this.opExec;
    }
    getState() {
        return this.state;
    }
    setOpCode(opCode) {
        this.opCode = opCode;
    }
    getEvaluationStack() {
        return this.evaluationStack;
    }
    getAltStack() {
        return this.altStack;
    }
    currentContext() {
        return this.contexts[this.contexts.length - 1];
    }
    popContext() {
        this.contexts.pop();
        if (this.contexts.length !== 0) {
            this.context = this.currentContext();
        } else {
            this.state = _interfaces_engine__WEBPACK_IMPORTED_MODULE_3__["NONE"];
        }
    }
    pushContext(context) {
        this.contexts.push(context);
        this.context = this.currentContext();
    }
    execute() {
        // tslint:disable-next-line:no-bitwise
        this.state = this.state & ~_interfaces_engine__WEBPACK_IMPORTED_MODULE_3__["BREAK"];
        while (true) {
            if (this.state === _interfaces_engine__WEBPACK_IMPORTED_MODULE_3__["FAULT"] || this.state === _interfaces_engine__WEBPACK_IMPORTED_MODULE_3__["HALT"] || this.state === _interfaces_engine__WEBPACK_IMPORTED_MODULE_3__["BREAK"]) {
                break;
            }
            const error = this.stepInto();
            if (error !== undefined) {
                return error;
            }
        }
    }
    executeCode() {
        const code = this.context.getReader().readByte();
        this.opCode = code;
    }
    validateOp() {
        const opExec = _opExec__WEBPACK_IMPORTED_MODULE_5__["OpExecList"].get(this.opCode);
        if (opExec === undefined) {
            throw _errors__WEBPACK_IMPORTED_MODULE_1__["ERR_NOT_SUPPORT_OPCODE"]();
        }
        this.opExec = opExec;
    }
    stepInto() {
        try {
            this.executeOp();
        } catch (e) {
            this.state = _interfaces_engine__WEBPACK_IMPORTED_MODULE_3__["FAULT"];
            if (e instanceof Error) {
                return e;
            } else {
                return new _common_error__WEBPACK_IMPORTED_MODULE_0__["TracedError"](e);
            }
        }
    }
    executeOp() {
        if (this.opCode >= _opCode__WEBPACK_IMPORTED_MODULE_4__["PUSHBYTES1"] && this.opCode <= _opCode__WEBPACK_IMPORTED_MODULE_4__["PUSHBYTES75"]) {
            Object(_func_common__WEBPACK_IMPORTED_MODULE_2__["pushData"])(this, this.context.getReader().readBytes(this.opCode));
            return;
        }
        if (this.opExec.validator !== undefined) {
            this.opExec.validator(this);
        }
        if (this.opExec.exec !== undefined) {
            this.opExec.exec(this);
        }
    }
}

/***/ }),

/***/ "big-integer":
/*!******************************!*\
  !*** external "big-integer" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("big-integer");

/***/ }),

/***/ "bs58":
/*!***********************!*\
  !*** external "bs58" ***!
  \***********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("bs58");

/***/ }),

/***/ "bytebuffer":
/*!*****************************!*\
  !*** external "bytebuffer" ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("bytebuffer");

/***/ }),

/***/ "crypto":
/*!*************************!*\
  !*** external "crypto" ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("crypto");

/***/ }),

/***/ "elliptic":
/*!***************************!*\
  !*** external "elliptic" ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("elliptic");

/***/ }),

/***/ "js-sha3":
/*!**************************!*\
  !*** external "js-sha3" ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("js-sha3");

/***/ }),

/***/ "long":
/*!***********************!*\
  !*** external "long" ***!
  \***********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("long");

/***/ })

/******/ });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ontology-ts-vm/lib/index.js
// module id = djsB
// module chunks = 16